// (function() {
//     'use strict';
//
//     // desiredOffset - page offset to scroll to
//     // speed - duration of the scroll per 1000px
//     function __ANIMATE_SCROLL_TO(desiredOffset) {
//         var userOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
//
//         var options = {
//             speed: 500,
//             minDuration: 250,
//             maxDuration: 1500,
//             cancelOnUserAction: true,
//             element: window,
//             horizontal: false,
//             onComplete: undefined,
//             passive: true,
//             offset: 0
//         };
//
//         var optionsKeys = Object.keys(options);
//
//         // Override default options
//         for (var i = 0; i < optionsKeys.length; i++) {
//             var key = optionsKeys[i];
//
//             if (typeof userOptions[key] !== 'undefined') {
//                 options[key] = userOptions[key];
//             }
//         }
//
//         if (!options.cancelOnUserAction && options.passive) {
//             options.passive = false;
//             if (userOptions.passive) {
//                 console && console.warn(
//                     'animated-scroll-to:\n "passive" was set to "false" to prevent errors, ' +
//                     'as using "cancelOnUserAction: false" doesn\'t work with passive events.')
//             }
//         }
//
//         if (desiredOffset instanceof HTMLElement) {
//             if (userOptions.element && userOptions.element instanceof HTMLElement) {
//                 if (options.horizontal) {
//                     desiredOffset = (desiredOffset.getBoundingClientRect().left + userOptions.element.scrollLeft)
//                         - userOptions.element.getBoundingClientRect().left;
//                 } else {
//                     desiredOffset = (desiredOffset.getBoundingClientRect().top + userOptions.element.scrollTop)
//                         - userOptions.element.getBoundingClientRect().top;
//                 }
//             } else if (options.horizontal) {
//                 var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
//                 desiredOffset = scrollLeft + desiredOffset.getBoundingClientRect().left;
//             } else {
//                 var scrollTop = window.scrollY || document.documentElement.scrollTop;
//                 desiredOffset = scrollTop + desiredOffset.getBoundingClientRect().top;
//             }
//         }
//
//         // Add additonal user offset
//         desiredOffset += options.offset
//
//         options.isWindow = options.element === window;
//
//         var initialScrollPosition = null;
//         var initialAxisScollPosition = 0;
//         var maxScroll = null;
//
//         if (options.isWindow) {
//             if (options.horizontal) {
//                 // get cross browser scroll positions
//                 initialScrollPosition = window.scrollX || document.documentElement.scrollLeft;
//                 initialAxisScollPosition = window.scrollY || document.documentElement.scrollTop;
//                 // cross browser document height minus window height
//                 maxScroll = Math.max(
//                     document.body.scrollWidth, document.documentElement.scrollWidth,
//                     document.body.offsetWidth, document.documentElement.offsetWidth,
//                     document.body.clientWidth, document.documentElement.clientWidth
//                 ) - window.innerWidth;
//             } else {
//                 // get cross browser scroll positions
//                 initialScrollPosition = window.scrollY || document.documentElement.scrollTop;
//                 initialAxisScollPosition = window.scrollX || document.documentElement.scrollLeft;
//                 // cross browser document width minus window width
//                 maxScroll = Math.max(
//                     document.body.scrollHeight, document.documentElement.scrollHeight,
//                     document.body.offsetHeight, document.documentElement.offsetHeight,
//                     document.body.clientHeight, document.documentElement.clientHeight
//                 ) - window.innerHeight;
//             }
//         } else {
//             // DOM element
//             if (options.horizontal) {
//                 initialScrollPosition = options.element.scrollLeft;
//                 maxScroll = options.element.scrollWidth - options.element.clientWidth;
//             } else {
//                 initialScrollPosition = options.element.scrollTop;
//                 maxScroll = options.element.scrollHeight - options.element.clientHeight;
//             }
//         }
//
//         // If the scroll position is greater than maximum available scroll
//         if (desiredOffset > maxScroll) {
//             desiredOffset = maxScroll;
//         }
//
//         // Calculate diff to scroll
//         var diff = desiredOffset - initialScrollPosition;
//
//         // Do nothing if the page is already there
//         if (diff === 0) {
//             // Execute callback if there is any
//             if (options.onComplete && typeof options.onComplete === 'function') {
//                 options.onComplete()
//             }
//
//             return;
//         }
//
//         // Calculate duration of the scroll
//         var duration = Math.abs(Math.round((diff / 1000) * options.speed));
//
//         // Set minimum and maximum duration
//         if (duration < options.minDuration) {
//             duration = options.minDuration;
//         } else if (duration > options.maxDuration) {
//             duration = options.maxDuration;
//         }
//
//         var startingTime = Date.now();
//
//         // Request animation frame ID
//         var requestID = null;
//
//         // Method handler
//         var handleUserEvent = null;
//         var userEventOptions = { passive: options.passive };
//
//         if (options.cancelOnUserAction) {
//             // Set handler to cancel scroll on user action
//             handleUserEvent = function() {
//                 removeListeners();
//                 cancelAnimationFrame(requestID);
//             };
//             window.addEventListener('keydown', handleUserEvent, userEventOptions);
//             window.addEventListener('mousedown', handleUserEvent, userEventOptions);
//         } else {
//             // Set handler to prevent user actions while scroll is active
//             handleUserEvent = function(e) { e.preventDefault(); };
//             window.addEventListener('scroll', handleUserEvent, userEventOptions);
//         }
//
//         window.addEventListener('wheel', handleUserEvent, userEventOptions);
//         window.addEventListener('touchstart', handleUserEvent, userEventOptions);
//
//         var removeListeners = function () {
//             window.removeEventListener('wheel', handleUserEvent, userEventOptions);
//             window.removeEventListener('touchstart', handleUserEvent, userEventOptions);
//
//             if (options.cancelOnUserAction) {
//                 window.removeEventListener('keydown', handleUserEvent, userEventOptions);
//                 window.removeEventListener('mousedown', handleUserEvent, userEventOptions);
//             } else {
//                 window.removeEventListener('scroll', handleUserEvent, userEventOptions);
//             }
//         };
//
//         var step = function () {
//             var timeDiff = Date.now() - startingTime;
//             var t = (timeDiff / duration) - 1;
//             var easing = t * t * t + 1;
//             var scrollPosition = Math.round(initialScrollPosition + (diff * easing));
//
//             var doScroll = function(position) {
//                 if (options.isWindow) {
//                     if (options.horizontal) {
//                         options.element.scrollTo(position, initialAxisScollPosition);
//                     } else {
//                         options.element.scrollTo(initialAxisScollPosition, position);
//                     }
//                 } else if (options.horizontal) {
//                     options.element.scrollLeft = position;
//                 } else {
//                     options.element.scrollTop = position;
//                 }
//             }
//
//             if (timeDiff < duration && scrollPosition !== desiredOffset) {
//                 // If scroll didn't reach desired offset or time is not elapsed
//                 // Scroll to a new position
//                 // And request a new step
//                 doScroll(scrollPosition);
//
//                 requestID = requestAnimationFrame(step);
//             } else {
//                 // If the time elapsed or we reached the desired offset
//                 // Set scroll to the desired offset (when rounding made it to be off a pixel or two)
//                 // Clear animation frame to be sure
//                 doScroll(desiredOffset);
//
//                 cancelAnimationFrame(requestID);
//
//                 // Remove listeners
//                 removeListeners();
//
//                 // Animation is complete, execute callback if there is any
//                 if (options.onComplete && typeof options.onComplete === 'function') {
//                     options.onComplete()
//                 }
//             }
//         };
//
//         // Start animating scroll
//         requestID = requestAnimationFrame(step);
//     }
//
//     if (typeof exports !== 'undefined') {
//         if (typeof module !== 'undefined' && module.exports) {
//             module.exports = __ANIMATE_SCROLL_TO;
//             exports = module.exports;
//         }
//         exports.default = __ANIMATE_SCROLL_TO;
//     } else if (window) {
//         window.animateScrollTo = __ANIMATE_SCROLL_TO;
//     }
// }).call(this);
function animateScrollTo(scrollTargetY, speed, easing, callback) {
  // scrollTargetY: the target scrollY property of the window
  // speed: time in pixels per second
  // easing: easing equation to use
  var scrollY = window.scrollY || document.documentElement.scrollTop,
      scrollTargetY = scrollTargetY || 0,
      speed = speed || 2000,
      easing = easing || 'easeOutSine',
      currentTime = 0; // min time .1, max time .8 seconds

  var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8)); // easing equations from https://github.com/danro/easing-js/blob/master/easing.js

  var easingEquations = {
    easeOutSine: function easeOutSine(pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function easeInOutSine(pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function easeInOutQuint(pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }

      return 0.5 * (Math.pow(pos - 2, 5) + 2);
    },
    easeInOutCirc: function easeInOutCirc(pos) {
      if ((pos /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - pos * pos) - 1);
      return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
    }
  }; // add animation loop

  function tick() {
    currentTime += 1 / 60;
    var p = currentTime / time;
    var t = easingEquations[easing](p);

    if (p < 1) {
      window.requestAnimationFrame(tick);
      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      console.log('scroll done');
      window.scrollTo(0, scrollTargetY);

      if (callback && typeof callback === 'function') {
        callback.apply();
      }
    }
  } // call it once to get started


  tick();
}
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.BadgerAccordion = e();
}(this, function () {
  "use strict";

  function t(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function e(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  function n(t, n, i) {
    return n && e(t.prototype, n), i && e(t, i), t;
  }

  function i() {
    return (i = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var i in n) {
          Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  return Array.from || (Array.from = function () {
    var t = Object.prototype.toString,
        e = function e(_e) {
      return "function" == typeof _e || "[object Function]" === t.call(_e);
    },
        n = function n(t) {
      var e = Number(t);
      return isNaN(e) ? 0 : 0 !== e && isFinite(e) ? (e > 0 ? 1 : -1) * Math.floor(Math.abs(e)) : e;
    },
        i = Math.pow(2, 53) - 1,
        s = function s(t) {
      var e = n(t);
      return Math.min(Math.max(e, 0), i);
    };

    return function (t) {
      var n = this,
          i = Object(t);
      if (null == t) throw new TypeError("Array.from requires an array-like object - not null or undefined");
      var a,
          r = arguments.length > 1 ? arguments[1] : void 0;

      if (void 0 !== r) {
        if (!e(r)) throw new TypeError("Array.from: when provided, the second argument must be a function");
        arguments.length > 2 && (a = arguments[2]);
      }

      for (var o, l = s(i.length), d = e(n) ? Object(new n(l)) : new Array(l), h = 0; h < l;) {
        o = i[h], d[h] = r ? void 0 === a ? r(o, h) : r.call(a, o, h) : o, h += 1;
      }

      return d.length = l, d;
    };
  }()), function (t, e) {
    var n = (t.body || t.documentElement).style,
        i = "",
        s = "";
    "" == n.WebkitAnimation && (i = "-webkit-"), "" == n.MozAnimation && (i = "-moz-"), "" == n.OAnimation && (i = "-o-"), "" == n.WebkitTransition && (s = "-webkit-"), "" == n.MozTransition && (s = "-moz-"), "" == n.OTransition && (s = "-o-"), Object.defineProperty(Object.prototype, "onCSSAnimationEnd", {
      value: function value(t) {
        var e = function e(n) {
          t(), n.target.removeEventListener(n.type, e);
        };

        return this.addEventListener("webkitAnimationEnd", e), this.addEventListener("mozAnimationEnd", e), this.addEventListener("oAnimationEnd", e), this.addEventListener("oanimationend", e), this.addEventListener("animationend", e), ("" != i || "animation" in n) && "0s" != getComputedStyle(this)[i + "animation-duration"] || t(), this;
      },
      enumerable: !1,
      writable: !0
    }), Object.defineProperty(Object.prototype, "onCSSTransitionEnd", {
      value: function value(t) {
        var e = function e(n) {
          t(), n.target.removeEventListener(n.type, e);
        };

        return this.addEventListener("webkitTransitionEnd", e), this.addEventListener("mozTransitionEnd", e), this.addEventListener("oTransitionEnd", e), this.addEventListener("transitionend", e), this.addEventListener("transitionend", e), ("" != s || "transition" in n) && "0s" != getComputedStyle(this)[s + "transition-duration"] || t(), this;
      },
      enumerable: !1,
      writable: !0
    });
  }(document, window), function () {
    function e(n, s) {
      t(this, e);
      var a = "string" == typeof n ? document.querySelector(n) : n;

      if (null != a) {
        var r = {
          headerClass: ".js-badger-accordion-header",
          panelClass: ".js-badger-accordion-panel",
          panelInnerClass: ".js-badger-accordion-panel-inner",
          hiddenClass: "-ba-is-hidden",
          activeClass: "-ba-is-active",

          get hidenClass() {
            return this.hiddenClass;
          },

          initializedClass: "badger-accordion--initialized",

          get initalisedClass() {
            return this.hiddenClass;
          },

          headerDataAttr: "data-badger-accordion-header-id",
          openMultiplePanels: !1,
          openHeadersOnLoad: [],
          headerOpenLabel: "Open accordion panel",
          headerCloseLabel: "Close accordion panel",
          roles: !0
        };
        this.settings = i({}, r, s), this.settings.hidenClass !== this.settings.hiddenClass && (this.settings.hiddenClass = this.settings.hidenClass), this.container = a, this.headers = Array.from(this.container.querySelectorAll(this.settings.headerClass)), this.panels = Array.from(this.container.querySelectorAll(this.settings.panelClass)), this.toggleEl = void 0 !== this.settings.toggleEl ? Array.from(this.container.querySelectorAll(this.settings.toggleEl)) : this.headers, this.states = [].map.call(this.headers, function () {
          return {
            state: "closed"
          };
        }), this.ids = [].map.call(this.headers, function () {
          return {
            id: Math.floor(1e6 * Math.random() + 1)
          };
        }), this.toggling = !1, this.container ? this.init() : console.log("Something is wrong with you markup...");
      }
    }

    return n(e, [{
      key: "init",
      value: function value() {
        this._setupAttributes(), this._initalState(), this.calculateAllPanelsHeight(), this._insertDataAttrs(), this._addListeners(), this._finishInitialization();
      }
    }, {
      key: "_setRole",
      value: function value(t, e) {
        ("boolean" == typeof this.settings.roles && this.settings.roles || void 0 !== this.settings.roles[t] && !1 !== this.settings.roles[t]) && e.setAttribute("role", t);
      }
    }, {
      key: "_initalState",
      value: function value() {
        var t = this.settings.openHeadersOnLoad;
        t.length && this._openHeadersOnLoad(t), this._renderDom();
      }
    }, {
      key: "_insertDataAttrs",
      value: function value() {
        var t = this;
        this.headers.forEach(function (e, n) {
          e.setAttribute(t.settings.headerDataAttr, n);
        });
      }
    }, {
      key: "_finishInitialization",
      value: function value() {
        this.container.classList.add(this.settings.initializedClass), this._setRole("presentation", this.container);
      }
    }, {
      key: "_addListeners",
      value: function value() {
        var t = this;
        this.headers.forEach(function (e, n) {
          e.addEventListener("click", function () {
            t.handleClick(e, n);
          });
        });
      }
    }, {
      key: "handleClick",
      value: function value(t, e) {
        var n = this.settings.headerClass.substr(1);
        t.classList.contains(n) && !1 === this.toggling && (this.toggling = !0, this.setState(e), this._renderDom());
      }
    }, {
      key: "setState",
      value: function value(t) {
        var e = this,
            n = this.getState();
        this.settings.openMultiplePanels || n.filter(function (e, n) {
          n != t && (e.state = "closed");
        }), n.filter(function (n, i) {
          if (i == t) {
            var s = e.toggleState(n.state);
            return n.state = s;
          }
        });
      }
    }, {
      key: "_renderDom",
      value: function value() {
        var t = this;
        this.states.filter(function (e, n) {
          "open" === e.state && t.open(n, !1);
        }), this.states.filter(function (e, n) {
          "closed" === e.state && t.close(n, !1);
        });
      }
    }, {
      key: "open",
      value: function value(t) {
        (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) && this.setState(t), this.togglePanel("open", t);
      }
    }, {
      key: "close",
      value: function value(t) {
        (!(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]) && this.setState(t), this.togglePanel("closed", t);
      }
    }, {
      key: "openAll",
      value: function value() {
        var t = this;
        this.headers.forEach(function (e, n) {
          t.togglePanel("open", n);
        });
      }
    }, {
      key: "closeAll",
      value: function value() {
        var t = this;
        this.headers.forEach(function (e, n) {
          t.togglePanel("closed", n);
        });
      }
    }, {
      key: "togglePanel",
      value: function value(t, e) {
        var n = this;
        if (void 0 !== t && void 0 !== e) if ("closed" === t) {
          var i = this.headers[e],
              s = this.panels[e];
          s.classList.add(this.settings.hiddenClass), s.classList.remove(this.settings.activeClass), i.classList.remove(this.settings.activeClass), i.setAttribute("aria-expanded", !1), i.setAttribute("aria-label", this.settings.headerOpenLabel), s.onCSSTransitionEnd(function () {
            return n.toggling = !1;
          });
        } else if ("open" === t) {
          var a = this.headers[e],
              r = this.panels[e];
          r.classList.remove(this.settings.hiddenClass), r.classList.add(this.settings.activeClass), a.classList.add(this.settings.activeClass), a.setAttribute("aria-expanded", !0), a.setAttribute("aria-label", this.settings.headerCloseLabel), r.onCSSTransitionEnd(function () {
            return n.toggling = !1;
          });
        }
      }
    }, {
      key: "getState",
      value: function value() {
        var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return e.length && Array.isArray(e) ? e.map(function (e) {
          return t.states[e];
        }) : this.states;
      }
    }, {
      key: "toggleState",
      value: function value(t) {
        if (void 0 !== t) return "closed" === t ? "open" : "closed";
      }
    }, {
      key: "_openHeadersOnLoad",
      value: function value() {
        var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        e.length && Array.isArray(e) && e.filter(function (t) {
          return void 0 != t;
        }).forEach(function (e) {
          t.setState(e);
        });
      }
    }, {
      key: "_setupAttributes",
      value: function value() {
        this._setupHeaders(), this._setupPanels(), this._insertDataAttrs();
      }
    }, {
      key: "_setPanelHeight",
      value: function value() {
        this.calculateAllPanelsHeight();
      }
    }, {
      key: "calculatePanelHeight",
      value: function value(t) {
        var e = t.querySelector(this.settings.panelInnerClass).offsetHeight;
        return t.style.maxHeight = "".concat(e, "px");
      }
    }, {
      key: "calculateAllPanelsHeight",
      value: function value() {
        var t = this;
        this.panels.forEach(function (e) {
          t.calculatePanelHeight(e);
        });
      }
    }, {
      key: "_setupHeaders",
      value: function value() {
        var t = this;
        this.headers.forEach(function (e, n) {
          e.setAttribute("id", "badger-accordion-header-".concat(t.ids[n].id)), e.setAttribute("aria-controls", "badger-accordion-panel-".concat(t.ids[n].id)), e.setAttribute("aria-label", t.settings.headerOpenLabel);
        });
      }
    }, {
      key: "_setupPanels",
      value: function value() {
        var t = this;
        this.panels.forEach(function (e, n) {
          e.setAttribute("id", "badger-accordion-panel-".concat(t.ids[n].id)), e.setAttribute("aria-labeledby", "badger-accordion-header-".concat(t.ids[n].id)), !0 !== t.settings.roles && !1 === t.settings.roles.region || t._setRole("region", e);
        });
      }
    }]), e;
  }();
});
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* flatpickr v4.5.2,, @license MIT */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.flatpickr = t();
}(this, function () {
  "use strict";

  var X = function X(e) {
    return ("0" + e).slice(-2);
  },
      ee = function ee(e) {
    return !0 === e ? 1 : 0;
  };

  function te(n, a, i) {
    var o;
    return void 0 === i && (i = !1), function () {
      var e = this,
          t = arguments;
      null !== o && clearTimeout(o), o = window.setTimeout(function () {
        o = null, i || n.apply(e, t);
      }, a), i && !o && n.apply(e, t);
    };
  }

  var ne = function ne(e) {
    return e instanceof Array ? e : [e];
  },
      e = function e() {},
      ae = function ae(e, t, n) {
    return n.months[t ? "shorthand" : "longhand"][e];
  },
      w = {
    D: e,
    F: function F(e, t, n) {
      e.setMonth(n.months.longhand.indexOf(t));
    },
    G: function G(e, t) {
      e.setHours(parseFloat(t));
    },
    H: function H(e, t) {
      e.setHours(parseFloat(t));
    },
    J: function J(e, t) {
      e.setDate(parseFloat(t));
    },
    K: function K(e, t, n) {
      e.setHours(e.getHours() % 12 + 12 * ee(new RegExp(n.amPM[1], "i").test(t)));
    },
    M: function M(e, t, n) {
      e.setMonth(n.months.shorthand.indexOf(t));
    },
    S: function S(e, t) {
      e.setSeconds(parseFloat(t));
    },
    U: function U(e, t) {
      return new Date(1e3 * parseFloat(t));
    },
    W: function W(e, t) {
      var n = parseInt(t);
      return new Date(e.getFullYear(), 0, 2 + 7 * (n - 1), 0, 0, 0, 0);
    },
    Y: function Y(e, t) {
      e.setFullYear(parseFloat(t));
    },
    Z: function Z(e, t) {
      return new Date(t);
    },
    d: function d(e, t) {
      e.setDate(parseFloat(t));
    },
    h: function h(e, t) {
      e.setHours(parseFloat(t));
    },
    i: function i(e, t) {
      e.setMinutes(parseFloat(t));
    },
    j: function j(e, t) {
      e.setDate(parseFloat(t));
    },
    l: e,
    m: function m(e, t) {
      e.setMonth(parseFloat(t) - 1);
    },
    n: function n(e, t) {
      e.setMonth(parseFloat(t) - 1);
    },
    s: function s(e, t) {
      e.setSeconds(parseFloat(t));
    },
    w: e,
    y: function y(e, t) {
      e.setFullYear(2e3 + parseFloat(t));
    }
  },
      ie = {
    D: "(\\w+)",
    F: "(\\w+)",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "(\\w+)",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "(\\w+)",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
  },
      l = {
    Z: function Z(e) {
      return e.toISOString();
    },
    D: function D(e, t, n) {
      return t.weekdays.shorthand[l.w(e, t, n)];
    },
    F: function F(e, t, n) {
      return ae(l.n(e, t, n) - 1, !1, t);
    },
    G: function G(e, t, n) {
      return X(l.h(e, t, n));
    },
    H: function H(e) {
      return X(e.getHours());
    },
    J: function J(e, t) {
      return void 0 !== t.ordinal ? e.getDate() + t.ordinal(e.getDate()) : e.getDate();
    },
    K: function K(e, t) {
      return t.amPM[ee(11 < e.getHours())];
    },
    M: function M(e, t) {
      return ae(e.getMonth(), !0, t);
    },
    S: function S(e) {
      return X(e.getSeconds());
    },
    U: function U(e) {
      return e.getTime() / 1e3;
    },
    W: function W(e, t, n) {
      return n.getWeek(e);
    },
    Y: function Y(e) {
      return e.getFullYear();
    },
    d: function d(e) {
      return X(e.getDate());
    },
    h: function h(e) {
      return e.getHours() % 12 ? e.getHours() % 12 : 12;
    },
    i: function i(e) {
      return X(e.getMinutes());
    },
    j: function j(e) {
      return e.getDate();
    },
    l: function l(e, t) {
      return t.weekdays.longhand[e.getDay()];
    },
    m: function m(e) {
      return X(e.getMonth() + 1);
    },
    n: function n(e) {
      return e.getMonth() + 1;
    },
    s: function s(e) {
      return e.getSeconds();
    },
    w: function w(e) {
      return e.getDay();
    },
    y: function y(e) {
      return String(e.getFullYear()).substring(2);
    }
  },
      oe = {
    weekdays: {
      shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    },
    months: {
      shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: function ordinal(e) {
      var t = e % 100;
      if (3 < t && t < 21) return "th";

      switch (t % 10) {
        case 1:
          return "st";

        case 2:
          return "nd";

        case 3:
          return "rd";

        default:
          return "th";
      }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: ["AM", "PM"],
    yearAriaLabel: "Year"
  },
      re = function re(e) {
    var t = e.config,
        o = void 0 === t ? C : t,
        n = e.l10n,
        r = void 0 === n ? oe : n;
    return function (a, e, t) {
      var i = t || r;
      return void 0 !== o.formatDate ? o.formatDate(a, e, i) : e.split("").map(function (e, t, n) {
        return l[e] && "\\" !== n[t - 1] ? l[e](a, i, o) : "\\" !== e ? e : "";
      }).join("");
    };
  },
      le = function le(e) {
    var t = e.config,
        D = void 0 === t ? C : t,
        n = e.l10n,
        b = void 0 === n ? oe : n;
    return function (e, t, n, a) {
      if (0 === e || e) {
        var i,
            o = a || b,
            r = e;
        if (e instanceof Date) i = new Date(e.getTime());else if ("string" != typeof e && void 0 !== e.toFixed) i = new Date(e);else if ("string" == typeof e) {
          var l = t || (D || C).dateFormat,
              c = String(e).trim();
          if ("today" === c) i = new Date(), n = !0;else if (/Z$/.test(c) || /GMT$/.test(c)) i = new Date(e);else if (D && D.parseDate) i = D.parseDate(e, l);else {
            i = D && D.noCalendar ? new Date(new Date().setHours(0, 0, 0, 0)) : new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);

            for (var d, s = [], u = 0, f = 0, m = ""; u < l.length; u++) {
              var g = l[u],
                  p = "\\" === g,
                  h = "\\" === l[u - 1] || p;

              if (ie[g] && !h) {
                m += ie[g];
                var v = new RegExp(m).exec(e);
                v && (d = !0) && s["Y" !== g ? "push" : "unshift"]({
                  fn: w[g],
                  val: v[++f]
                });
              } else p || (m += ".");

              s.forEach(function (e) {
                var t = e.fn,
                    n = e.val;
                return i = t(i, n, o) || i;
              });
            }

            i = d ? i : void 0;
          }
        }
        if (i instanceof Date && !isNaN(i.getTime())) return !0 === n && i.setHours(0, 0, 0, 0), i;
        D.errorHandler(new Error("Invalid date provided: " + r));
      }
    };
  };

  function ce(e, t, n) {
    return void 0 === n && (n = !0), !1 !== n ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : e.getTime() - t.getTime();
  }

  var de = function de(e, t, n) {
    return e > Math.min(t, n) && e < Math.max(t, n);
  },
      se = {
    DAY: 864e5
  },
      ue = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"],
      C = {
    _disable: [],
    _enable: [],
    allowInput: !1,
    altFormat: "F j, Y",
    altInput: !1,
    altInputClass: "form-control input",
    animate: "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && -1 === window.navigator.userAgent.indexOf("MSIE"),
    ariaDateFormat: "F j, Y",
    clickOpens: !0,
    closeOnSelect: !0,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: !1,
    enable: [],
    enableSeconds: !1,
    enableTime: !1,
    errorHandler: function errorHandler(e) {
      return "undefined" != typeof console && console.warn(e);
    },
    getWeek: function getWeek(e) {
      var t = new Date(e.getTime());
      t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7);
      var n = new Date(t.getFullYear(), 0, 4);
      return 1 + Math.round(((t.getTime() - n.getTime()) / 864e5 - 3 + (n.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: !1,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: !1,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: void 0,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: !1,
    showMonths: 1,
    static: !1,
    time_24hr: !1,
    weekNumbers: !1,
    wrap: !1
  };

  function fe(e, t, n) {
    if (!0 === n) return e.classList.add(t);
    e.classList.remove(t);
  }

  function me(e, t, n) {
    var a = window.document.createElement(e);
    return t = t || "", n = n || "", a.className = t, void 0 !== n && (a.textContent = n), a;
  }

  function ge(e) {
    for (; e.firstChild;) {
      e.removeChild(e.firstChild);
    }
  }

  function pe(e, t) {
    var n = me("div", "numInputWrapper"),
        a = me("input", "numInput " + e),
        i = me("span", "arrowUp"),
        o = me("span", "arrowDown");
    if (a.type = "text", a.pattern = "\\d*", void 0 !== t) for (var r in t) {
      a.setAttribute(r, t[r]);
    }
    return n.appendChild(a), n.appendChild(i), n.appendChild(o), n;
  }

  "function" != typeof Object.assign && (Object.assign = function (n) {
    if (!n) throw TypeError("Cannot convert undefined or null to object");

    for (var e = arguments.length, a = new Array(1 < e ? e - 1 : 0), t = 1; t < e; t++) {
      a[t - 1] = arguments[t];
    }

    for (var i = function i() {
      var t = a[o];
      t && Object.keys(t).forEach(function (e) {
        return n[e] = t[e];
      });
    }, o = 0; o < a.length; o++) {
      i();
    }

    return n;
  });
  var he = 300;

  function r(d, s) {
    var h = {
      config: Object.assign({}, ve.defaultConfig),
      l10n: oe
    };

    function u(e) {
      return e.bind(h);
    }

    function t() {
      var t = h.config;
      !1 === t.weekNumbers && 1 === t.showMonths || !0 !== t.noCalendar && window.requestAnimationFrame(function () {
        if (h.calendarContainer.style.visibility = "hidden", h.calendarContainer.style.display = "block", void 0 !== h.daysContainer) {
          var e = (h.days.offsetWidth + 1) * t.showMonths;
          h.daysContainer.style.width = e + "px", h.calendarContainer.style.width = e + (void 0 !== h.weekWrapper ? h.weekWrapper.offsetWidth : 0) + "px", h.calendarContainer.style.removeProperty("visibility"), h.calendarContainer.style.removeProperty("display");
        }
      });
    }

    function f(e) {
      if (0 !== h.selectedDates.length) {
        void 0 !== e && "blur" !== e.type && function (e) {
          e.preventDefault();
          var t = "keydown" === e.type,
              n = e.target;
          void 0 !== h.amPM && e.target === h.amPM && (h.amPM.textContent = h.l10n.amPM[ee(h.amPM.textContent === h.l10n.amPM[0])]);
          var a = parseFloat(n.getAttribute("data-min")),
              i = parseFloat(n.getAttribute("data-max")),
              o = parseFloat(n.getAttribute("data-step")),
              r = parseInt(n.value, 10),
              l = e.delta || (t ? 38 === e.which ? 1 : -1 : 0),
              c = r + o * l;

          if (void 0 !== n.value && 2 === n.value.length) {
            var d = n === h.hourElement,
                s = n === h.minuteElement;
            c < a ? (c = i + c + ee(!d) + (ee(d) && ee(!h.amPM)), s && v(void 0, -1, h.hourElement)) : i < c && (c = n === h.hourElement ? c - i - ee(!h.amPM) : a, s && v(void 0, 1, h.hourElement)), h.amPM && d && (1 === o ? c + r === 23 : Math.abs(c - r) > o) && (h.amPM.textContent = h.l10n.amPM[ee(h.amPM.textContent === h.l10n.amPM[0])]), n.value = X(c);
          }
        }(e);
        var t = h._input.value;
        m(), Z(), h._input.value !== t && h._debouncedChange();
      }
    }

    function m() {
      if (void 0 !== h.hourElement && void 0 !== h.minuteElement) {
        var e,
            t,
            n = (parseInt(h.hourElement.value.slice(-2), 10) || 0) % 24,
            a = (parseInt(h.minuteElement.value, 10) || 0) % 60,
            i = void 0 !== h.secondElement ? (parseInt(h.secondElement.value, 10) || 0) % 60 : 0;
        void 0 !== h.amPM && (e = n, t = h.amPM.textContent, n = e % 12 + 12 * ee(t === h.l10n.amPM[1]));
        var o = void 0 !== h.config.minTime || h.config.minDate && h.minDateHasTime && h.latestSelectedDateObj && 0 === ce(h.latestSelectedDateObj, h.config.minDate, !0);

        if (void 0 !== h.config.maxTime || h.config.maxDate && h.maxDateHasTime && h.latestSelectedDateObj && 0 === ce(h.latestSelectedDateObj, h.config.maxDate, !0)) {
          var r = void 0 !== h.config.maxTime ? h.config.maxTime : h.config.maxDate;
          (n = Math.min(n, r.getHours())) === r.getHours() && (a = Math.min(a, r.getMinutes())), a === r.getMinutes() && (i = Math.min(i, r.getSeconds()));
        }

        if (o) {
          var l = void 0 !== h.config.minTime ? h.config.minTime : h.config.minDate;
          (n = Math.max(n, l.getHours())) === l.getHours() && (a = Math.max(a, l.getMinutes())), a === l.getMinutes() && (i = Math.max(i, l.getSeconds()));
        }

        c(n, a, i);
      }
    }

    function i(e) {
      var t = e || h.latestSelectedDateObj;
      t && c(t.getHours(), t.getMinutes(), t.getSeconds());
    }

    function a() {
      var e = h.config.defaultHour,
          t = h.config.defaultMinute,
          n = h.config.defaultSeconds;

      if (void 0 !== h.config.minDate) {
        var a = h.config.minDate.getHours(),
            i = h.config.minDate.getMinutes();
        (e = Math.max(e, a)) === a && (t = Math.max(i, t)), e === a && t === i && (n = h.config.minDate.getSeconds());
      }

      if (void 0 !== h.config.maxDate) {
        var o = h.config.maxDate.getHours(),
            r = h.config.maxDate.getMinutes();
        (e = Math.min(e, o)) === o && (t = Math.min(r, t)), e === o && t === r && (n = h.config.maxDate.getSeconds());
      }

      c(e, t, n);
    }

    function c(e, t, n) {
      void 0 !== h.latestSelectedDateObj && h.latestSelectedDateObj.setHours(e % 24, t, n || 0, 0), h.hourElement && h.minuteElement && !h.isMobile && (h.hourElement.value = X(h.config.time_24hr ? e : (12 + e) % 12 + 12 * ee(e % 12 == 0)), h.minuteElement.value = X(t), void 0 !== h.amPM && (h.amPM.textContent = h.l10n.amPM[ee(12 <= e)]), void 0 !== h.secondElement && (h.secondElement.value = X(n)));
    }

    function n(e) {
      var t = parseInt(e.target.value) + (e.delta || 0);
      (1 < t / 1e3 || "Enter" === e.key && !/[^\d]/.test(t.toString())) && _(t);
    }

    function o(t, n, a, i) {
      return n instanceof Array ? n.forEach(function (e) {
        return o(t, e, a, i);
      }) : t instanceof Array ? t.forEach(function (e) {
        return o(e, n, a, i);
      }) : (t.addEventListener(n, a, i), void h._handlers.push({
        element: t,
        event: n,
        handler: a,
        options: i
      }));
    }

    function r(t) {
      return function (e) {
        1 === e.which && t(e);
      };
    }

    function g() {
      q("onChange");
    }

    function l(e) {
      var t = void 0 !== e ? h.parseDate(e) : h.latestSelectedDateObj || (h.config.minDate && h.config.minDate > h.now ? h.config.minDate : h.config.maxDate && h.config.maxDate < h.now ? h.config.maxDate : h.now);

      try {
        void 0 !== t && (h.currentYear = t.getFullYear(), h.currentMonth = t.getMonth());
      } catch (e) {
        e.message = "Invalid date supplied: " + t, h.config.errorHandler(e);
      }

      h.redraw();
    }

    function p(e) {
      ~e.target.className.indexOf("arrow") && v(e, e.target.classList.contains("arrowUp") ? 1 : -1);
    }

    function v(e, t, n) {
      var a = e && e.target,
          i = n || a && a.parentNode && a.parentNode.firstChild,
          o = $("increment");
      o.delta = t, i && i.dispatchEvent(o);
    }

    function D(e, t, n, a) {
      var i,
          o = N(t, !0),
          r = me("span", "flatpickr-day " + e, t.getDate().toString());
      return r.dateObj = t, r.$i = a, r.setAttribute("aria-label", h.formatDate(t, h.config.ariaDateFormat)), -1 === e.indexOf("hidden") && 0 === ce(t, h.now) && ((h.todayDateElem = r).classList.add("today"), r.setAttribute("aria-current", "date")), o ? (r.tabIndex = -1, z(t) && (r.classList.add("selected"), h.selectedDateElem = r, "range" === h.config.mode && (fe(r, "startRange", h.selectedDates[0] && 0 === ce(t, h.selectedDates[0], !0)), fe(r, "endRange", h.selectedDates[1] && 0 === ce(t, h.selectedDates[1], !0)), "nextMonthDay" === e && r.classList.add("inRange")))) : r.classList.add("disabled"), "range" === h.config.mode && (i = t, !("range" !== h.config.mode || h.selectedDates.length < 2) && 0 <= ce(i, h.selectedDates[0]) && ce(i, h.selectedDates[1]) <= 0 && !z(t) && r.classList.add("inRange")), h.weekNumbers && 1 === h.config.showMonths && "prevMonthDay" !== e && n % 7 == 1 && h.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + h.config.getWeek(t) + "</span>"), q("onDayCreate", r), r;
    }

    function b(e) {
      e.focus(), "range" === h.config.mode && P(e);
    }

    function w(e) {
      for (var t = 0 < e ? 0 : h.config.showMonths - 1, n = 0 < e ? h.config.showMonths : -1, a = t; a != n; a += e) {
        for (var i = h.daysContainer.children[a], o = 0 < e ? 0 : i.children.length - 1, r = 0 < e ? i.children.length : -1, l = o; l != r; l += e) {
          var c = i.children[l];
          if (-1 === c.className.indexOf("hidden") && N(c.dateObj)) return c;
        }
      }
    }

    function C(e, t) {
      var n = F(document.activeElement || document.body),
          a = void 0 !== e ? e : n ? document.activeElement : void 0 !== h.selectedDateElem && F(h.selectedDateElem) ? h.selectedDateElem : void 0 !== h.todayDateElem && F(h.todayDateElem) ? h.todayDateElem : w(0 < t ? 1 : -1);
      return void 0 === a ? h._input.focus() : n ? void function (e, t) {
        for (var n = -1 === e.className.indexOf("Month") ? e.dateObj.getMonth() : h.currentMonth, a = 0 < t ? h.config.showMonths : -1, i = 0 < t ? 1 : -1, o = n - h.currentMonth; o != a; o += i) {
          for (var r = h.daysContainer.children[o], l = n - h.currentMonth === o ? e.$i + t : t < 0 ? r.children.length - 1 : 0, c = r.children.length, d = l; 0 <= d && d < c && d != (0 < t ? c : -1); d += i) {
            var s = r.children[d];
            if (-1 === s.className.indexOf("hidden") && N(s.dateObj) && Math.abs(e.$i - d) >= Math.abs(t)) return b(s);
          }
        }

        h.changeMonth(i), C(w(i), 0);
      }(a, t) : b(a);
    }

    function y(e, t) {
      for (var n = (new Date(e, t, 1).getDay() - h.l10n.firstDayOfWeek + 7) % 7, a = h.utils.getDaysInMonth((t - 1 + 12) % 12), i = h.utils.getDaysInMonth(t), o = window.document.createDocumentFragment(), r = 1 < h.config.showMonths, l = r ? "prevMonthDay hidden" : "prevMonthDay", c = r ? "nextMonthDay hidden" : "nextMonthDay", d = a + 1 - n, s = 0; d <= a; d++, s++) {
        o.appendChild(D(l, new Date(e, t - 1, d), d, s));
      }

      for (d = 1; d <= i; d++, s++) {
        o.appendChild(D("", new Date(e, t, d), d, s));
      }

      for (var u = i + 1; u <= 42 - n && (1 === h.config.showMonths || s % 7 != 0); u++, s++) {
        o.appendChild(D(c, new Date(e, t + 1, u % i), u, s));
      }

      var f = me("div", "dayContainer");
      return f.appendChild(o), f;
    }

    function M() {
      if (void 0 !== h.daysContainer) {
        ge(h.daysContainer), h.weekNumbers && ge(h.weekNumbers);

        for (var e = document.createDocumentFragment(), t = 0; t < h.config.showMonths; t++) {
          var n = new Date(h.currentYear, h.currentMonth, 1);
          n.setMonth(h.currentMonth + t), e.appendChild(y(n.getFullYear(), n.getMonth()));
        }

        h.daysContainer.appendChild(e), h.days = h.daysContainer.firstChild, "range" === h.config.mode && 1 === h.selectedDates.length && P();
      }
    }

    function x() {
      var e = me("div", "flatpickr-month"),
          t = window.document.createDocumentFragment(),
          n = me("span", "cur-month"),
          a = pe("cur-year", {
        tabindex: "-1"
      }),
          i = a.getElementsByTagName("input")[0];
      i.setAttribute("aria-label", h.l10n.yearAriaLabel), h.config.minDate && i.setAttribute("data-min", h.config.minDate.getFullYear().toString()), h.config.maxDate && (i.setAttribute("data-max", h.config.maxDate.getFullYear().toString()), i.disabled = !!h.config.minDate && h.config.minDate.getFullYear() === h.config.maxDate.getFullYear());
      var o = me("div", "flatpickr-current-month");
      return o.appendChild(n), o.appendChild(a), t.appendChild(o), e.appendChild(t), {
        container: e,
        yearElement: i,
        monthElement: n
      };
    }

    function E() {
      ge(h.monthNav), h.monthNav.appendChild(h.prevMonthNav);

      for (var e = h.config.showMonths; e--;) {
        var t = x();
        h.yearElements.push(t.yearElement), h.monthElements.push(t.monthElement), h.monthNav.appendChild(t.container);
      }

      h.monthNav.appendChild(h.nextMonthNav);
    }

    function T() {
      h.weekdayContainer ? ge(h.weekdayContainer) : h.weekdayContainer = me("div", "flatpickr-weekdays");

      for (var e = h.config.showMonths; e--;) {
        var t = me("div", "flatpickr-weekdaycontainer");
        h.weekdayContainer.appendChild(t);
      }

      return k(), h.weekdayContainer;
    }

    function k() {
      var e = h.l10n.firstDayOfWeek,
          t = h.l10n.weekdays.shorthand.concat();
      0 < e && e < t.length && (t = t.splice(e, t.length).concat(t.splice(0, e)));

      for (var n = h.config.showMonths; n--;) {
        h.weekdayContainer.children[n].innerHTML = "\n      <span class=flatpickr-weekday>\n        " + t.join("</span><span class=flatpickr-weekday>") + "\n      </span>\n      ";
      }
    }

    function I(e, t) {
      void 0 === t && (t = !0);
      var n = t ? e : e - h.currentMonth;
      n < 0 && !0 === h._hidePrevMonthArrow || 0 < n && !0 === h._hideNextMonthArrow || (h.currentMonth += n, (h.currentMonth < 0 || 11 < h.currentMonth) && (h.currentYear += 11 < h.currentMonth ? 1 : -1, h.currentMonth = (h.currentMonth + 12) % 12, q("onYearChange")), M(), q("onMonthChange"), G());
    }

    function O(e) {
      return !(!h.config.appendTo || !h.config.appendTo.contains(e)) || h.calendarContainer.contains(e);
    }

    function S(t) {
      if (h.isOpen && !h.config.inline) {
        var e = O(t.target),
            n = t.target === h.input || t.target === h.altInput || h.element.contains(t.target) || t.path && t.path.indexOf && (~t.path.indexOf(h.input) || ~t.path.indexOf(h.altInput)),
            a = "blur" === t.type ? n && t.relatedTarget && !O(t.relatedTarget) : !n && !e,
            i = !h.config.ignoredFocusElements.some(function (e) {
          return e.contains(t.target);
        });
        a && i && (h.close(), "range" === h.config.mode && 1 === h.selectedDates.length && (h.clear(!1), h.redraw()));
      }
    }

    function _(e) {
      if (!(!e || h.config.minDate && e < h.config.minDate.getFullYear() || h.config.maxDate && e > h.config.maxDate.getFullYear())) {
        var t = e,
            n = h.currentYear !== t;
        h.currentYear = t || h.currentYear, h.config.maxDate && h.currentYear === h.config.maxDate.getFullYear() ? h.currentMonth = Math.min(h.config.maxDate.getMonth(), h.currentMonth) : h.config.minDate && h.currentYear === h.config.minDate.getFullYear() && (h.currentMonth = Math.max(h.config.minDate.getMonth(), h.currentMonth)), n && (h.redraw(), q("onYearChange"));
      }
    }

    function N(e, t) {
      void 0 === t && (t = !0);
      var n = h.parseDate(e, void 0, t);
      if (h.config.minDate && n && ce(n, h.config.minDate, void 0 !== t ? t : !h.minDateHasTime) < 0 || h.config.maxDate && n && 0 < ce(n, h.config.maxDate, void 0 !== t ? t : !h.maxDateHasTime)) return !1;
      if (0 === h.config.enable.length && 0 === h.config.disable.length) return !0;
      if (void 0 === n) return !1;

      for (var a, i = 0 < h.config.enable.length, o = i ? h.config.enable : h.config.disable, r = 0; r < o.length; r++) {
        if ("function" == typeof (a = o[r]) && a(n)) return i;
        if (a instanceof Date && void 0 !== n && a.getTime() === n.getTime()) return i;

        if ("string" == typeof a && void 0 !== n) {
          var l = h.parseDate(a, void 0, !0);
          return l && l.getTime() === n.getTime() ? i : !i;
        }

        if ("object" == _typeof(a) && void 0 !== n && a.from && a.to && n.getTime() >= a.from.getTime() && n.getTime() <= a.to.getTime()) return i;
      }

      return !i;
    }

    function F(e) {
      return void 0 !== h.daysContainer && -1 === e.className.indexOf("hidden") && h.daysContainer.contains(e);
    }

    function A(e) {
      var t = e.target === h._input,
          n = h.config.allowInput,
          a = h.isOpen && (!n || !t),
          i = h.config.inline && t && !n;

      if (13 === e.keyCode && t) {
        if (n) return h.setDate(h._input.value, !0, e.target === h.altInput ? h.config.altFormat : h.config.dateFormat), e.target.blur();
        h.open();
      } else if (O(e.target) || a || i) {
        var o = !!h.timeContainer && h.timeContainer.contains(e.target);

        switch (e.keyCode) {
          case 13:
            o ? f() : B(e);
            break;

          case 27:
            e.preventDefault(), R();
            break;

          case 8:
          case 46:
            t && !h.config.allowInput && (e.preventDefault(), h.clear());
            break;

          case 37:
          case 39:
            if (o) h.hourElement && h.hourElement.focus();else if (e.preventDefault(), void 0 !== h.daysContainer && (!1 === n || F(document.activeElement))) {
              var r = 39 === e.keyCode ? 1 : -1;
              e.ctrlKey ? (I(r), C(w(1), 0)) : C(void 0, r);
            }
            break;

          case 38:
          case 40:
            e.preventDefault();
            var l = 40 === e.keyCode ? 1 : -1;
            h.daysContainer && void 0 !== e.target.$i ? e.ctrlKey ? (_(h.currentYear - l), C(w(1), 0)) : o || C(void 0, 7 * l) : h.config.enableTime && (!o && h.hourElement && h.hourElement.focus(), f(e), h._debouncedChange());
            break;

          case 9:
            if (!o) {
              h.element.focus();
              break;
            }

            var c = [h.hourElement, h.minuteElement, h.secondElement, h.amPM].filter(function (e) {
              return e;
            }),
                d = c.indexOf(e.target);

            if (-1 !== d) {
              var s = c[d + (e.shiftKey ? -1 : 1)];
              void 0 !== s ? (e.preventDefault(), s.focus()) : h.element.focus();
            }

        }
      }

      if (void 0 !== h.amPM && e.target === h.amPM) switch (e.key) {
        case h.l10n.amPM[0].charAt(0):
        case h.l10n.amPM[0].charAt(0).toLowerCase():
          h.amPM.textContent = h.l10n.amPM[0], m(), Z();
          break;

        case h.l10n.amPM[1].charAt(0):
        case h.l10n.amPM[1].charAt(0).toLowerCase():
          h.amPM.textContent = h.l10n.amPM[1], m(), Z();
      }
      q("onKeyDown", e);
    }

    function P(o) {
      if (1 === h.selectedDates.length && (!o || o.classList.contains("flatpickr-day") && !o.classList.contains("disabled"))) {
        for (var r = o ? o.dateObj.getTime() : h.days.firstElementChild.dateObj.getTime(), l = h.parseDate(h.selectedDates[0], void 0, !0).getTime(), e = Math.min(r, h.selectedDates[0].getTime()), t = Math.max(r, h.selectedDates[0].getTime()), n = h.daysContainer.lastChild.lastChild.dateObj.getTime(), c = !1, d = 0, s = 0, a = e; a < n; a += se.DAY) {
          N(new Date(a), !0) || (c = c || e < a && a < t, a < l && (!d || d < a) ? d = a : l < a && (!s || a < s) && (s = a));
        }

        for (var u = 0; u < h.config.showMonths; u++) {
          for (var f = h.daysContainer.children[u], m = h.daysContainer.children[u - 1], i = function i(e, t) {
            var n = f.children[e],
                a = n.dateObj.getTime(),
                i = 0 < d && a < d || 0 < s && s < a;
            return i ? (n.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function (e) {
              n.classList.remove(e);
            }), "continue") : c && !i ? "continue" : (["startRange", "inRange", "endRange", "notAllowed"].forEach(function (e) {
              n.classList.remove(e);
            }), void (void 0 !== o && (o.classList.add(r < h.selectedDates[0].getTime() ? "startRange" : "endRange"), !f.contains(o) && 0 < u && m && m.lastChild.dateObj.getTime() >= a || (l < r && a === l ? n.classList.add("startRange") : r < l && a === l && n.classList.add("endRange"), d <= a && (0 === s || a <= s) && de(a, l, r) && n.classList.add("inRange")))));
          }, g = 0, p = f.children.length; g < p; g++) {
            i(g);
          }
        }
      }
    }

    function j() {
      !h.isOpen || h.config.static || h.config.inline || L();
    }

    function Y(a) {
      return function (e) {
        var t = h.config["_" + a + "Date"] = h.parseDate(e, h.config.dateFormat),
            n = h.config["_" + ("min" === a ? "max" : "min") + "Date"];
        void 0 !== t && (h["min" === a ? "minDateHasTime" : "maxDateHasTime"] = 0 < t.getHours() || 0 < t.getMinutes() || 0 < t.getSeconds()), h.selectedDates && (h.selectedDates = h.selectedDates.filter(function (e) {
          return N(e);
        }), h.selectedDates.length || "min" !== a || i(t), Z()), h.daysContainer && (W(), void 0 !== t ? h.currentYearElement[a] = t.getFullYear().toString() : h.currentYearElement.removeAttribute(a), h.currentYearElement.disabled = !!n && void 0 !== t && n.getFullYear() === t.getFullYear());
      };
    }

    function H() {
      "object" != _typeof(h.config.locale) && void 0 === ve.l10ns[h.config.locale] && h.config.errorHandler(new Error("flatpickr: invalid locale " + h.config.locale)), h.l10n = Object.assign({}, ve.l10ns.default, "object" == _typeof(h.config.locale) ? h.config.locale : "default" !== h.config.locale ? ve.l10ns[h.config.locale] : void 0), ie.K = "(" + h.l10n.amPM[0] + "|" + h.l10n.amPM[1] + "|" + h.l10n.amPM[0].toLowerCase() + "|" + h.l10n.amPM[1].toLowerCase() + ")", h.formatDate = re(h), h.parseDate = le({
        config: h.config,
        l10n: h.l10n
      });
    }

    function L(e) {
      if (void 0 !== h.calendarContainer) {
        q("onPreCalendarPosition");
        var t = e || h._positionElement,
            n = Array.prototype.reduce.call(h.calendarContainer.children, function (e, t) {
          return e + t.offsetHeight;
        }, 0),
            a = h.calendarContainer.offsetWidth,
            i = h.config.position.split(" "),
            o = i[0],
            r = 1 < i.length ? i[1] : null,
            l = t.getBoundingClientRect(),
            c = window.innerHeight - l.bottom,
            d = "above" === o || "below" !== o && c < n && l.top > n,
            s = window.pageYOffset + l.top + (d ? -n - 2 : t.offsetHeight + 2);

        if (fe(h.calendarContainer, "arrowTop", !d), fe(h.calendarContainer, "arrowBottom", d), !h.config.inline) {
          var u = window.pageXOffset + l.left - (null != r && "center" === r ? (a - l.width) / 2 : 0),
              f = window.document.body.offsetWidth - l.right,
              m = u + a > window.document.body.offsetWidth;
          fe(h.calendarContainer, "rightMost", m), h.config.static || (h.calendarContainer.style.top = s + "px", m ? (h.calendarContainer.style.left = "auto", h.calendarContainer.style.right = f + "px") : (h.calendarContainer.style.left = u + "px", h.calendarContainer.style.right = "auto"));
        }
      }
    }

    function W() {
      h.config.noCalendar || h.isMobile || (G(), M());
    }

    function R() {
      h._input.focus(), -1 !== window.navigator.userAgent.indexOf("MSIE") || void 0 !== navigator.msMaxTouchPoints ? setTimeout(h.close, 0) : h.close();
    }

    function B(e) {
      e.preventDefault(), e.stopPropagation();

      var t = function e(t, n) {
        return n(t) ? t : t.parentNode ? e(t.parentNode, n) : void 0;
      }(e.target, function (e) {
        return e.classList && e.classList.contains("flatpickr-day") && !e.classList.contains("disabled") && !e.classList.contains("notAllowed");
      });

      if (void 0 !== t) {
        var n = t,
            a = h.latestSelectedDateObj = new Date(n.dateObj.getTime()),
            i = (a.getMonth() < h.currentMonth || a.getMonth() > h.currentMonth + h.config.showMonths - 1) && "range" !== h.config.mode;
        if (h.selectedDateElem = n, "single" === h.config.mode) h.selectedDates = [a];else if ("multiple" === h.config.mode) {
          var o = z(a);
          o ? h.selectedDates.splice(parseInt(o), 1) : h.selectedDates.push(a);
        } else "range" === h.config.mode && (2 === h.selectedDates.length && h.clear(!1), h.selectedDates.push(a), 0 !== ce(a, h.selectedDates[0], !0) && h.selectedDates.sort(function (e, t) {
          return e.getTime() - t.getTime();
        }));

        if (m(), i) {
          var r = h.currentYear !== a.getFullYear();
          h.currentYear = a.getFullYear(), h.currentMonth = a.getMonth(), r && q("onYearChange"), q("onMonthChange");
        }

        if (G(), M(), Z(), h.config.enableTime && setTimeout(function () {
          return h.showTimeInput = !0;
        }, 50), i || "range" === h.config.mode || 1 !== h.config.showMonths ? h.selectedDateElem && h.selectedDateElem.focus() : b(n), void 0 !== h.hourElement && setTimeout(function () {
          return void 0 !== h.hourElement && h.hourElement.select();
        }, 451), h.config.closeOnSelect) {
          var l = "single" === h.config.mode && !h.config.enableTime,
              c = "range" === h.config.mode && 2 === h.selectedDates.length && !h.config.enableTime;
          (l || c) && R();
        }

        g();
      }
    }

    h.parseDate = le({
      config: h.config,
      l10n: h.l10n
    }), h._handlers = [], h._bind = o, h._setHoursFromDate = i, h._positionCalendar = L, h.changeMonth = I, h.changeYear = _, h.clear = function (e) {
      void 0 === e && (e = !0);
      h.input.value = "", void 0 !== h.altInput && (h.altInput.value = "");
      void 0 !== h.mobileInput && (h.mobileInput.value = "");
      h.selectedDates = [], h.latestSelectedDateObj = void 0, !(h.showTimeInput = !1) === h.config.enableTime && a();
      h.redraw(), e && q("onChange");
    }, h.close = function () {
      h.isOpen = !1, h.isMobile || (h.calendarContainer.classList.remove("open"), h._input.classList.remove("active"));
      q("onClose");
    }, h._createElement = me, h.destroy = function () {
      void 0 !== h.config && q("onDestroy");

      for (var e = h._handlers.length; e--;) {
        var t = h._handlers[e];
        t.element.removeEventListener(t.event, t.handler, t.options);
      }

      if (h._handlers = [], h.mobileInput) h.mobileInput.parentNode && h.mobileInput.parentNode.removeChild(h.mobileInput), h.mobileInput = void 0;else if (h.calendarContainer && h.calendarContainer.parentNode) if (h.config.static && h.calendarContainer.parentNode) {
        var n = h.calendarContainer.parentNode;

        if (n.lastChild && n.removeChild(n.lastChild), n.parentNode) {
          for (; n.firstChild;) {
            n.parentNode.insertBefore(n.firstChild, n);
          }

          n.parentNode.removeChild(n);
        }
      } else h.calendarContainer.parentNode.removeChild(h.calendarContainer);
      h.altInput && (h.input.type = "text", h.altInput.parentNode && h.altInput.parentNode.removeChild(h.altInput), delete h.altInput);
      h.input && (h.input.type = h.input._type, h.input.classList.remove("flatpickr-input"), h.input.removeAttribute("readonly"), h.input.value = "");
      ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (e) {
        try {
          delete h[e];
        } catch (e) {}
      });
    }, h.isEnabled = N, h.jumpToDate = l, h.open = function (e, t) {
      void 0 === t && (t = h._positionElement);
      if (!0 === h.isMobile) return e && (e.preventDefault(), e.target && e.target.blur()), void 0 !== h.mobileInput && (h.mobileInput.focus(), h.mobileInput.click()), void q("onOpen");
      if (h._input.disabled || h.config.inline) return;
      var n = h.isOpen;
      h.isOpen = !0, n || (h.calendarContainer.classList.add("open"), h._input.classList.add("active"), q("onOpen"), L(t));
      !0 === h.config.enableTime && !0 === h.config.noCalendar && (0 === h.selectedDates.length && (h.setDate(void 0 !== h.config.minDate ? new Date(h.config.minDate.getTime()) : new Date(), !1), a(), Z()), !1 !== h.config.allowInput || void 0 !== e && h.timeContainer.contains(e.relatedTarget) || setTimeout(function () {
        return h.hourElement.select();
      }, 50));
    }, h.redraw = W, h.set = function (e, t) {
      null !== e && "object" == _typeof(e) ? Object.assign(h.config, e) : (h.config[e] = t, void 0 !== K[e] ? K[e].forEach(function (e) {
        return e();
      }) : -1 < ue.indexOf(e) && (h.config[e] = ne(t)));
      h.redraw(), l(), Z(!1);
    }, h.setDate = function (e, t, n) {
      void 0 === t && (t = !1);
      void 0 === n && (n = h.config.dateFormat);
      if (0 !== e && !e || e instanceof Array && 0 === e.length) return h.clear(t);
      J(e, n), h.showTimeInput = 0 < h.selectedDates.length, h.latestSelectedDateObj = h.selectedDates[0], h.redraw(), l(), i(), Z(t), t && q("onChange");
    }, h.toggle = function (e) {
      if (!0 === h.isOpen) return h.close();
      h.open(e);
    };
    var K = {
      locale: [H, k],
      showMonths: [E, t, T]
    };

    function J(e, t) {
      var n = [];
      if (e instanceof Array) n = e.map(function (e) {
        return h.parseDate(e, t);
      });else if (e instanceof Date || "number" == typeof e) n = [h.parseDate(e, t)];else if ("string" == typeof e) switch (h.config.mode) {
        case "single":
        case "time":
          n = [h.parseDate(e, t)];
          break;

        case "multiple":
          n = e.split(h.config.conjunction).map(function (e) {
            return h.parseDate(e, t);
          });
          break;

        case "range":
          n = e.split(h.l10n.rangeSeparator).map(function (e) {
            return h.parseDate(e, t);
          });
      } else h.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(e)));
      h.selectedDates = n.filter(function (e) {
        return e instanceof Date && N(e, !1);
      }), "range" === h.config.mode && h.selectedDates.sort(function (e, t) {
        return e.getTime() - t.getTime();
      });
    }

    function U(e) {
      return e.slice().map(function (e) {
        return "string" == typeof e || "number" == typeof e || e instanceof Date ? h.parseDate(e, void 0, !0) : e && "object" == _typeof(e) && e.from && e.to ? {
          from: h.parseDate(e.from, void 0),
          to: h.parseDate(e.to, void 0)
        } : e;
      }).filter(function (e) {
        return e;
      });
    }

    function q(e, t) {
      if (void 0 !== h.config) {
        var n = h.config[e];
        if (void 0 !== n && 0 < n.length) for (var a = 0; n[a] && a < n.length; a++) {
          n[a](h.selectedDates, h.input.value, h, t);
        }
        "onChange" === e && (h.input.dispatchEvent($("change")), h.input.dispatchEvent($("input")));
      }
    }

    function $(e) {
      var t = document.createEvent("Event");
      return t.initEvent(e, !0, !0), t;
    }

    function z(e) {
      for (var t = 0; t < h.selectedDates.length; t++) {
        if (0 === ce(h.selectedDates[t], e)) return "" + t;
      }

      return !1;
    }

    function G() {
      h.config.noCalendar || h.isMobile || !h.monthNav || (h.yearElements.forEach(function (e, t) {
        var n = new Date(h.currentYear, h.currentMonth, 1);
        n.setMonth(h.currentMonth + t), h.monthElements[t].textContent = ae(n.getMonth(), h.config.shorthandCurrentMonth, h.l10n) + " ", e.value = n.getFullYear().toString();
      }), h._hidePrevMonthArrow = void 0 !== h.config.minDate && (h.currentYear === h.config.minDate.getFullYear() ? h.currentMonth <= h.config.minDate.getMonth() : h.currentYear < h.config.minDate.getFullYear()), h._hideNextMonthArrow = void 0 !== h.config.maxDate && (h.currentYear === h.config.maxDate.getFullYear() ? h.currentMonth + 1 > h.config.maxDate.getMonth() : h.currentYear > h.config.maxDate.getFullYear()));
    }

    function V(t) {
      return h.selectedDates.map(function (e) {
        return h.formatDate(e, t);
      }).filter(function (e, t, n) {
        return "range" !== h.config.mode || h.config.enableTime || n.indexOf(e) === t;
      }).join("range" !== h.config.mode ? h.config.conjunction : h.l10n.rangeSeparator);
    }

    function Z(e) {
      if (void 0 === e && (e = !0), 0 === h.selectedDates.length) return h.clear(e);
      void 0 !== h.mobileInput && h.mobileFormatStr && (h.mobileInput.value = void 0 !== h.latestSelectedDateObj ? h.formatDate(h.latestSelectedDateObj, h.mobileFormatStr) : ""), h.input.value = V(h.config.dateFormat), void 0 !== h.altInput && (h.altInput.value = V(h.config.altFormat)), !1 !== e && q("onValueUpdate");
    }

    function Q(e) {
      e.preventDefault();
      var t = h.prevMonthNav.contains(e.target),
          n = h.nextMonthNav.contains(e.target);
      t || n ? I(t ? -1 : 1) : 0 <= h.yearElements.indexOf(e.target) ? e.target.select() : e.target.classList.contains("arrowUp") ? h.changeYear(h.currentYear + 1) : e.target.classList.contains("arrowDown") && h.changeYear(h.currentYear - 1);
    }

    return function () {
      h.element = h.input = d, h.isOpen = !1, function () {
        var e = ["wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"],
            t = Object.assign({}, s, JSON.parse(JSON.stringify(d.dataset || {}))),
            n = {};
        h.config.parseDate = t.parseDate, h.config.formatDate = t.formatDate, Object.defineProperty(h.config, "enable", {
          get: function get() {
            return h.config._enable;
          },
          set: function set(e) {
            h.config._enable = U(e);
          }
        }), Object.defineProperty(h.config, "disable", {
          get: function get() {
            return h.config._disable;
          },
          set: function set(e) {
            h.config._disable = U(e);
          }
        });
        var a = "time" === t.mode;
        t.dateFormat || !t.enableTime && !a || (n.dateFormat = t.noCalendar || a ? "H:i" + (t.enableSeconds ? ":S" : "") : ve.defaultConfig.dateFormat + " H:i" + (t.enableSeconds ? ":S" : "")), t.altInput && (t.enableTime || a) && !t.altFormat && (n.altFormat = t.noCalendar || a ? "h:i" + (t.enableSeconds ? ":S K" : " K") : ve.defaultConfig.altFormat + " h:i" + (t.enableSeconds ? ":S" : "") + " K"), Object.defineProperty(h.config, "minDate", {
          get: function get() {
            return h.config._minDate;
          },
          set: Y("min")
        }), Object.defineProperty(h.config, "maxDate", {
          get: function get() {
            return h.config._maxDate;
          },
          set: Y("max")
        });

        var i = function i(t) {
          return function (e) {
            h.config["min" === t ? "_minTime" : "_maxTime"] = h.parseDate(e, "H:i");
          };
        };

        Object.defineProperty(h.config, "minTime", {
          get: function get() {
            return h.config._minTime;
          },
          set: i("min")
        }), Object.defineProperty(h.config, "maxTime", {
          get: function get() {
            return h.config._maxTime;
          },
          set: i("max")
        }), "time" === t.mode && (h.config.noCalendar = !0, h.config.enableTime = !0), Object.assign(h.config, n, t);

        for (var o = 0; o < e.length; o++) {
          h.config[e[o]] = !0 === h.config[e[o]] || "true" === h.config[e[o]];
        }

        ue.filter(function (e) {
          return void 0 !== h.config[e];
        }).forEach(function (e) {
          h.config[e] = ne(h.config[e] || []).map(u);
        }), h.isMobile = !h.config.disableMobile && !h.config.inline && "single" === h.config.mode && !h.config.disable.length && !h.config.enable.length && !h.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        for (var r = 0; r < h.config.plugins.length; r++) {
          var l = h.config.plugins[r](h) || {};

          for (var c in l) {
            -1 < ue.indexOf(c) ? h.config[c] = ne(l[c]).map(u).concat(h.config[c]) : void 0 === t[c] && (h.config[c] = l[c]);
          }
        }

        q("onParseConfig");
      }(), H(), function () {
        if (h.input = h.config.wrap ? d.querySelector("[data-input]") : d, !h.input) return h.config.errorHandler(new Error("Invalid input element specified"));
        h.input._type = h.input.type, h.input.type = "text", h.input.classList.add("flatpickr-input"), h._input = h.input, h.config.altInput && (h.altInput = me(h.input.nodeName, h.input.className + " " + h.config.altInputClass), h._input = h.altInput, h.altInput.placeholder = h.input.placeholder, h.altInput.disabled = h.input.disabled, h.altInput.required = h.input.required, h.altInput.tabIndex = h.input.tabIndex, h.altInput.type = "text", h.input.setAttribute("type", "hidden"), !h.config.static && h.input.parentNode && h.input.parentNode.insertBefore(h.altInput, h.input.nextSibling)), h.config.allowInput || h._input.setAttribute("readonly", "readonly"), h._positionElement = h.config.positionElement || h._input;
      }(), function () {
        h.selectedDates = [], h.now = h.parseDate(h.config.now) || new Date();
        var e = h.config.defaultDate || ("INPUT" !== h.input.nodeName && "TEXTAREA" !== h.input.nodeName || !h.input.placeholder || h.input.value !== h.input.placeholder ? h.input.value : null);
        e && J(e, h.config.dateFormat);
        var t = 0 < h.selectedDates.length ? h.selectedDates[0] : h.config.minDate && h.config.minDate.getTime() > h.now.getTime() ? h.config.minDate : h.config.maxDate && h.config.maxDate.getTime() < h.now.getTime() ? h.config.maxDate : h.now;
        h.currentYear = t.getFullYear(), h.currentMonth = t.getMonth(), 0 < h.selectedDates.length && (h.latestSelectedDateObj = h.selectedDates[0]), void 0 !== h.config.minTime && (h.config.minTime = h.parseDate(h.config.minTime, "H:i")), void 0 !== h.config.maxTime && (h.config.maxTime = h.parseDate(h.config.maxTime, "H:i")), h.minDateHasTime = !!h.config.minDate && (0 < h.config.minDate.getHours() || 0 < h.config.minDate.getMinutes() || 0 < h.config.minDate.getSeconds()), h.maxDateHasTime = !!h.config.maxDate && (0 < h.config.maxDate.getHours() || 0 < h.config.maxDate.getMinutes() || 0 < h.config.maxDate.getSeconds()), Object.defineProperty(h, "showTimeInput", {
          get: function get() {
            return h._showTimeInput;
          },
          set: function set(e) {
            h._showTimeInput = e, h.calendarContainer && fe(h.calendarContainer, "showTimeInput", e), h.isOpen && L();
          }
        });
      }(), h.utils = {
        getDaysInMonth: function getDaysInMonth(e, t) {
          return void 0 === e && (e = h.currentMonth), void 0 === t && (t = h.currentYear), 1 === e && (t % 4 == 0 && t % 100 != 0 || t % 400 == 0) ? 29 : h.l10n.daysInMonth[e];
        }
      }, h.isMobile || function () {
        var e = window.document.createDocumentFragment();

        if (h.calendarContainer = me("div", "flatpickr-calendar"), h.calendarContainer.tabIndex = -1, !h.config.noCalendar) {
          if (e.appendChild((h.monthNav = me("div", "flatpickr-months"), h.yearElements = [], h.monthElements = [], h.prevMonthNav = me("span", "flatpickr-prev-month"), h.prevMonthNav.innerHTML = h.config.prevArrow, h.nextMonthNav = me("span", "flatpickr-next-month"), h.nextMonthNav.innerHTML = h.config.nextArrow, E(), Object.defineProperty(h, "_hidePrevMonthArrow", {
            get: function get() {
              return h.__hidePrevMonthArrow;
            },
            set: function set(e) {
              h.__hidePrevMonthArrow !== e && (fe(h.prevMonthNav, "disabled", e), h.__hidePrevMonthArrow = e);
            }
          }), Object.defineProperty(h, "_hideNextMonthArrow", {
            get: function get() {
              return h.__hideNextMonthArrow;
            },
            set: function set(e) {
              h.__hideNextMonthArrow !== e && (fe(h.nextMonthNav, "disabled", e), h.__hideNextMonthArrow = e);
            }
          }), h.currentYearElement = h.yearElements[0], G(), h.monthNav)), h.innerContainer = me("div", "flatpickr-innerContainer"), h.config.weekNumbers) {
            var t = function () {
              h.calendarContainer.classList.add("hasWeeks");
              var e = me("div", "flatpickr-weekwrapper");
              e.appendChild(me("span", "flatpickr-weekday", h.l10n.weekAbbreviation));
              var t = me("div", "flatpickr-weeks");
              return e.appendChild(t), {
                weekWrapper: e,
                weekNumbers: t
              };
            }(),
                n = t.weekWrapper,
                a = t.weekNumbers;

            h.innerContainer.appendChild(n), h.weekNumbers = a, h.weekWrapper = n;
          }

          h.rContainer = me("div", "flatpickr-rContainer"), h.rContainer.appendChild(T()), h.daysContainer || (h.daysContainer = me("div", "flatpickr-days"), h.daysContainer.tabIndex = -1), M(), h.rContainer.appendChild(h.daysContainer), h.innerContainer.appendChild(h.rContainer), e.appendChild(h.innerContainer);
        }

        h.config.enableTime && e.appendChild(function () {
          h.calendarContainer.classList.add("hasTime"), h.config.noCalendar && h.calendarContainer.classList.add("noCalendar"), h.timeContainer = me("div", "flatpickr-time"), h.timeContainer.tabIndex = -1;
          var e = me("span", "flatpickr-time-separator", ":"),
              t = pe("flatpickr-hour");
          h.hourElement = t.getElementsByTagName("input")[0];
          var n = pe("flatpickr-minute");

          if (h.minuteElement = n.getElementsByTagName("input")[0], h.hourElement.tabIndex = h.minuteElement.tabIndex = -1, h.hourElement.value = X(h.latestSelectedDateObj ? h.latestSelectedDateObj.getHours() : h.config.time_24hr ? h.config.defaultHour : function (e) {
            switch (e % 24) {
              case 0:
              case 12:
                return 12;

              default:
                return e % 12;
            }
          }(h.config.defaultHour)), h.minuteElement.value = X(h.latestSelectedDateObj ? h.latestSelectedDateObj.getMinutes() : h.config.defaultMinute), h.hourElement.setAttribute("data-step", h.config.hourIncrement.toString()), h.minuteElement.setAttribute("data-step", h.config.minuteIncrement.toString()), h.hourElement.setAttribute("data-min", h.config.time_24hr ? "0" : "1"), h.hourElement.setAttribute("data-max", h.config.time_24hr ? "23" : "12"), h.minuteElement.setAttribute("data-min", "0"), h.minuteElement.setAttribute("data-max", "59"), h.timeContainer.appendChild(t), h.timeContainer.appendChild(e), h.timeContainer.appendChild(n), h.config.time_24hr && h.timeContainer.classList.add("time24hr"), h.config.enableSeconds) {
            h.timeContainer.classList.add("hasSeconds");
            var a = pe("flatpickr-second");
            h.secondElement = a.getElementsByTagName("input")[0], h.secondElement.value = X(h.latestSelectedDateObj ? h.latestSelectedDateObj.getSeconds() : h.config.defaultSeconds), h.secondElement.setAttribute("data-step", h.minuteElement.getAttribute("data-step")), h.secondElement.setAttribute("data-min", h.minuteElement.getAttribute("data-min")), h.secondElement.setAttribute("data-max", h.minuteElement.getAttribute("data-max")), h.timeContainer.appendChild(me("span", "flatpickr-time-separator", ":")), h.timeContainer.appendChild(a);
          }

          return h.config.time_24hr || (h.amPM = me("span", "flatpickr-am-pm", h.l10n.amPM[ee(11 < (h.latestSelectedDateObj ? h.hourElement.value : h.config.defaultHour))]), h.amPM.title = h.l10n.toggleTitle, h.amPM.tabIndex = -1, h.timeContainer.appendChild(h.amPM)), h.timeContainer;
        }()), fe(h.calendarContainer, "rangeMode", "range" === h.config.mode), fe(h.calendarContainer, "animate", !0 === h.config.animate), fe(h.calendarContainer, "multiMonth", 1 < h.config.showMonths), h.calendarContainer.appendChild(e);
        var i = void 0 !== h.config.appendTo && void 0 !== h.config.appendTo.nodeType;

        if ((h.config.inline || h.config.static) && (h.calendarContainer.classList.add(h.config.inline ? "inline" : "static"), h.config.inline && (!i && h.element.parentNode ? h.element.parentNode.insertBefore(h.calendarContainer, h._input.nextSibling) : void 0 !== h.config.appendTo && h.config.appendTo.appendChild(h.calendarContainer)), h.config.static)) {
          var o = me("div", "flatpickr-wrapper");
          h.element.parentNode && h.element.parentNode.insertBefore(o, h.element), o.appendChild(h.element), h.altInput && o.appendChild(h.altInput), o.appendChild(h.calendarContainer);
        }

        h.config.static || h.config.inline || (void 0 !== h.config.appendTo ? h.config.appendTo : window.document.body).appendChild(h.calendarContainer);
      }(), function () {
        if (h.config.wrap && ["open", "close", "toggle", "clear"].forEach(function (t) {
          Array.prototype.forEach.call(h.element.querySelectorAll("[data-" + t + "]"), function (e) {
            return o(e, "click", h[t]);
          });
        }), h.isMobile) return function () {
          var e = h.config.enableTime ? h.config.noCalendar ? "time" : "datetime-local" : "date";
          h.mobileInput = me("input", h.input.className + " flatpickr-mobile"), h.mobileInput.step = h.input.getAttribute("step") || "any", h.mobileInput.tabIndex = 1, h.mobileInput.type = e, h.mobileInput.disabled = h.input.disabled, h.mobileInput.required = h.input.required, h.mobileInput.placeholder = h.input.placeholder, h.mobileFormatStr = "datetime-local" === e ? "Y-m-d\\TH:i:S" : "date" === e ? "Y-m-d" : "H:i:S", 0 < h.selectedDates.length && (h.mobileInput.defaultValue = h.mobileInput.value = h.formatDate(h.selectedDates[0], h.mobileFormatStr)), h.config.minDate && (h.mobileInput.min = h.formatDate(h.config.minDate, "Y-m-d")), h.config.maxDate && (h.mobileInput.max = h.formatDate(h.config.maxDate, "Y-m-d")), h.input.type = "hidden", void 0 !== h.altInput && (h.altInput.type = "hidden");

          try {
            h.input.parentNode && h.input.parentNode.insertBefore(h.mobileInput, h.input.nextSibling);
          } catch (e) {}

          o(h.mobileInput, "change", function (e) {
            h.setDate(e.target.value, !1, h.mobileFormatStr), q("onChange"), q("onClose");
          });
        }();
        var e = te(j, 50);
        h._debouncedChange = te(g, he), h.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && o(h.daysContainer, "mouseover", function (e) {
          "range" === h.config.mode && P(e.target);
        }), o(window.document.body, "keydown", A), h.config.static || o(h._input, "keydown", A), h.config.inline || h.config.static || o(window, "resize", e), void 0 !== window.ontouchstart ? o(window.document, "click", S) : o(window.document, "mousedown", r(S)), o(window.document, "focus", S, {
          capture: !0
        }), !0 === h.config.clickOpens && (o(h._input, "focus", h.open), o(h._input, "mousedown", r(h.open))), void 0 !== h.daysContainer && (o(h.monthNav, "mousedown", r(Q)), o(h.monthNav, ["keyup", "increment"], n), o(h.daysContainer, "mousedown", r(B))), void 0 !== h.timeContainer && void 0 !== h.minuteElement && void 0 !== h.hourElement && (o(h.timeContainer, ["increment"], f), o(h.timeContainer, "blur", f, {
          capture: !0
        }), o(h.timeContainer, "mousedown", r(p)), o([h.hourElement, h.minuteElement], ["focus", "click"], function (e) {
          return e.target.select();
        }), void 0 !== h.secondElement && o(h.secondElement, "focus", function () {
          return h.secondElement && h.secondElement.select();
        }), void 0 !== h.amPM && o(h.amPM, "mousedown", r(function (e) {
          f(e), g();
        })));
      }(), (h.selectedDates.length || h.config.noCalendar) && (h.config.enableTime && i(h.config.noCalendar ? h.latestSelectedDateObj || h.config.minDate : void 0), Z(!1)), t(), h.showTimeInput = 0 < h.selectedDates.length || h.config.noCalendar;
      var e = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      !h.isMobile && e && L(), q("onReady");
    }(), h;
  }

  function n(e, t) {
    for (var n = Array.prototype.slice.call(e), a = [], i = 0; i < n.length; i++) {
      var o = n[i];

      try {
        if (null !== o.getAttribute("data-fp-omit")) continue;
        void 0 !== o._flatpickr && (o._flatpickr.destroy(), o._flatpickr = void 0), o._flatpickr = r(o, t || {}), a.push(o._flatpickr);
      } catch (e) {
        console.error(e);
      }
    }

    return 1 === a.length ? a[0] : a;
  }

  "undefined" != typeof HTMLElement && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (e) {
    return n(this, e);
  }, HTMLElement.prototype.flatpickr = function (e) {
    return n([this], e);
  });

  var ve = function ve(e, t) {
    return e instanceof NodeList ? n(e, t) : n("string" == typeof e ? window.document.querySelectorAll(e) : [e], t);
  };

  return ve.defaultConfig = C, ve.l10ns = {
    en: Object.assign({}, oe),
    default: Object.assign({}, oe)
  }, ve.localize = function (e) {
    ve.l10ns.default = Object.assign({}, ve.l10ns.default, e);
  }, ve.setDefaults = function (e) {
    ve.defaultConfig = Object.assign({}, ve.defaultConfig, e);
  }, ve.parseDate = le({}), ve.formatDate = re({}), ve.compareDates = ce, "undefined" != typeof jQuery && (jQuery.fn.flatpickr = function (e) {
    return n(this, e);
  }), Date.prototype.fp_incr = function (e) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + ("string" == typeof e ? parseInt(e, 10) : e));
  }, "undefined" != typeof window && (window.flatpickr = ve), ve;
});
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Glide.js v3.2.4
 * (c) 2013-2018 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Glide = e();
}(this, function () {
  "use strict";

  var i = {
    type: "slider",
    startAt: 0,
    perView: 1,
    focusAt: 0,
    gap: 10,
    autoplay: !1,
    hoverpause: !0,
    keyboard: !0,
    bound: !1,
    swipeThreshold: 80,
    dragThreshold: 120,
    perTouch: !1,
    touchRatio: .5,
    touchAngle: 45,
    animationDuration: 400,
    rewind: !0,
    rewindDuration: 800,
    animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    throttle: 10,
    direction: "ltr",
    peek: 0,
    breakpoints: {},
    classes: {
      direction: {
        ltr: "glide--ltr",
        rtl: "glide--rtl"
      },
      slider: "glide--slider",
      carousel: "glide--carousel",
      swipeable: "glide--swipeable",
      dragging: "glide--dragging",
      cloneSlide: "glide__slide--clone",
      activeNav: "glide__bullet--active",
      activeSlide: "glide__slide--active",
      disabledArrow: "glide__arrow--disabled"
    }
  };

  var n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  },
      r = function r(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  },
      o = function () {
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    return function (t, e, n) {
      return e && i(t.prototype, e), n && i(t, n), t;
    };
  }(),
      a = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
      }
    }

    return t;
  };

  function b(t) {
    return parseInt(t);
  }

  function s(t) {
    return "string" == typeof t;
  }

  function u(t) {
    var e = void 0 === t ? "undefined" : n(t);
    return "function" === e || "object" === e && !!t;
  }

  function c(t) {
    return "function" == typeof t;
  }

  function l(t) {
    return void 0 === t;
  }

  function f(t) {
    return t.constructor === Array;
  }

  function d(t, e, n) {
    Object.defineProperty(t, e, n);
  }

  function h(t, e) {
    var n = a({}, t, e);
    return e.hasOwnProperty("classes") && (n.classes = a({}, t.classes, e.classes), e.classes.hasOwnProperty("direction") && (n.classes.direction = a({}, t.classes.direction, e.classes.direction))), e.hasOwnProperty("breakpoints") && (n.breakpoints = a({}, t.breakpoints, e.breakpoints)), n;
  }

  var v = function () {
    function e() {
      var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
      r(this, e), this.events = t, this.hop = t.hasOwnProperty;
    }

    return o(e, [{
      key: "on",
      value: function value(t, e) {
        if (f(t)) for (var n = 0; n < t.length; n++) {
          this.on(t[n], e);
        }
        this.hop.call(this.events, t) || (this.events[t] = []);
        var i = this.events[t].push(e) - 1;
        return {
          remove: function remove() {
            delete this.events[t][i];
          }
        };
      }
    }, {
      key: "emit",
      value: function value(t, e) {
        if (f(t)) for (var n = 0; n < t.length; n++) {
          this.emit(t[n], e);
        }
        this.hop.call(this.events, t) && this.events[t].forEach(function (t) {
          t(e || {});
        });
      }
    }]), e;
  }(),
      p = function () {
    function n(t) {
      var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
      r(this, n), this._c = {}, this._t = [], this._e = new v(), this.disabled = !1, this.selector = t, this.settings = h(i, e), this.index = this.settings.startAt;
    }

    return o(n, [{
      key: "mount",
      value: function value() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        return this._e.emit("mount.before"), u(t) && (this._c = function (t, e, n) {
          var i = {};

          for (var r in e) {
            c(e[r]) && (i[r] = e[r](t, i, n));
          }

          for (var o in i) {
            c(i[o].mount) && i[o].mount();
          }

          return i;
        }(this, t, this._e)), this._e.emit("mount.after"), this;
      }
    }, {
      key: "mutate",
      value: function value() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [];
        return f(t) && (this._t = t), this;
      }
    }, {
      key: "update",
      value: function value() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        return this.settings = h(this.settings, t), t.hasOwnProperty("startAt") && (this.index = t.startAt), this._e.emit("update"), this;
      }
    }, {
      key: "go",
      value: function value(t) {
        return this._c.Run.make(t), this;
      }
    }, {
      key: "move",
      value: function value(t) {
        return this._c.Transition.disable(), this._c.Move.make(t), this;
      }
    }, {
      key: "destroy",
      value: function value() {
        return this._e.emit("destroy"), this;
      }
    }, {
      key: "play",
      value: function value() {
        var t = 0 < arguments.length && void 0 !== arguments[0] && arguments[0];
        return t && (this.settings.autoplay = t), this._e.emit("play"), this;
      }
    }, {
      key: "pause",
      value: function value() {
        return this._e.emit("pause"), this;
      }
    }, {
      key: "disable",
      value: function value() {
        return this.disabled = !0, this;
      }
    }, {
      key: "enable",
      value: function value() {
        return this.disabled = !1, this;
      }
    }, {
      key: "on",
      value: function value(t, e) {
        return this._e.on(t, e), this;
      }
    }, {
      key: "isType",
      value: function value(t) {
        return this.settings.type === t;
      }
    }, {
      key: "settings",
      get: function get() {
        return this._o;
      },
      set: function set(t) {
        u(t) && (this._o = t);
      }
    }, {
      key: "index",
      get: function get() {
        return this._i;
      },
      set: function set(t) {
        this._i = b(t);
      }
    }, {
      key: "type",
      get: function get() {
        return this.settings.type;
      }
    }, {
      key: "disabled",
      get: function get() {
        return this._d;
      },
      set: function set(t) {
        this._d = !!t;
      }
    }]), n;
  }();

  function m() {
    return new Date().getTime();
  }

  function w(n, i, r) {
    var o = void 0,
        s = void 0,
        u = void 0,
        a = void 0,
        c = 0;
    r || (r = {});

    var l = function l() {
      c = !1 === r.leading ? 0 : m(), o = null, a = n.apply(s, u), o || (s = u = null);
    },
        t = function t() {
      var t = m();
      c || !1 !== r.leading || (c = t);
      var e = i - (t - c);
      return s = this, u = arguments, e <= 0 || i < e ? (o && (clearTimeout(o), o = null), c = t, a = n.apply(s, u), o || (s = u = null)) : o || !1 === r.trailing || (o = setTimeout(l, e)), a;
    };

    return t.cancel = function () {
      clearTimeout(o), c = 0, o = s = u = null;
    }, t;
  }

  var g = {
    ltr: ["marginLeft", "marginRight"],
    rtl: ["marginRight", "marginLeft"]
  };

  function y(t) {
    if (t && t.parentNode) {
      for (var e = t.parentNode.firstChild, n = []; e; e = e.nextSibling) {
        1 === e.nodeType && e !== t && n.push(e);
      }

      return n;
    }

    return [];
  }

  function _(t) {
    return !!(t && t instanceof window.HTMLElement);
  }

  var k = '[data-glide-el="track"]';

  var S = function () {
    function e() {
      var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
      r(this, e), this.listeners = t;
    }

    return o(e, [{
      key: "on",
      value: function value(t, e, n) {
        var i = 3 < arguments.length && void 0 !== arguments[3] && arguments[3];
        s(t) && (t = [t]);

        for (var r = 0; r < t.length; r++) {
          this.listeners[t[r]] = n, e.addEventListener(t[r], this.listeners[t[r]], i);
        }
      }
    }, {
      key: "off",
      value: function value(t, e) {
        s(t) && (t = [t]);

        for (var n = 0; n < t.length; n++) {
          e.removeEventListener(t[n], this.listeners[t[n]], !1);
        }
      }
    }, {
      key: "destroy",
      value: function value() {
        delete this.listeners;
      }
    }]), e;
  }();

  var H = ["ltr", "rtl"],
      T = {
    ">": "<",
    "<": ">",
    "=": "="
  };

  function t(t, e) {
    return {
      modify: function modify(t) {
        return e.Direction.is("rtl") ? -t : t;
      }
    };
  }

  function x(i, r, o) {
    var s = [function (e, n) {
      return {
        modify: function modify(t) {
          return t + n.Gaps.value * e.index;
        }
      };
    }, function (t, e) {
      return {
        modify: function modify(t) {
          return t + e.Clones.grow / 2;
        }
      };
    }, function (n, i) {
      return {
        modify: function modify(t) {
          if (0 <= n.settings.focusAt) {
            var e = i.Peek.value;
            return u(e) ? t - e.before : t - e;
          }

          return t;
        }
      };
    }, function (o, s) {
      return {
        modify: function modify(t) {
          var e = s.Gaps.value,
              n = s.Sizes.width,
              i = o.settings.focusAt,
              r = s.Sizes.slideWidth;
          return "center" === i ? t - (n / 2 - r / 2) : t - r * i - e * i;
        }
      };
    }].concat(i._t, [t]);
    return {
      mutate: function mutate(t) {
        for (var e = 0; e < s.length; e++) {
          var n = s[e];
          c(n) && c(n().modify) && (t = n(i, r, o).modify(t));
        }

        return t;
      }
    };
  }

  var e = !1;

  try {
    var O = Object.defineProperty({}, "passive", {
      get: function get() {
        e = !0;
      }
    });
    window.addEventListener("testPassive", null, O), window.removeEventListener("testPassive", null, O);
  } catch (t) {}

  var A = e,
      M = ["touchstart", "mousedown"],
      C = ["touchmove", "mousemove"],
      P = ["touchend", "touchcancel", "mouseup", "mouseleave"],
      L = ["mousedown", "mousemove", "mouseup", "mouseleave"];

  function z(t) {
    return u(t) ? (n = t, Object.keys(n).sort().reduce(function (t, e) {
      return t[e] = n[e], t[e], t;
    }, {})) : {};
    var n;
  }

  var j = {
    Html: function Html(e, t) {
      var n = {
        mount: function mount() {
          this.root = e.selector, this.track = this.root.querySelector(k), this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (t) {
            return !t.classList.contains(e.settings.classes.cloneSlide);
          });
        }
      };
      return d(n, "root", {
        get: function get() {
          return n._r;
        },
        set: function set(t) {
          s(t) && (t = document.querySelector(t)), _(t) && (n._r = t);
        }
      }), d(n, "track", {
        get: function get() {
          return n._t;
        },
        set: function set(t) {
          _(t) && (n._t = t);
        }
      }), d(n, "wrapper", {
        get: function get() {
          return n.track.children[0];
        }
      }), n;
    },
    Translate: function Translate(r, o, s) {
      var u = {
        set: function set(t) {
          var e = x(r, o).mutate(t);
          o.Html.wrapper.style.transform = "translate3d(" + -1 * e + "px, 0px, 0px)";
        },
        remove: function remove() {
          o.Html.wrapper.style.transform = "";
        }
      };
      return s.on("move", function (t) {
        var e = o.Gaps.value,
            n = o.Sizes.length,
            i = o.Sizes.slideWidth;
        return r.isType("carousel") && o.Run.isOffset("<") ? (o.Transition.after(function () {
          s.emit("translate.jump"), u.set(i * (n - 1));
        }), u.set(-i - e * n)) : r.isType("carousel") && o.Run.isOffset(">") ? (o.Transition.after(function () {
          s.emit("translate.jump"), u.set(0);
        }), u.set(i * n + e * n)) : u.set(t.movement);
      }), s.on("destroy", function () {
        u.remove();
      }), u;
    },
    Transition: function Transition(n, e, t) {
      var i = !1,
          r = {
        compose: function compose(t) {
          var e = n.settings;
          return i ? t + " 0ms " + e.animationTimingFunc : t + " " + this.duration + "ms " + e.animationTimingFunc;
        },
        set: function set() {
          var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "transform";
          e.Html.wrapper.style.transition = this.compose(t);
        },
        remove: function remove() {
          e.Html.wrapper.style.transition = "";
        },
        after: function after(t) {
          setTimeout(function () {
            t();
          }, this.duration);
        },
        enable: function enable() {
          i = !1, this.set();
        },
        disable: function disable() {
          i = !0, this.set();
        }
      };
      return d(r, "duration", {
        get: function get() {
          var t = n.settings;
          return n.isType("slider") && e.Run.offset ? t.rewindDuration : t.animationDuration;
        }
      }), t.on("move", function () {
        r.set();
      }), t.on(["build.before", "resize", "translate.jump"], function () {
        r.disable();
      }), t.on("run", function () {
        r.enable();
      }), t.on("destroy", function () {
        r.remove();
      }), r;
    },
    Direction: function Direction(t, e, n) {
      var i = {
        mount: function mount() {
          this.value = t.settings.direction;
        },
        resolve: function resolve(t) {
          var e = t.slice(0, 1);
          return this.is("rtl") ? t.split(e).join(T[e]) : t;
        },
        is: function is(t) {
          return this.value === t;
        },
        addClass: function addClass() {
          e.Html.root.classList.add(t.settings.classes.direction[this.value]);
        },
        removeClass: function removeClass() {
          e.Html.root.classList.remove(t.settings.classes.direction[this.value]);
        }
      };
      return d(i, "value", {
        get: function get() {
          return i._v;
        },
        set: function set(t) {
          -1 < H.indexOf(t) && (i._v = t);
        }
      }), n.on(["destroy", "update"], function () {
        i.removeClass();
      }), n.on("update", function () {
        i.mount();
      }), n.on(["build.before", "update"], function () {
        i.addClass();
      }), i;
    },
    Peek: function Peek(n, t, e) {
      var i = {
        mount: function mount() {
          this.value = n.settings.peek;
        }
      };
      return d(i, "value", {
        get: function get() {
          return i._v;
        },
        set: function set(t) {
          u(t) ? (t.before = b(t.before), t.after = b(t.after)) : t = b(t), i._v = t;
        }
      }), d(i, "reductor", {
        get: function get() {
          var t = i.value,
              e = n.settings.perView;
          return u(t) ? t.before / e + t.after / e : 2 * t / e;
        }
      }), e.on(["resize", "update"], function () {
        i.mount();
      }), i;
    },
    Sizes: function Sizes(t, n, e) {
      var i = {
        setupSlides: function setupSlides() {
          for (var t = n.Html.slides, e = 0; e < t.length; e++) {
            t[e].style.width = this.slideWidth + "px";
          }
        },
        setupWrapper: function setupWrapper(t) {
          n.Html.wrapper.style.width = this.wrapperSize + "px";
        },
        remove: function remove() {
          for (var t = n.Html.slides, e = 0; e < t.length; e++) {
            t[e].style.width = "";
          }

          n.Html.wrapper.style.width = "";
        }
      };
      return d(i, "length", {
        get: function get() {
          return n.Html.slides.length;
        }
      }), d(i, "width", {
        get: function get() {
          return n.Html.root.offsetWidth;
        }
      }), d(i, "wrapperSize", {
        get: function get() {
          return i.slideWidth * i.length + n.Gaps.grow + n.Clones.grow;
        }
      }), d(i, "slideWidth", {
        get: function get() {
          return i.width / t.settings.perView - n.Peek.reductor - n.Gaps.reductor;
        }
      }), e.on(["build.before", "resize", "update"], function () {
        i.setupSlides(), i.setupWrapper();
      }), e.on("destroy", function () {
        i.remove();
      }), i;
    },
    Gaps: function Gaps(e, o, t) {
      var n = {
        apply: function apply(t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style,
                r = o.Direction.value;
            i[g[r][0]] = 0 !== e ? this.value / 2 + "px" : "", e !== t.length - 1 ? i[g[r][1]] = this.value / 2 + "px" : i[g[r][1]] = "";
          }
        },
        remove: function remove(t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style;
            i.marginLeft = "", i.marginRight = "";
          }
        }
      };
      return d(n, "value", {
        get: function get() {
          return b(e.settings.gap);
        }
      }), d(n, "grow", {
        get: function get() {
          return n.value * (o.Sizes.length - 1);
        }
      }), d(n, "reductor", {
        get: function get() {
          var t = e.settings.perView;
          return n.value * (t - 1) / t;
        }
      }), t.on(["build.after", "update"], w(function () {
        n.apply(o.Html.wrapper.children);
      }, 30)), t.on("destroy", function () {
        n.remove(o.Html.wrapper.children);
      }), n;
    },
    Move: function Move(t, n, i) {
      var e = {
        mount: function mount() {
          this._o = 0;
        },
        make: function make() {
          var t = this,
              e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0;
          this.offset = e, i.emit("move", {
            movement: this.value
          }), n.Transition.after(function () {
            i.emit("move.after", {
              movement: t.value
            });
          });
        }
      };
      return d(e, "offset", {
        get: function get() {
          return e._o;
        },
        set: function set(t) {
          e._o = l(t) ? 0 : b(t);
        }
      }), d(e, "translate", {
        get: function get() {
          return n.Sizes.slideWidth * t.index;
        }
      }), d(e, "value", {
        get: function get() {
          var t = this.offset,
              e = this.translate;
          return n.Direction.is("rtl") ? e + t : e - t;
        }
      }), i.on(["build.before", "run"], function () {
        e.make();
      }), e;
    },
    Clones: function Clones(h, v, t) {
      var e = {
        mount: function mount() {
          this.items = [], h.isType("carousel") && (this.items = this.collect());
        },
        collect: function collect() {
          for (var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [], e = v.Html.slides, n = h.settings, i = n.perView, r = n.classes, o = i + +!!h.settings.peek, s = e.slice(0, o), u = e.slice(-o), a = 0; a < Math.max(1, Math.floor(i / e.length)); a++) {
            for (var c = 0; c < s.length; c++) {
              var l = s[c].cloneNode(!0);
              l.classList.add(r.cloneSlide), t.push(l);
            }

            for (var f = 0; f < u.length; f++) {
              var d = u[f].cloneNode(!0);
              d.classList.add(r.cloneSlide), t.unshift(d);
            }
          }

          return t;
        },
        append: function append() {
          for (var t = this.items, e = v.Html, n = e.wrapper, i = e.slides, r = Math.floor(t.length / 2), o = t.slice(0, r).reverse(), s = t.slice(r, t.length), u = 0; u < s.length; u++) {
            n.appendChild(s[u]);
          }

          for (var a = 0; a < o.length; a++) {
            n.insertBefore(o[a], i[0]);
          }

          for (var c = 0; c < t.length; c++) {
            t[c].style.width = v.Sizes.slideWidth + "px";
          }
        },
        remove: function remove() {
          for (var t = this.items, e = 0; e < t.length; e++) {
            v.Html.wrapper.removeChild(t[e]);
          }
        }
      };
      return d(e, "grow", {
        get: function get() {
          return (v.Sizes.slideWidth + v.Gaps.value) * e.items.length;
        }
      }), t.on("update", function () {
        e.remove(), e.mount(), e.append();
      }), t.on("build.before", function () {
        h.isType("carousel") && e.append();
      }), t.on("destroy", function () {
        e.remove();
      }), e;
    },
    Resize: function Resize(t, e, n) {
      var i = new S(),
          r = {
        mount: function mount() {
          this.bind();
        },
        bind: function bind() {
          i.on("resize", window, w(function () {
            n.emit("resize");
          }, t.settings.throttle));
        },
        unbind: function unbind() {
          i.off("resize", window);
        }
      };
      return n.on("destroy", function () {
        r.unbind(), i.destroy();
      }), r;
    },
    Build: function Build(n, i, t) {
      var e = {
        mount: function mount() {
          t.emit("build.before"), this.typeClass(), this.activeClass(), t.emit("build.after");
        },
        typeClass: function typeClass() {
          i.Html.root.classList.add(n.settings.classes[n.settings.type]);
        },
        activeClass: function activeClass() {
          var e = n.settings.classes,
              t = i.Html.slides[n.index];
          t && (t.classList.add(e.activeSlide), y(t).forEach(function (t) {
            t.classList.remove(e.activeSlide);
          }));
        },
        removeClasses: function removeClasses() {
          var e = n.settings.classes;
          i.Html.root.classList.remove(e[n.settings.type]), i.Html.slides.forEach(function (t) {
            t.classList.remove(e.activeSlide);
          });
        }
      };
      return t.on(["destroy", "update"], function () {
        e.removeClasses();
      }), t.on(["resize", "update"], function () {
        e.mount();
      }), t.on("move.after", function () {
        e.activeClass();
      }), e;
    },
    Run: function Run(o, n, s) {
      var t = {
        mount: function mount() {
          this._o = !1;
        },
        make: function make(t) {
          var e = this;
          o.disabled || (o.disable(), this.move = t, s.emit("run.before", this.move), this.calculate(), s.emit("run", this.move), n.Transition.after(function () {
            (e.isOffset("<") || e.isOffset(">")) && (e._o = !1, s.emit("run.offset", e.move)), s.emit("run.after", e.move), o.enable();
          }));
        },
        calculate: function calculate() {
          var t = this.move,
              e = this.length,
              n = t.steps,
              i = t.direction,
              r = "number" == typeof b(n) && 0 !== b(n);

          switch (i) {
            case ">":
              ">" === n ? o.index = e : this.isEnd() ? (o.isType("slider") && !o.settings.rewind || (this._o = !0, o.index = 0), s.emit("run.end", t)) : r ? o.index += Math.min(e - o.index, -b(n)) : o.index++;
              break;

            case "<":
              "<" === n ? o.index = 0 : this.isStart() ? (o.isType("slider") && !o.settings.rewind || (this._o = !0, o.index = e), s.emit("run.start", t)) : r ? o.index -= Math.min(o.index, b(n)) : o.index--;
              break;

            case "=":
              o.index = n;
          }
        },
        isStart: function isStart() {
          return 0 === o.index;
        },
        isEnd: function isEnd() {
          return o.index === this.length;
        },
        isOffset: function isOffset(t) {
          return this._o && this.move.direction === t;
        }
      };
      return d(t, "move", {
        get: function get() {
          return this._m;
        },
        set: function set(t) {
          this._m = {
            direction: t.substr(0, 1),
            steps: t.substr(1) ? t.substr(1) : 0
          };
        }
      }), d(t, "length", {
        get: function get() {
          var t = o.settings,
              e = n.Html.slides.length;
          return o.isType("slider") && "center" !== t.focusAt && t.bound ? e - 1 - (b(t.perView) - 1) + b(t.focusAt) : e - 1;
        }
      }), d(t, "offset", {
        get: function get() {
          return this._o;
        }
      }), t;
    },
    Swipe: function Swipe(d, h, v) {
      var n = new S(),
          p = 0,
          m = 0,
          g = 0,
          i = !1,
          y = !0,
          r = !!A && {
        passive: !0
      },
          t = {
        mount: function mount() {
          this.bindSwipeStart();
        },
        start: function start(t) {
          if (!i && !d.disabled) {
            this.disable();
            var e = this.touches(t);
            y = !0, p = null, m = b(e.pageX), g = b(e.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), v.emit("swipe.start");
          }
        },
        move: function move(t) {
          if (!d.disabled) {
            var e = d.settings,
                n = e.touchAngle,
                i = e.touchRatio,
                r = e.classes,
                o = this.touches(t),
                s = b(o.pageX) - m,
                u = b(o.pageY) - g,
                a = Math.abs(s << 2),
                c = Math.abs(u << 2),
                l = Math.sqrt(a + c),
                f = Math.sqrt(c);
            if (p = Math.asin(f / l), !(y && 180 * p / Math.PI < n)) return y = !1;
            t.stopPropagation(), h.Move.make(s * parseFloat(i)), h.Html.root.classList.add(r.dragging), v.emit("swipe.move");
          }
        },
        end: function end(t) {
          if (!d.disabled) {
            var e = d.settings,
                n = this.touches(t),
                i = this.threshold(t),
                r = n.pageX - m,
                o = 180 * p / Math.PI,
                s = Math.round(r / h.Sizes.slideWidth);
            this.enable(), y && (i < r && o < e.touchAngle ? (e.perTouch && (s = Math.min(s, b(e.perTouch))), h.Direction.is("rtl") && (s = -s), h.Run.make(h.Direction.resolve("<" + s))) : r < -i && o < e.touchAngle ? (e.perTouch && (s = Math.max(s, -b(e.perTouch))), h.Direction.is("rtl") && (s = -s), h.Run.make(h.Direction.resolve(">" + s))) : h.Move.make()), h.Html.root.classList.remove(e.classes.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), v.emit("swipe.end");
          }
        },
        bindSwipeStart: function bindSwipeStart() {
          var e = this,
              t = d.settings;
          t.swipeThreshold && n.on(M[0], h.Html.wrapper, function (t) {
            e.start(t);
          }, r), t.dragThreshold && n.on(M[1], h.Html.wrapper, function (t) {
            e.start(t);
          }, r);
        },
        unbindSwipeStart: function unbindSwipeStart() {
          n.off(M[0], h.Html.wrapper), n.off(M[1], h.Html.wrapper);
        },
        bindSwipeMove: function bindSwipeMove() {
          var e = this;
          n.on(C, h.Html.wrapper, w(function (t) {
            e.move(t);
          }, d.settings.throttle), r);
        },
        unbindSwipeMove: function unbindSwipeMove() {
          n.off(C, h.Html.wrapper);
        },
        bindSwipeEnd: function bindSwipeEnd() {
          var e = this;
          n.on(P, h.Html.wrapper, function (t) {
            e.end(t);
          });
        },
        unbindSwipeEnd: function unbindSwipeEnd() {
          n.off(P, h.Html.wrapper);
        },
        touches: function touches(t) {
          return -1 < L.indexOf(t.type) ? t : t.touches[0] || t.changedTouches[0];
        },
        threshold: function threshold(t) {
          var e = d.settings;
          return -1 < L.indexOf(t.type) ? e.dragThreshold : e.swipeThreshold;
        },
        enable: function enable() {
          return i = !1, h.Transition.enable(), this;
        },
        disable: function disable() {
          return i = !0, h.Transition.disable(), this;
        }
      };
      return v.on("build.after", function () {
        h.Html.root.classList.add(d.settings.classes.swipeable);
      }), v.on("destroy", function () {
        t.unbindSwipeStart(), t.unbindSwipeMove(), t.unbindSwipeEnd(), n.destroy();
      }), t;
    },
    Images: function Images(t, e, n) {
      var i = new S(),
          r = {
        mount: function mount() {
          this.bind();
        },
        bind: function bind() {
          i.on("dragstart", e.Html.wrapper, this.dragstart);
        },
        unbind: function unbind() {
          i.off("dragstart", e.Html.wrapper);
        },
        dragstart: function dragstart(t) {
          t.preventDefault();
        }
      };
      return n.on("destroy", function () {
        r.unbind(), i.destroy();
      }), r;
    },
    Anchors: function Anchors(t, e, n) {
      var i = new S(),
          r = !1,
          o = !1,
          s = {
        mount: function mount() {
          this._a = e.Html.wrapper.querySelectorAll("a"), this.bind();
        },
        bind: function bind() {
          i.on("click", e.Html.wrapper, this.click);
        },
        unbind: function unbind() {
          i.off("click", e.Html.wrapper);
        },
        click: function click(t) {
          t.stopPropagation(), o && t.preventDefault();
        },
        detach: function detach() {
          if (o = !0, !r) {
            for (var t = 0; t < this.items.length; t++) {
              this.items[t].draggable = !1, this.items[t].setAttribute("data-href", this.items[t].getAttribute("href")), this.items[t].removeAttribute("href");
            }

            r = !0;
          }

          return this;
        },
        attach: function attach() {
          if (o = !1, r) {
            for (var t = 0; t < this.items.length; t++) {
              this.items[t].draggable = !0, this.items[t].setAttribute("href", this.items[t].getAttribute("data-href"));
            }

            r = !1;
          }

          return this;
        }
      };
      return d(s, "items", {
        get: function get() {
          return s._a;
        }
      }), n.on("swipe.move", function () {
        s.detach();
      }), n.on("swipe.end", function () {
        e.Transition.after(function () {
          s.attach();
        });
      }), n.on("destroy", function () {
        s.attach(), s.unbind(), i.destroy();
      }), s;
    },
    Controls: function Controls(i, e, t) {
      var n = new S(),
          r = {
        mount: function mount() {
          this._n = e.Html.root.querySelectorAll('[data-glide-el="controls[nav]"]'), this._c = e.Html.root.querySelectorAll('[data-glide-el^="controls"]'), this.addBindings();
        },
        setActive: function setActive() {
          for (var t = 0; t < this._n.length; t++) {
            this.addClass(this._n[t].children);
          }
        },
        removeActive: function removeActive() {
          for (var t = 0; t < this._n.length; t++) {
            this.removeClass(this._n[t].children);
          }
        },
        addClass: function addClass(t) {
          var e = i.settings,
              n = t[i.index];
          n.classList.add(e.classes.activeNav), y(n).forEach(function (t) {
            t.classList.remove(e.classes.activeNav);
          });
        },
        removeClass: function removeClass(t) {
          t[i.index].classList.remove(i.settings.classes.activeNav);
        },
        addBindings: function addBindings() {
          for (var t = 0; t < this._c.length; t++) {
            this.bind(this._c[t].children);
          }
        },
        removeBindings: function removeBindings() {
          for (var t = 0; t < this._c.length; t++) {
            this.unbind(this._c[t].children);
          }
        },
        bind: function bind(t) {
          for (var e = 0; e < t.length; e++) {
            n.on(["click", "touchstart"], t[e], this.click);
          }
        },
        unbind: function unbind(t) {
          for (var e = 0; e < t.length; e++) {
            n.off(["click", "touchstart"], t[e]);
          }
        },
        click: function click(t) {
          t.preventDefault(), e.Run.make(e.Direction.resolve(t.currentTarget.getAttribute("data-glide-dir")));
        }
      };
      return d(r, "items", {
        get: function get() {
          return r._c;
        }
      }), t.on(["mount.after", "move.after"], function () {
        r.setActive();
      }), t.on("destroy", function () {
        r.removeBindings(), r.removeActive(), n.destroy();
      }), r;
    },
    Keyboard: function Keyboard(t, e, n) {
      var i = new S(),
          r = {
        mount: function mount() {
          t.settings.keyboard && this.bind();
        },
        bind: function bind() {
          i.on("keyup", document, this.press);
        },
        unbind: function unbind() {
          i.off("keyup", document);
        },
        press: function press(t) {
          39 === t.keyCode && e.Run.make(e.Direction.resolve(">")), 37 === t.keyCode && e.Run.make(e.Direction.resolve("<"));
        }
      };
      return n.on(["destroy", "update"], function () {
        r.unbind();
      }), n.on("update", function () {
        r.mount();
      }), n.on("destroy", function () {
        i.destroy();
      }), r;
    },
    Autoplay: function Autoplay(e, n, t) {
      var i = new S(),
          r = {
        mount: function mount() {
          this.start(), e.settings.hoverpause && this.bind();
        },
        start: function start() {
          var t = this;
          e.settings.autoplay && l(this._i) && (this._i = setInterval(function () {
            t.stop(), n.Run.make(">"), t.start();
          }, this.time));
        },
        stop: function stop() {
          this._i = clearInterval(this._i);
        },
        bind: function bind() {
          var t = this;
          i.on("mouseover", n.Html.root, function () {
            t.stop();
          }), i.on("mouseout", n.Html.root, function () {
            t.start();
          });
        },
        unbind: function unbind() {
          i.off(["mouseover", "mouseout"], n.Html.root);
        }
      };
      return d(r, "time", {
        get: function get() {
          var t = n.Html.slides[e.index].getAttribute("data-glide-autoplay");
          return b(t || e.settings.autoplay);
        }
      }), t.on(["destroy", "update"], function () {
        r.unbind();
      }), t.on(["run.before", "pause", "destroy", "swipe.start", "update"], function () {
        r.stop();
      }), t.on(["run.after", "play", "swipe.end"], function () {
        r.start();
      }), t.on("update", function () {
        r.mount();
      }), t.on("destroy", function () {
        i.destroy();
      }), r;
    },
    Breakpoints: function Breakpoints(t, e, n) {
      var i = new S(),
          r = t.settings,
          o = z(r.breakpoints),
          s = a({}, r),
          u = {
        match: function match(t) {
          if (void 0 !== window.matchMedia) for (var e in t) {
            if (t.hasOwnProperty(e) && window.matchMedia("(max-width: " + e + "px)").matches) return t[e];
          }
          return s;
        }
      };
      return a(r, u.match(o)), i.on("resize", window, w(function () {
        t.settings = h(r, u.match(o));
      }, t.settings.throttle)), n.on("update", function () {
        o = z(o), s = a({}, r);
      }), n.on("destroy", function () {
        i.off("resize", window);
      }), u;
    }
  };
  return function (t) {
    function e() {
      return r(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, p), o(e, [{
      key: "mount",
      value: function value() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        return function t(e, n, i) {
          null === e && (e = Function.prototype);
          var r = Object.getOwnPropertyDescriptor(e, n);

          if (void 0 === r) {
            var o = Object.getPrototypeOf(e);
            return null === o ? void 0 : t(o, n, i);
          }

          if ("value" in r) return r.value;
          var s = r.get;
          return void 0 !== s ? s.call(i) : void 0;
        }(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "mount", this).call(this, a({}, j, t));
      }
    }]), e;
  }();
});
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * ModuloBox PACKAGED v1.3.0
 * Touch & responsive multimedia Lightbox
 *
 * @author Themeone [https://theme-one.com/]
 * Copyright © 2016 All Rights Reserved.
 */
!function () {
  var t = window,
      e = 0;
  t.requestAnimationFrame = t.requestAnimationFrame || t.webkitRequestAnimationFrame, t.requestAnimationFrame || (t.requestAnimationFrame = function (t) {
    var i = new Date().getTime(),
        s = Math.max(0, 16 - (i - e));
    return t = setTimeout(t, s), e = i + s, t;
  }), t.cancelAnimationFrame || (t.cancelAnimationFrame = function (t) {
    clearTimeout(t);
  });
}(), function (t, e) {
  "function" == typeof define && define.amd ? define("themeone-utils/utils", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e() : t.ThemeoneUtils = e();
}(this, function () {
  var t = {},
      e = window.console;
  return t.error = function (t) {
    "undefined" != typeof e && e.error(t);
  }, t.extend = function (t, e) {
    if (t) if ("object" != _typeof(t)) this.error("Custom options must be an object");else for (var i in e) {
      e.hasOwnProperty(i) && t.hasOwnProperty(i) && (e[i] = t[i]);
    }
    return e;
  }, t.prop = function (t) {
    for (var e = this.createEl(), i = ["", "Webkit", "Moz", "ms", "O"], s = 0, o = i.length; o > s; s++) {
      var n = i[s] ? i[s] + t.charAt(0).toUpperCase() + t.slice(1) : t;
      if (void 0 !== e.style[n]) return n;
    }

    return "";
  }, t.cloneObject = function (t) {
    var e,
        i = {};

    for (e in t) {
      t.hasOwnProperty(e) && (i[e] = t[e]);
    }

    return i;
  }, t.createEl = function (t, e) {
    var i = document.createElement(t || "div");
    return e && (i.className = e), i;
  }, t.camelize = function (t) {
    return t.replace(/-([a-z])/g, function (t) {
      return t[1].toUpperCase();
    });
  }, t.handleEvents = function (t, e, i, s, o) {
    "object" != _typeof(this.event_handlers) && (this.event_handlers = {}), this.event_handlers[s] || (this.event_handlers[s] = t[s].bind(t));
    var n = void 0 === o || o ? "addEventListener" : "removeEventListener";
    i.forEach(function (t) {
      e[n](t, this.event_handlers[s], !1);
    }.bind(this));
  }, t.dispatchEvent = function (t, e, i, s, o) {
    i += e ? "." + e : "", e = s ? [s].concat(o) : [o], t.emitEvent(i, e);
  }, t.throttle = function (t, e) {
    var i = null;
    return function () {
      var s = arguments,
          o = Date.now();
      (!i || o - i >= e) && (i = o, t.apply(this, s));
    };
  }, t.modulo = function (t, e) {
    return (t + e % t) % t;
  }, t.classReg = function (t) {
    return new RegExp("(^|\\s+)" + t + "(\\s+|$)");
  }, t.hasClass = function (t, e) {
    return !!t.className.match(this.classReg(e));
  }, t.addClass = function (t, e) {
    this.hasClass(t, e) || (t.className += (t.className ? " " : "") + e);
  }, t.removeClass = function (t, e) {
    this.hasClass(t, e) && (t.className = t.className.replace(this.classReg(e), " ").replace(/\s+$/, ""));
  }, t.translate = function (t, e, i, s) {
    s = s ? " scale(" + s + "," + s + ")" : "", t.style[this.browser.trans] = this.browser.gpu ? "translate3d(" + (e || 0) + "px, " + (i || 0) + "px, 0)" + s : "translate(" + (e || 0) + "px, " + (i || 0) + "px)" + s;
  }, t.browser = {
    trans: t.prop("transform"),
    gpu: t.prop("perspective") ? !0 : !1
  }, t;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("themeone-event/event", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e() : t.ThemeoneEvent = e();
}("undefined" != typeof window ? window : this, function () {
  var t = function t() {},
      e = t.prototype;

  return e.on = function (t, e) {
    if (!t || !e) return null;
    var i = this._events = this._events || {};
    return i = i[t] = i[t] || [], -1 === i.indexOf(e) && i.push(e), this;
  }, e.off = function (t, e) {
    var i = this._events && this._events[t];
    if (!i || !i.length) return null;
    var s = i.indexOf(e);
    return -1 !== s && i.splice(s, 1), this;
  }, e.emitEvent = function (t, e) {
    var i = this._events && this._events[t];
    if (!i || !i.length) return null;
    var s = 0,
        o = i[s];
    e = e || [];

    for (var n = this._onceEvents && this._onceEvents[t]; o;) {
      var r = n && n[o];
      r && (this.off(t, o), delete n[o]), o.apply(this, e), s += r ? 0 : 1, o = i[s];
    }

    return this;
  }, t;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("themeone-animate/animate", ["themeone-utils/utils", "themeone-event/event"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e(require("themeone-utils"), require("themeone-event")) : t.ThemeoneAnimate = e(t.ThemeoneUtils, t.ThemeoneEvent);
}(this, function (t, e) {
  var i = function i(t, e, _i, s) {
    this.element = t, this.defaults = e, this.forces = {
      friction: _i || .28,
      attraction: s || .028
    }, this.resetAnimate();
  },
      s = i.prototype = Object.create(e.prototype);

  return s.updateDrag = function (t) {
    this.move = !0, this.drag = t;
  }, s.releaseDrag = function () {
    this.move = !1;
  }, s.animateTo = function (t) {
    this.attraction = t;
  }, s.startAnimate = function () {
    this.move = !0, this.settle = !1, this.restingFrames = 0, this.RAF || this.animate();
  }, s.stopAnimate = function () {
    this.move = !1, this.restingFrames = 0, this.RAF && (cancelAnimationFrame(this.RAF), this.RAF = !1), this.start = t.cloneObject(this.position), this.velocity = {
      x: 0,
      y: 0,
      s: 0
    };
  }, s.resetAnimate = function () {
    this.stopAnimate(), this.settle = !0, this.drag = t.cloneObject(this.defaults), this.start = t.cloneObject(this.defaults), this.resting = t.cloneObject(this.defaults), this.position = t.cloneObject(this.defaults), this.attraction = t.cloneObject(this.defaults);
  }, s.animate = function () {
    var e = function () {
      if ("undefined" != typeof this.position) {
        var i = t.cloneObject(this.position);
        this.applyDragForce(), this.applyAttractionForce(), t.dispatchEvent(this, "toanimate", "render", this), this.integratePhysics(), this.getRestingPosition(), this.render(100), this.RAF = requestAnimationFrame(e), this.checkSettle(i);
      }
    }.bind(this);

    this.RAF = requestAnimationFrame(e);
  }, s.integratePhysics = function () {
    for (var t in this.position) {
      "undefined" != typeof this.position[t] && (this.position[t] += this.velocity[t], this.position[t] = "s" === t ? Math.max(.1, this.position[t]) : this.position[t], this.velocity[t] *= this.getFrictionFactor());
    }
  }, s.applyDragForce = function () {
    if (this.move) for (var t in this.drag) {
      "undefined" != typeof this.drag[t] && this.applyForce(t, this.drag[t] - this.position[t] - this.velocity[t]);
    }
  }, s.applyAttractionForce = function () {
    if (!this.move) for (var t in this.attraction) {
      "undefined" != typeof this.attraction[t] && this.applyForce(t, (this.attraction[t] - this.position[t]) * this.forces.attraction);
    }
  }, s.getRestingPosition = function () {
    for (var t in this.position) {
      "undefined" != typeof this.position[t] && (this.resting[t] = this.position[t] + this.velocity[t] / (1 - this.getFrictionFactor()));
    }
  }, s.applyForce = function (t, e) {
    this.velocity[t] += e;
  }, s.getFrictionFactor = function () {
    return 1 - this.forces.friction;
  }, s.roundValues = function (t, e) {
    for (var i in t) {
      "undefined" != typeof t[i] && (e = "s" === i ? 100 * e : e, t[i] = Math.round(t[i] * e) / e);
    }
  }, s.checkSettle = function (e) {
    if (!this.move) {
      var i,
          s = 0;

      for (i in this.position) {
        if ("undefined" != typeof this.position[i]) {
          var o = "s" === i ? 1e4 : 100;
          Math.round(this.position[i] * o) === Math.round(e[i] * o) && (s++, s === Object.keys(this.position).length && this.restingFrames++);
        }
      }
    }

    2 < this.restingFrames && (this.stopAnimate(), this.render(1 < this.position.s ? 10 : 1), this.settle = !0, JSON.stringify(this.start) !== JSON.stringify(this.position) && t.dispatchEvent(this, "toanimate", "settle", this));
  }, s.render = function (e) {
    this.roundValues(this.position, e), t.translate(this.element, this.position.x, this.position.y, this.position.s);
  }, i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define(["themeone-utils/utils", "themeone-event/event", "themeone-animate/animate"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && module.exports ? module.exports = e(require("themeone-utils"), require("themeone-event"), require("themeone-animate")) : t.ModuloBox = e(t.ThemeoneUtils, t.ThemeoneEvent, t.ThemeoneAnimate);
}(this, function (t, e, i) {
  var s = 0,
      o = {},
      n = "mobx" + ("1.3.0" + Math.random()).replace(/\D/g, ""),
      r = {
    uid: 0
  },
      a = {
    mediaSelector: ".mobx",
    threshold: 5,
    attraction: {
      slider: .055,
      slide: .018,
      thumbs: .016
    },
    friction: {
      slider: .62,
      slide: .18,
      thumbs: .22
    },
    rightToLeft: !1,
    loop: 3,
    preload: 1,
    unload: !1,
    timeToIdle: 4e3,
    history: !1,
    mouseWheel: !0,
    contextMenu: !0,
    scrollBar: !0,
    fadeIfSettle: !1,
    controls: ["close"],
    prevNext: !0,
    prevNextTouch: !1,
    counterMessage: "[index] / [total]",
    caption: !0,
    autoCaption: !1,
    captionSmallDevice: !0,
    thumbnails: !0,
    thumbnailsNav: "basic",
    thumbnailSizes: {
      1920: {
        width: 110,
        height: 80,
        gutter: 10
      },
      1280: {
        width: 90,
        height: 65,
        gutter: 10
      },
      680: {
        width: 70,
        height: 50,
        gutter: 8
      },
      480: {
        width: 60,
        height: 44,
        gutter: 5
      }
    },
    spacing: .1,
    smartResize: !0,
    overflow: !1,
    loadError: "Sorry, an error occured while loading the content...",
    noContent: "Sorry, no content was found!",
    prevNextKey: !0,
    scrollToNav: !1,
    scrollSensitivity: 15,
    zoomTo: "auto",
    minZoom: 1.2,
    maxZoom: 4,
    doubleTapToZoom: !0,
    scrollToZoom: !1,
    pinchToZoom: !0,
    escapeToClose: !0,
    scrollToClose: !1,
    pinchToClose: !0,
    dragToClose: !0,
    tapToClose: !0,
    shareButtons: "facebook googleplus twitter pinterest linkedin reddit".split(" "),
    shareText: "Share on",
    sharedUrl: "deeplink",
    slideShowInterval: 4e3,
    slideShowAutoPlay: !1,
    slideShowAutoStop: !1,
    countTimer: !0,
    countTimerBg: "rgba(255,255,255,0.25)",
    countTimerColor: "rgba(255,255,255,0.75)",
    mediaelement: !1,
    videoRatio: 16 / 9,
    videoMaxWidth: 1180,
    videoAutoPlay: !1,
    videoThumbnail: !1
  },
      h = function h(e) {
    this.options = t.extend(e, a), this.setVar();
  };

  return e = h.prototype = Object.create(e.prototype), e.init = function () {
    return this.GUID ? o[this.GUID] : (this.GUID = ++s, o[this.GUID] = this, this.createDOM(), this.setAnimation(), this.getGalleries(), void this.openFromQuery());
  }, e.setVar = function () {
    var t = window,
        e = document,
        i = navigator;
    this.pre = "mobx", this.gesture = {}, this.buttons = {}, this.slider = {}, this.slides = {}, this.cells = {}, this.states = {}, this.pointers = [], this.expando = n, this.cache = r, this.dragEvents = this.detectPointerEvents(), this.browser = {
      touchDevice: "ontouchstart" in t || 0 < i.maxTouchPoints || 0 < i.msMaxTouchPoints,
      pushState: "history" in t && "pushState" in history,
      fullScreen: this.detectFullScreen(),
      mouseWheel: "onwheel" in e.createElement("div") ? "wheel" : void 0 !== e.onmousewheel ? "mousewheel" : "DOMMouseScroll"
    }, this.iframeVideo = this.iframeVideo(), this.socialMedia = this.socialMedia();
  }, e.detectPointerEvents = function () {
    var t = navigator;
    return t.pointerEnabled ? {
      start: ["pointerdown"],
      move: ["pointermove"],
      end: ["pointerup", "pointercancel"]
    } : t.msPointerEnabled ? {
      start: ["MSPointerDown"],
      move: ["MSPointerMove"],
      end: ["MSPointerUp", "MSPointerCancel"]
    } : {
      start: ["mousedown", "touchstart"],
      move: ["mousemove", "touchmove"],
      end: ["mouseup", "mouseleave", "touchend", "touchcancel"]
    };
  }, e.detectFullScreen = function () {
    for (var t = ["fullscreenEnabled", "webkitFullscreenEnabled", "mozFullScreenEnabled", "msFullscreenEnabled"], e = 0, i = t.length; i > e; e++) {
      if (document[t[e]]) return {
        element: ["fullscreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"][e],
        request: ["requestFullscreen", "webkitRequestFullscreen", "mozRequestFullScreen", "msRequestFullscreen"][e],
        change: ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"][e],
        exit: ["exitFullscreen", "webkitExitFullscreen", "mozCancelFullScreen", "msExitFullscreen"][e]
      };
    }

    return t = this.options.controls, e = t.indexOf("fullScreen"), e > -1 && t.splice(e, 1), null;
  }, e.iframeVideo = function () {
    return {
      youtube: {
        reg: /(?:www\.)?youtu\.?be(?:\.com)?\/?.*?(?:watch|embed)?(?:.*v=|v\/|watch%3Fv%3D|\/)([\w\-_]+)&?/i,
        url: "https://www.youtube.com/embed/[ID]?enablejsapi=1&rel=0&autoplay=1",
        share: "https://www.youtube.com/watch?v=[ID]",
        poster: "https://img.youtube.com/vi/[ID]/maxresdefault.jpg",
        thumb: "https://img.youtube.com/vi/[ID]/default.jpg",
        play: {
          event: "command",
          func: "playVideo"
        },
        pause: {
          event: "command",
          func: "pauseVideo"
        }
      },
      vimeo: {
        reg: /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/)?(\d+)(?:[a-zA-Z0-9_\-]+)?/i,
        url: "https://player.vimeo.com/video/[ID]?autoplay=1&api=1",
        share: "https://vimeo.com/[ID]",
        poster: "https://vimeo.com/api/v2/video/[ID].json",
        play: {
          event: "command",
          method: "play"
        },
        pause: {
          event: "command",
          method: "pause"
        }
      },
      dailymotion: {
        reg: /(?:www\.)?(?:dailymotion\.com(?:\/embed)(?:\/video|\/hub)|dai\.ly)\/([0-9a-z]+)(?:[\-_0-9a-zA-Z]+#video=(?:[a-zA-Z0-9_\-]+))?/i,
        url: "https://dailymotion.com/embed/video/[ID]?autoplay=1&api=postMessage",
        share: "https://www.dailymotion.com/video/[ID]",
        poster: "https://www.dailymotion.com/thumbnail/video/[ID]",
        thumb: "https://www.dailymotion.com/thumbnail/video/[ID]",
        play: "play",
        pause: "pause"
      },
      wistia: {
        reg: /(?:www\.)?(?:wistia\.(?:com|net)|wi\.st)\/(?:(?:m|medias|projects)|embed\/(?:iframe|playlists))\/([a-zA-Z0-9_\-]+)/i,
        url: "https://fast.wistia.net/embed/iframe/[ID]?version=3&enablejsapi=1&html5=1&autoplay=1",
        share: "https://fast.wistia.net/embed/iframe/[ID]",
        poster: "https://fast.wistia.com/oembed?url=https://home.wistia.com/medias/[ID].json",
        play: {
          event: "cmd",
          method: "play"
        },
        pause: {
          event: "cmd",
          method: "pause"
        }
      }
    };
  }, e.socialMedia = function () {
    return {
      facebook: "https://www.facebook.com/sharer/sharer.php?u=[url]",
      googleplus: "https://plus.google.com/share?url=[url]",
      twitter: "https://twitter.com/intent/tweet?text=[text]&url=[url]",
      pinterest: "https://www.pinterest.com/pin/create/button/?url=[url]&media=[image]&description=[text]",
      linkedin: "https://www.linkedin.com/shareArticle?url=[url]&mini=true&title=[text]",
      reddit: "https://www.reddit.com/submit?url=[url]&title=[text]",
      stumbleupon: "https://www.stumbleupon.com/badge?url=[url]&title=[text]",
      tumblr: "https://www.tumblr.com/share?v=3&u=[url]&t=[text]",
      blogger: "https://www.blogger.com/blog_this.pyra?t&u=[url]&n=[text]",
      buffer: "https://bufferapp.com/add?url=[url]title=[text]",
      digg: "https://digg.com/submit?url=[url]&title=[text]",
      evernote: "https://www.evernote.com/clip.action?url=[url]&title=[text]"
    };
  }, e.createDOM = function () {
    this.DOM = {};

    for (var e = "holder overlay slider item item-inner ui top-bar bottom-bar share-tooltip counter caption caption-inner thumbs-holder thumbs-inner".split(" "), i = 0; i < e.length; i++) {
      this.DOM[t.camelize(e[i])] = t.createEl("div", this.pre + "-" + e[i]);
    }

    this.appendDOM(this.DOM);
  }, e.appendDOM = function (e) {
    var i = this.options;
    e.holder.appendChild(e.overlay), e.holder.appendChild(e.slider), e.holder.appendChild(e.ui);

    for (var s = 0; 5 > s; s++) {
      var o = e.item.cloneNode(!0);
      o.appendChild(e.itemInner.cloneNode(!0)), e.slider.appendChild(o), this.slides[s] = o;
    }

    this.slides.length = e.slider.children.length, this.createUI(e, i), e.holder.setAttribute("tabindex", -1), e.holder.setAttribute("aria-hidden", !0), this.DOM.comment = document.createComment(" ModuloBox (v1.3.0) by Themeone "), document.body.appendChild(this.DOM.comment), t.dispatchEvent(this, "modulobox", "beforeAppendDOM", e), document.body.appendChild(e.holder), e.topBar.height = e.topBar.clientHeight;
  }, e.createUI = function (e, i) {
    var s = i.controls.indexOf("share");

    if (s > -1) {
      for (var o = i.shareButtons, n = o.length; n--;) {
        this.socialMedia.hasOwnProperty(o[n]) || o.splice(n, 1);
      }

      o.length ? (e.ui.appendChild(e.shareTooltip), i.shareText && (e.shareTooltip.appendChild(t.createEl("span")).textContent = i.shareText), this.createButtons(o, e.shareTooltip, "shareOn")) : i.controls.splice(s, 1);
    }

    (i.controls.length || i.counterMessage) && (s = i.controls.indexOf("play"), e.ui.appendChild(e.topBar), i.counterMessage && e.topBar.appendChild(e.counter), 1 > i.slideShowInterval && s > -1 && i.controls.splice(s, 1), i.countTimer && s > -1 && (s = this.DOM.timer = t.createEl("canvas", this.pre + "-timer"), s.setAttribute("width", 48), s.setAttribute("height", 48), e.topBar.appendChild(s)), i.controls.length && (s = i.controls.slice(), this.createButtons(s.reverse(), e.topBar))), (i.caption || i.thumbnails) && (e.ui.appendChild(e.bottomBar), i.caption && e.bottomBar.appendChild(e.caption).appendChild(e.captionInner), i.thumbnails && e.bottomBar.appendChild(e.thumbsHolder).appendChild(e.thumbsInner)), i.prevNext && this.createButtons(["prev", "next"], e.ui);
  }, e.createButtons = function (e, i, s) {
    for (var o = e.length, n = 0; o > n; n++) {
      var r = e[n];
      this.buttons[r] = t.createEl("BUTTON", this.pre + "-" + r.toLowerCase()), i.appendChild(this.buttons[r]), (r && "function" == typeof this[r] || s) && (this.buttons[r].event = s ? s : r, this.buttons[r].action = r, "shareOn" === s && this.buttons[r].setAttribute("title", r.charAt(0).toUpperCase() + r.slice(1)));
    }
  }, e.getGalleries = function () {
    this.galleries = {};
    var e = this.options.mediaSelector,
        i = "";
    if (!e) return !1;

    try {
      i = document.querySelectorAll(e);
    } catch (s) {
      t.error('Your current mediaSelector is not a valid selector: "' + e + '"');
    }

    e = 0;

    for (var o = i.length; o > e; e++) {
      var n = i[e],
          r = {};

      if (r.src = "A" === n.tagName ? n.getAttribute("href") : null, r.src = "IMG" === n.tagName ? n.currentSrc || n.src : r.src, r.src = n.getAttribute("data-src") || r.src, r.src && (this.getMediaAtts(n, r), this.setMediaType(r), r.type)) {
        this.getMediaThumb(n, r), this.getVideoThumb(r), this.getMediaCaption(n, r), this.setMediaCaption(r);
        var a = this.setGalleryName(n);
        this.setGalleryFeatures(a, r), r.index = a.length, a.push(r), this.setMediaEvent(n, a.name, r.index);
      }
    }

    t.dispatchEvent(this, "modulobox", "updateGalleries", this.galleries);
  }, e.addMedia = function (e, i) {
    if (!i || "object" != _typeof(i)) return t.error("No media was found to addMedia() in a gallery"), !1;
    e = "" === e ? 1 : e;
    var s = this.galleries[e];
    s = s ? s : this.galleries[e] = [], s.name = e;

    for (var o = i.length, n = 0; o > n; n++) {
      var r = t.cloneObject(i[n]);
      r.src && (this.setMediaType(r), this.getVideoThumb(r), this.setMediaCaption(r), this.setGalleryFeatures(s, r), r.index = s.length, s.push(r));
    }
  }, e.setMediaType = function (t) {
    if (!(-1 < ["image", "video", "iframe", "HTML"].indexOf(t.type))) {
      t.type = null;
      var e = t.src ? t.src : null,
          i = (e.split(/[?#]/)[0] || e).substr((~-e.lastIndexOf(".") >>> 0) + 2);
      if (/(jpg|jpeg|png|bmp|gif|tif|tiff|jfi|jfif|exif|svg)/i.test(i) || -1 < ["external.xx.fbcdn", "drscdn.500px.org"].indexOf(e)) t.type = "image", t.src = this.getSrc(e);else if (/(mp4|webm|ogv)/i.test(i)) t.type = "video", t.format = "html5";else {
        var s,
            o = this.iframeVideo;

        for (s in o) {
          if (o.hasOwnProperty(s) && (i = e.match(o[s].reg)) && i[1]) {
            e = o[s], t.type = "video", t.format = s, t.share = e.share.replace("[ID]", i[1]), t.src = e.url.replace("[ID]", i[1]), t.pause = e.pause, t.play = e.play, this.options.videoThumbnail && (t.poster = !t.poster && e.poster ? e.poster.replace("[ID]", i[1]) : t.poster, t.thumb = !t.thumb && e.poster ? e.poster.replace("[ID]", i[1]) : t.thumb);
            break;
          }
        }
      }
    }
  }, e.getSrc = function (t) {
    var e = (t || "").split(/,/),
        i = e.length,
        s = 0;
    if (1 >= i) return t;

    for (var o = 0; i > o; o++) {
      var n = e[o].replace(/\s+/g, " ").trim().split(/ /),
          r = parseFloat(n[1]) || 0;
      ("w" === (n[1] ? n[1].slice(-1) : null) && screen.width >= r && r > s || !r || 0 === o) && (s = r, t = n[0]);
    }

    return t;
  }, e.getMediaAtts = function (t, e) {
    var i = this.options.autoCaption,
        s = this.getAttr(t),
        o = t.firstElementChild;
    o = "IMG" !== t.tagName && o && "IMG" === o.tagName ? o : t, e.type = e.type ? e.type : s.type || t.getAttribute("data-type"), e.title = s.title || t.getAttribute("data-title") || (i ? o.title : null), e.desc = s.desc || t.getAttribute("data-desc") || (i ? o.alt : null), e.thumb = s.thumb || t.getAttribute("data-thumb"), e.poster = this.getSrc(s.poster || t.getAttribute("data-poster")), e.width = s.width || t.getAttribute("data-width"), e.height = s.height || t.getAttribute("data-height"), e.title === e.desc && (e.desc = null);
  }, e.getMediaThumb = function (t, e) {
    var i = t.getElementsByTagName("img");
    !e.thumb && i[0] && (e.thumb = i[0].src);
  }, e.getVideoThumb = function (t) {
    if (this.options.videoThumbnail && "video" === t.type && "html5" !== t.format) {
      var e = t.poster && -1 < t.poster.indexOf(".json"),
          i = t.thumb && -1 < t.thumb.indexOf(".json");

      if (e || i) {
        e = e ? t.poster : t.thumb;
        var s = new XMLHttpRequest();
        s.onload = function (e) {
          e = e.target.responseText, e = JSON.parse(e), (e = e.hasOwnProperty(0) ? e[0] : e) && (t.poster = e.thumbnail_large || e.thumbnail_url, t.dom && (t.dom.style.backgroundImage = 'url("' + t.poster + '")'), i && (e = e.thumbnail_small || e.thumbnail_url, "object" == _typeof(t.thumb) ? t.thumb.style.backgroundImage = 'url("' + e + '")' : t.thumb = e));
        }.bind(this), s.open("GET", encodeURI(e), !0), setTimeout(function () {
          s.send();
        }, 0);
      }
    }
  }, e.getMediaCaption = function (t, e) {
    var i = t.nextElementSibling;
    i && "FIGCAPTION" === i.tagName && (i = i.innerHTML, e.title ? e.desc || (e.desc = i) : e.title = i);
  }, e.setMediaCaption = function (t) {
    t.title = t.title ? '<div class="' + this.pre + '-title">' + t.title.trim() + "</div>" : "", t.desc = t.desc ? '<div class="' + this.pre + '-desc">' + t.desc.trim() + "</div>" : "", t.caption = t.title + t.desc;
  }, e.getGalleryName = function (t) {
    for (var e = 0; t && 2 > e;) {
      if ((t = t.parentNode) && "FIGURE" === t.tagName && t.parentNode) return t.parentNode.getAttribute("id");
      e++;
    }
  }, e.setGalleryName = function (t) {
    var e = this.getAttr(t).rel || t.getAttribute("data-rel");
    return e = (e = e ? e : this.getGalleryName(t)) ? e : Object.keys(this.galleries).length + 1, t = (t = this.galleries[e]) ? t : this.galleries[e] = [], t.name = e, t;
  }, e.setGalleryFeatures = function (t, e) {
    t.zoom || "image" !== e.type || (t.zoom = !0), t.download || "image" !== e.type && "html5" !== e.format || (t.download = !0);
  }, e.setMediaEvent = function (t, e, i) {
    t.mobxListener && t.removeEventListener("click", t.mobxListener, !1), t.mobxListener = this.open.bind(this, e, i), t.addEventListener("click", t.mobxListener, !1);
  }, e.open = function (e, i, s) {
    return s && (s.preventDefault(), s.stopPropagation()), this.GUID ? this.galleries.hasOwnProperty(e) ? this.galleries[e].length ? this.galleries[e][i] ? (t.dispatchEvent(this, "modulobox", "beforeOpen", e, i), this.slides.index = i, this.gallery = this.galleries[e], this.gallery.name = e, this.gallery.index = i, this.gallery.loaded = !1, this.removeContent(), this.wrapAround(), this.hideScrollBar(), this.setSlider(), this.setThumbs(), this.setCaption(), this.setMedia(this.options.preload), this.updateMediaInfo(), this.replaceState(), this.setControls(), this.bindEvents(!0), this.show(), this.options.videoAutoPlay && this.appendVideo(), this.options.slideShowAutoPlay && -1 < this.options.controls.indexOf("play") && (!this.options.videoAutoPlay || "video" !== this.galleries[e][i].type) && this.startSlideShow(), this.states.zoom = !1, void (this.states.open = !0)) : (t.error("Sorry, no media was found for the current media index: " + i), !1) : (t.error("Sorry, no media was found for the current gallery."), !1) : (t.error('This gallery name : "' + e + '", does not exist!'), !1) : !1;
  }, e.openFromQuery = function () {
    var t = this.getQueryString(window.location.search);
    t.hasOwnProperty("guid") && t.hasOwnProperty("mid") && !1 === this.open(decodeURIComponent(t.guid), decodeURIComponent(t.mid) - 1) && this.replaceState(!0);
  }, e.show = function () {
    var e = this.DOM.holder,
        i = this.options.rightToLeft ? "add" : "remove";
    e.setAttribute("aria-hidden", !1), t.removeClass(e, this.pre + "-idle"), t.removeClass(e, this.pre + "-panzoom"), t.removeClass(e, this.pre + "-will-close"), t[i + "Class"](e, this.pre + "-rtl"), t.addClass(e, this.pre + "-open");
  }, e.close = function (e) {
    e && e.preventDefault(), e = this.DOM.holder;
    var i = this.gallery;
    t.dispatchEvent(this, "modulobox", "beforeClose", i ? i.name : "undefined", i ? i.index : "undefined"), this.states.fullScreen && (this.exitFullScreen(), t.removeClass(e, this.pre + "-fullscreen")), this.share(), this.stopSlideShow(), this.pauseVideo(), this.bindEvents(!1), this.replaceState(!0), this.hideScrollBar(), e.setAttribute("aria-hidden", !0), t.removeClass(e, this.pre + "-open"), this.states.open = !1;
  }, e.setControls = function () {
    var t = this.gallery,
        e = this.options,
        i = this.buttons;
    this.DOM.counter && (this.DOM.counter.style.display = 1 < t.initialLength ? "" : "none"), -1 < e.controls.indexOf("play") && (i.play.style.display = 1 < t.initialLength ? "" : "none"), -1 < e.controls.indexOf("zoom") && (i.zoom.style.display = t.zoom ? "" : "none"), -1 < e.controls.indexOf("download") && (i.download.style.display = t.download ? "" : "none"), this.setPrevNextButtons();
  }, e.setPrevNextButtons = function () {
    if (this.options.prevNext) {
      var t = 680 > this.slider.width && this.browser.touchDevice && !this.options.prevNextTouch;
      this.buttons.prev.style.display = this.buttons.next.style.display = 1 < this.gallery.length && !t ? "" : "none";
    }
  }, e.setCaption = function () {
    this.states.caption = !(!this.options.captionSmallDevice && (480 >= this.slider.width || 480 >= this.slider.height)), this.DOM.caption.style.display = this.states.caption ? "" : "none";
  }, e.hideScrollBar = function () {
    if (!this.options.scrollBar) {
      var t = this.states.open;
      document.body.style.overflow = document.documentElement.style.overflow = "undefined" !== t && t ? "" : "hidden";
    }
  }, e.bindEvents = function (e) {
    var i,
        s,
        o = window,
        n = document,
        r = this.options,
        a = this.DOM.holder,
        h = this.buttons;

    for (s in h) {
      h.hasOwnProperty(s) && t.handleEvents(this, "share" !== s ? h[s] : o, ["click", "touchend"], h[s].event, e);
    }

    t.handleEvents(this, a, this.dragEvents.start, "touchStart", e), t.handleEvents(this, o, ["keydown"], "keyDown", e), t.handleEvents(this, o, ["resize", "orientationchange"], "resize", e), t.handleEvents(this, a, ["transitionend", "webkitTransitionEnd", "oTransitionEnd", "otransitionend", "MSTransitionEnd"], "opened"), t.handleEvents(this, a, ["touchend"], "disableZoom", e), this.browser.fullScreen && t.handleEvents(this, n, [this.browser.fullScreen.change], "toggleFullScreen", e), r.history && t.handleEvents(this, o, ["mouseout"], "mouseOut", e), 0 < r.timeToIdle && t.handleEvents(this, a, ["mousemove"], "mouseMove", e), r.contextMenu || t.handleEvents(this, a, ["contextmenu"], "contextMenu", e), r.mouseWheel || this.disableScroll(e), r.scrollToZoom ? i = "scrollToZoom" : r.scrollToNav ? i = "scrollToNav" : r.scrollToClose && (i = "scrollToClose"), i && t.handleEvents(this, a, [this.browser.mouseWheel], i, e);
  }, e.opened = function (e) {
    if ("visibility" === e.propertyName && e.target === this.DOM.holder) {
      e = this.gallery.name;
      var i = this.gallery.index;
      this.states.open ? t.dispatchEvent(this, "modulobox", "afterOpen", e, i) : (this.removeContent(), t.dispatchEvent(this, "modulobox", "afterClose", e, i));
    }
  }, e.mouseOut = function (t) {
    t = t ? t : window.event, (t = t.relatedTarget || t.toElement) && "HTML" !== t.nodeName || this.replaceState();
  }, e.mouseMove = function () {
    var e = this.DOM.holder,
        i = this.pre + "-idle";
    clearTimeout(this.states.idle), this.states.idle = setTimeout(function () {
      t.hasClass(e, this.pre + "-open-tooltip") || t.addClass(e, i);
    }.bind(this), this.options.timeToIdle), t.removeClass(e, i);
  }, e.contextMenu = function (t) {
    var e = t.target,
        i = e.tagName;
    e = e.className, ("IMG" === i || "VIDEO" === i || -1 < e.indexOf(this.pre + "-video") || -1 < e.indexOf(this.pre + "-thumb-bg") || e === this.pre + "-thumb") && t.preventDefault();
  }, e.disableScroll = function (t) {
    var e = document,
        i = window,
        s = function s(t) {
      return this.isEl(t) && (t = t || i.event, t.preventDefault) ? (t.preventDefault(), t.returnValue = !1) : void 0;
    };

    i.onwheel = i.ontouchmove = i.onmousewheel = e.onmousewheel = e.onmousewheel = t ? s.bind(this) : null;
  }, e.scrollToZoom = function (t) {
    if (this.isEl(t)) {
      var e = this.normalizeWheel(t);

      if (e && e.deltaY) {
        var i = this.getCell();
        i = i.attraction.s || i.position.s, i = Math.min(this.options.maxZoom, Math.max(1, i - Math.abs(e.deltaY) / e.deltaY)), this.stopSlideShow(), this.zoomTo(t.clientX, t.clientY, Math.round(10 * i) / 10);
      }
    }
  }, e.scrollToNav = function (t) {
    this.isEl(t) && (t = this.normalizeWheel(t)) && t.delta && this[0 > t.delta * this.isRTL() ? "prev" : "next"]();
  }, e.scrollToClose = function (t) {
    this.isEl(t) && (t.preventDefault(), this.close());
  }, e.disableZoom = function (t) {
    for (var e = t.target; e;) {
      if (-1 < ["VIDEO", "INPUT", "A"].indexOf(e.tagName)) return;
      e = e.parentElement;
    }

    t.preventDefault();
  }, e.resize = function (e) {
    this.DOM.topBar.height = this.DOM.topBar.clientHeight, this.share(), this.setSlider(), this.setThumbsPosition(), this.setCaption(), this.resizeMedia(), this.updateMediaInfo(), this.setPrevNextButtons(), this.states.zoom = !1, t.removeClass(this.DOM.holder, this.pre + "-panzoom"), t.dispatchEvent(this, "modulobox", "resize", e);
  }, e.resizeMedia = function () {
    for (var t = this.slides, e = 0; e < t.length && this.gallery; e++) {
      var i = this.gallery[t[e].media];
      i && (i.dom && i.dom.loaded || i.dom && -1 < ["video", "iframe", "HTML"].indexOf(i.type)) && this.setMediaSize(i, t[e]);
    }
  }, e.isEl = function (t) {
    return t = t.target.className, t = "string" == typeof t ? t : t.baseVal, -1 < t.indexOf(this.pre);
  }, e.isZoomable = function () {
    var t = this.getMedia(),
        e = !1;
    return "image" === t.type && t.dom && t.dom.size && 1 < t.dom.size.scale && (e = !0), this.DOM.holder.setAttribute("data-zoom", e), e;
  }, e.isDownloadable = function () {
    var t = this.getMedia(),
        e = !0;
    return "image" !== t.type && "html5" !== t.format && (e = !1), this.DOM.holder.setAttribute("data-download", e), e;
  }, e.isRTL = function () {
    return this.options.rightToLeft ? -1 : 1;
  }, e.addAttr = function (t, e) {
    if ("undefined" == typeof t[this.expando]) {
      var i = this.cache.uid++;
      t[this.expando] = i, this.cache[i] = {};
    } else i = t[this.expando];

    for (var s in e) {
      e.hasOwnProperty(s) && (this.cache[i][s] = e[s]);
    }
  }, e.getAttr = function (t) {
    return this.cache[t[this.expando]] || {};
  }, e.getThumbHeight = function () {
    var t = this.thumbs;
    return 0 < t.height && 0 < t.width ? t.height + 2 * Math.min(10, t.gutter) : 0;
  }, e.getMedia = function () {
    var t = this.gallery;
    return t ? t[t.index] : null;
  }, e.getCell = function () {
    var e = this.slides;
    return e = t.modulo(e.length, e.index), this.cells[e];
  }, e.removeContent = function () {
    for (var t = 0; t < this.slides.length; t++) {
      var e = this.slides[t];
      this.unloadMedia(e), this.removeMedia(e), e.index = e.media = null;
    }

    this.removeMedia(this.DOM.thumbsHolder);
  }, e.getQueryString = function (t) {
    var e = {};
    return t.substr(1).split("&").forEach(function (t) {
      t = t.split("="), e[decodeURIComponent(t[0])] = 1 < t.length ? decodeURIComponent(t[1]) : "";
    }), e;
  }, e.setQueryString = function (t) {
    var e = window.location.search,
        i = this.getQueryString(e);
    e = decodeURI(e);

    for (var s in t) {
      if (t.hasOwnProperty(s)) {
        var o = encodeURIComponent(t[s]);

        if (i.hasOwnProperty(s)) {
          var n = i[s];
          o ? e = e.replace(s + "=" + n, s + "=" + o) : (e = e.replace("&" + s + "=" + n, ""), e = e.replace(s + "=" + n, ""));
        } else e = o ? e + (e ? "&" : "?") + s + "=" + o : e.replace(s + "=", "");
      }
    }

    return t = [location.protocol, "//", location.host, location.pathname].join(""), e = e.substr(1) ? e : e.substr(1), encodeURI(t + e);
  }, e.replaceState = function (e) {
    if ((this.options.history || e) && this.browser.pushState && !this.states.push) {
      var i = window.history.state;

      if (e = {
        guid: e ? "" : this.gallery.name,
        mid: e ? "" : t.modulo(this.gallery.initialLength, this.gallery.index) + 1
      }, !i || i.mid !== e.mid) {
        i = this.setQueryString(e);

        try {
          window.history.replaceState(e, "", i);
        } catch (s) {
          this.options.history = !1, t.error("SecurityError: A history state object with origin 'null' cannot be created. Please run the script on a server.");
        }
      }
    }

    this.states.push = !1;
  }, e.normalizeWheel = function (t) {
    var e,
        i,
        s = t || window.event,
        o = null;
    return t.preventDefault(), "detail" in s && (i = -1 * s.detail), "wheelDelta" in s && (i = -1 * s.wheelDelta), "wheelDeltaY" in s && (i = -1 * s.wheelDeltaY), "wheelDeltaX" in s && (e = -1 * s.wheelDeltaX), "deltaY" in s && (i = s.deltaY), "deltaX" in s && (e = -1 * s.deltaX), 1 === s.deltaMode ? (e *= 40, i *= 40) : 2 === s.deltaMode && (e *= 100, i *= 100), t = Math.abs(e) > Math.abs(i) ? e : i, t = Math.min(100, Math.max(-100, t)), Math.abs(t) < this.options.scrollSensitivity ? (this.states.prevDelta = t, o) : (s = +new Date(), (Math.abs(t) > Math.abs(this.states.prevDelta) || 60 < s - this.states.prevScroll) && (o = {
      deltaX: e,
      deltaY: i,
      delta: t
    }), this.states.prevDelta = t, this.states.prevScroll = s, o);
  }, e.share = function (e) {
    if (!e || "VIDEO" !== e.target.tagName) {
      var i = this.DOM.holder,
          s = this.pre + "-open-tooltip",
          o = e ? e.target.className : null,
          n = t.hasClass(i, s) ? "remove" : "add";
      ("remove" !== n || o === this.pre + "-share" && e) && o !== this.pre + "-share" || ("add" === n && this.setShareTooltip(), t[n + "Class"](i, s));
    }
  }, e.shareOn = function (e) {
    var i = e.target.action,
        s = this.gallery,
        o = this.getMedia();

    if (e = "image" === o.type ? o.src : o.poster, i = this.socialMedia[i]) {
      "page" === this.options.sharedUrl ? s = [location.protocol, "//", location.host, location.pathname].join("") : "deeplink" === this.options.sharedUrl || -1 < ["iframe", "HTML"].indexOf(o.type) ? s = this.setQueryString({
        guid: s.name,
        mid: s.index + 1
      }) : (s = o.src.replace(/\s/g, "").split(",")[0], "video" === o.type && "html5" !== o.format && (s = o.share));
      var n = t.createEl("a");
      n.href = e, e = n.href, n.href = s, s = n.href, n = t.createEl("div"), n.innerHTML = o.caption, o = (n.textContent || n.innerText).replace(/\s+/g, " ").trim() || "", (i = i.replace("[url]", encodeURIComponent(s)).replace("[image]", encodeURIComponent(e)).replace("[text]", encodeURIComponent(o || document.title))) && window.open(i, this.pre + "_share", "status=0,resizable=1,location=1,toolbar=0,width=626,height=436,top=" + Math.round(window.screenY + (window.outerHeight - 436) / 2) + ",left=" + Math.round(window.screenX + (window.outerWidth - 626) / 2));
    } else t.error("This social share media does not exist");

    return !1;
  }, e.setShareTooltip = function () {
    if (-1 < this.options.controls.indexOf("share")) {
      var t = "right",
          e = this.DOM.shareTooltip,
          i = e.clientWidth,
          s = this.buttons.share.getBoundingClientRect();
      i = s.left - i + s.width / 2 + 20, 0 > i && (t = "left", i = s.left + s.width / 2 - 20), e.setAttribute("data-position", t), e.style.top = this.DOM.topBar.height + 6 + "px", e.style.left = i + "px";
    }
  }, e.download = function () {
    if (!this.isDownloadable()) return !1;
    var t = this.getMedia().src.replace(/\s/g, "").split(",")[0],
        e = document.createElement("a");
    e.href = t, e.download = new Date().getTime(), e.setAttribute("target", "_blank"), document.body.appendChild(e), e.click(), document.body.removeChild(e);
  }, e.fullScreen = function () {
    document[this.browser.fullScreen.element] ? this.exitFullScreen() : this.requestFullScreen();
  }, e.toggleFullScreen = function () {
    var e = this.DOM.holder,
        i = document[this.browser.fullScreen.element];
    i ? i === e && (this.setShareTooltip(), this.states.fullScreen = !0, t.addClass(e, this.pre + "-fullscreen")) : (this.share(), this.states.fullScreen = !1, t.removeClass(e, this.pre + "-fullscreen")), this.videoFullScreen();
  }, e.requestFullScreen = function () {
    var t = this.browser.fullScreen.request;
    document.documentElement[t] && this.DOM.holder[t]();
  }, e.exitFullScreen = function () {
    var t = this.browser.fullScreen.exit;
    document[t] && document[t]();
  }, e.play = function () {
    this.states.play ? this.stopSlideShow() : this.startSlideShow();
  }, e.startSlideShow = function () {
    var e = 0,
        i = this.gallery,
        s = this.options,
        o = this.states.loop,
        n = s.slideShowAutoStop,
        r = Math.max(120, s.slideShowInterval),
        a = s.countTimer,
        h = a && this.DOM.timer ? this.DOM.timer.getContext("2d") : null,
        l = function (t) {
      if (t = t ? t : +new Date(), e = e ? e : t, o && !n || i.index !== i.initialLength - 1) {
        if (a && h) {
          var d = Math.PI / 180 * Math.min(1, (t - e + r) / r - 1) * 360;
          h.clearRect(0, 0, 48, 48), this.timerProgress(h, s.countTimerBg, 100), this.timerProgress(h, s.countTimerColor, d);
        }

        t >= e + r && (e = t, this.slideTo(this.slides.index + 1, !0)), this.timer = requestAnimationFrame(l);
      } else this.stopSlideShow();
    }.bind(this);

    t.addClass(this.DOM.holder, this.pre + "-autoplay"), this.states.play = !0, this.timer = requestAnimationFrame(l);
  }, e.stopSlideShow = function () {
    cancelAnimationFrame(this.timer), t.removeClass(this.DOM.holder, this.pre + "-autoplay"), this.states.play = !1;
  }, e.timerProgress = function (t, e, i) {
    var s = 1.5 * Math.PI;
    t.strokeStyle = e, t.lineWidth = 5, t.beginPath(), t.arc(24, 24, 18, s, s + i, !1), t.stroke();
  }, e.appendVideo = function () {
    var e = this.getMedia();

    if ("video" === e.type) {
      if (t.addClass(e.dom, this.pre + "-loading"), t.removeClass(e.dom, this.pre + "-playing"), !e.video) {
        if ("html5" === e.format) {
          e.video = t.createEl("video"), e.video.setAttribute("controls", ""), e.video.setAttribute("autoplay", "");

          for (var i = e.src.replace(/\s/g, "").split(","), s = 0; s < i.length; s++) {
            var o = document.createDocumentFragment(),
                n = t.createEl("source"),
                r = /^.+\.([^.]+)$/.exec(i[s]);
            r && -1 < ["mp4", "webm", "ogv"].indexOf(r[1]) && (n.src = i[s], n.setAttribute("type", "video/" + ("ogv" === r[1] ? "ogg" : r[1])), o.appendChild(n)), e.video.appendChild(o);
          }
        } else e.format && (e.video = t.createEl("iframe"), e.video.src = e.src, e.video.setAttribute("frameborder", 0), e.video.setAttribute("allowfullscreen", ""));

        e.video.setAttribute("width", "100%"), e.video.setAttribute("height", "100%");
      }

      e.dom.firstChild || (e.dom.appendChild(e.video), "html5" !== e.format && (e.video.loaded = !1)), this.playVideo(e);
    }
  }, e.onVideoLoaded = function (e) {
    e.video.loaded = !0, t.removeClass(e.dom, this.pre + "-loading"), t.addClass(e.dom, this.pre + "-playing"), this.cloneVideo(e);
  }, e.cloneVideo = function (e) {
    if (this.states.loop && "html5" === e.format) for (var i = this.gallery, s = i.length, o = i.initialLength, n = t.modulo(o, e.index), r = 0; s > r; r++) {
      t.modulo(o, i[r].index) === n && i[r].index !== e.index && (i[r].video = e.video);
    }
  }, e.videoFullScreen = function () {
    var t = this.getMedia(),
        e = this.states.fullScreen;
    "video" === t.type && "html5" !== t.format && t.video && t.video[e ? "removeAttribute" : "setAttribute"]("allowfullscreen", "");
  }, e.playVideo = function (e) {
    if (e.video.loaded) {
      if (e.video.getClientRects(), t.removeClass(e.dom, this.pre + "-loading"), t.addClass(e.dom, this.pre + "-playing"), "html5" !== e.format) {
        if (e.play) {
          var i = "object" == _typeof(e.play) ? JSON.stringify(e.play) : String(e.play);
          e.video.contentWindow.postMessage(i, "*");
        }
      } else e.video.error || ("function" == typeof MediaElementPlayer && "undefined" != typeof jQuery && this.options.mediaelement ? (i = "VIDEO" === e.video.tagName ? e.video : e.video.getElementsByTagName("video")[0], i.player && i.player.setControlsSize(), i.play()) : e.video.play());
    } else {
      var s = this;
      "undefined" == typeof jQuery || "function" != typeof MediaElementPlayer || e.play || !this.options.mediaelement || e.video.player ? e.video.onload || (e.video.onload = e.video.onerror = e.video.onloadedmetadata = function () {
        e.dom.firstChild && (s.onVideoLoaded(e), s.videoFullScreen());
      }, e.video.src = e.src.replace(/\s/g, "").split(",")[0]) : MediaElementPlayer(e.video, {
        features: "playpause stop current progress duration volume fullscreen".split(" "),
        videoVolume: "horizontal",
        startVolume: .8,
        keyActions: !1,
        enableKeyboard: !1,
        iPadUseNativeControls: !0,
        iPhoneUseNativeControls: !0,
        AndroidUseNativeControls: !0,
        success: function success(t) {
          t.addEventListener("loadeddata", function () {
            if (e.video = e.dom.lastChild, e.video) {
              var t = e.video.previousSibling;
              t && t.parentNode && t.parentNode.removeChild(t), s.onVideoLoaded(e);
            }
          }, e, !1);
        },
        error: function error() {
          s.onVideoLoaded(e);
        }
      });
    }
  }, e.pauseVideo = function () {
    var e = this.getMedia();
    if (e && "video" === e.type && e.video) if (t.removeClass(e.dom, this.pre + "-playing"), e.video.loaded) {
      if ("html5" === e.format) "function" == typeof MediaElementPlayer && "undefined" != typeof jQuery && this.options.mediaelement ? ("VIDEO" === e.video.tagName ? e.video : e.video.getElementsByTagName("video")[0]).pause() : e.video.pause();else if (e.pause && "dailymotion" !== e.format) {
        var i = "object" == _typeof(e.pause) ? JSON.stringify(e.pause) : String(e.pause);
        e.video.contentWindow.postMessage(i, "*");
      } else e.dom.innerHTML = "", e.video = null;
    } else e.dom.innerHTML = "", t.removeClass(e.dom, this.pre + "-loading");
  }, e.insertMedia = function (t, e) {
    var i = this.gallery[t];
    i && ("undefined" == typeof i.index && (i.index = this.gallery.indexOf(i)), this.buildMedia(i), this.appendMedia(i, e), this.loadMedia(i, e));
  }, e.buildMedia = function (e) {
    if ("undefined" == typeof e.dom) {
      switch (e.type) {
        case "image":
          e.dom = t.createEl("img", this.pre + "-img"), e.dom.src = e.src;
          break;

        case "video":
          e.dom = t.createEl("div", this.pre + "-video"), e.poster ? e.dom.style.backgroundImage = 'url("' + e.poster + '")' : e.dom.loaded = !0;
          break;

        case "iframe":
          e.dom = t.createEl("iframe", this.pre + "-iframe"), e.dom.setAttribute("allowfullscreen", ""), e.dom.setAttribute("frameborder", 0), e.dom.src = e.src;
          break;

        case "HTML":
          var i = document.querySelector(e.src);
          e.dom = t.createEl("div", this.pre + "-html"), e.dom.appendChild(t.createEl("div", this.pre + "-html-inner")), e.dom.firstChild.innerHTML = i ? i.innerHTML : null, e.src = i ? i : "", e.dom.loaded = !0;
      }

      e.type && e.src || (e.dom = t.createEl("div", this.pre + "-error"), e.dom.textContent = this.options.noContent, e.dom.loaded = !0, e.dom.error = !0, t.dispatchEvent(this, "modulobox", "noContent", this.gallery.name, parseInt(e.index, 10)));
    }
  }, e.appendMedia = function (e, i) {
    var s = this.slides[i],
        o = s.firstChild;

    if (o.childElementCount) {
      var n = o.lastChild,
          r = o.firstChild;
      r.style.visibility = "", e.dom !== n && o[1 === o.childElementCount ? "appendChild" : "replaceChild"](e.dom, n);
    } else n = document.createDocumentFragment(), r = t.createEl("div", this.pre + "-loader"), n.appendChild(r), n.appendChild(e.dom), o.appendChild(n);

    s.media = e.index;
  }, e.loadMedia = function (e, i) {
    if (e.dom.loaded) this.showMedia(e, i);else {
      var s = this,
          o = "iframe" === e.type ? e.dom : e.dom.img = new Image(),
          n = function n() {
        e.dom.error || t.dispatchEvent(s, "modulobox", "loadComplete", s.gallery.name, parseInt(e.index, 10)), e.dom.loaded = "iframe" !== e.type ? !0 : !1, s.showMedia(e, i);
      };

      o.onload = n, o.onerror = function (o) {
        "video" !== e.type && (e.dom = t.createEl("p", s.pre + "-error"), e.dom.textContent = s.options.loadError, e.dom.error = !0, s.appendMedia(e, i)), t.dispatchEvent(s, "modulobox", "loadError", s.gallery.name, parseInt(e.index, 10)), n();
      }, o.src = "video" === e.type ? e.poster : e.src;
    }
  }, e.unloadMedia = function (t) {
    this.gallery && (t = this.gallery[t.media]) && t.dom && (!this.options.unload || "image" !== t.type || t.dom.loaded || t.dom.complete || t.dom.naturalWidth ? "video" === t.type && "html5" !== t.format && t.dom.firstChild && (t.video = null, t.dom.removeChild(t.dom.firstChild)) : (t.dom.onload = null, t.dom.onerror = null, t.dom.src = "", t.dom.img && (t.dom.img.onload = null, t.dom.img.onerror = null, t.dom.img.src = "", delete t.dom.img), delete t.dom));
  }, e.removeMedia = function (t) {
    if (t = t.firstChild) for (; t.firstChild;) {
      t.removeChild(t.firstChild);
    }
  }, e.showMedia = function (e, i) {
    var s = this.slider;

    if (!this.options.fadeIfSettle || s.settle || e.dom.revealed) {
      s = this.slides[i];
      var o = this.gallery,
          n = s.firstChild.firstChild,
          r = this.options.preload;
      this.setMediaSize(e, s), e.index === o.index && this.isZoomable(), t.addClass(e.dom, this.pre + "-media-loaded"), e.dom.revealed = !0, s.media === e.index && (n.style.visibility = "hidden", o.loaded += 1, o.loaded === r && 4 > r && this.setMedia(r + 2)), "iframe" === e.type && (e.dom.loaded = !1);
    }
  }, e.setMediaSize = function (t, e) {
    var i = t.dom,
        s = this.slider,
        o = i.viewport,
        n = this.getThumbHeight();
    i.error || (o && o.width === s.width && o.height === s.height - n || (this.getCaptionHeight(t, e), this.getMediaSize(t, e), this.fitMediaSize(t, e), this.setMediaOffset(t, e)), s = i.style, s.width = i.size.width + "px", s.height = i.size.height + "px", s.left = i.offset.left + "px", s.top = i.offset.top + "px");
  }, e.getCaptionHeight = function (t, e) {
    var i = this.DOM.captionInner,
        s = this.DOM.topBar.height,
        o = i.innerHTML,
        n = this.getThumbHeight();
    this.options.caption && this.states.caption && t.caption ? (i.innerHTML = t.caption, i.height = Math.max(s, parseInt(i.clientHeight, 10)) || s, i.innerHTML = o) : i.height = n ? 0 : s, e.width = this.slider.width, e.height = this.slider.height - s - i.height - n;
  }, e.getMediaSize = function (t, e) {
    var i = t.dom.size = {};

    switch (t.type) {
      case "image":
        i.width = t.dom.naturalWidth, i.height = t.dom.naturalHeight;
        break;

      case "video":
        i.width = this.options.videoMaxWidth, i.height = i.width / this.options.videoRatio;
        break;

      case "iframe":
        i.width = t.width ? t.width : 680 < e.width ? .8 * e.width : e.width, i.height = t.height ? t.height : e.height;
        break;

      case "HTML":
        i.width = t.width ? t.width : e.width, i.height = t.height ? t.height : e.height;
    }
  }, e.fitMediaSize = function (t, e) {
    var i,
        s,
        o = this.slider,
        n = this.options,
        r = n.zoomTo,
        a = t.dom.size,
        h = a.width / a.height,
        l = this.getThumbHeight(),
        d = 480 >= o.width || 680 >= o.height,
        u = 0 > ["video", "iframe", "HTML"].indexOf(t.type),
        p = [e.height];
    (n.smartResize && d || n.overflow) && u && p.unshift(o.height - l), p.forEach(function (t) {
      (!s || s < o.height - l) && (i = Math.min(a.width, h * t), i = i > e.width ? e.width : Math.round(i), s = Math.ceil(1 / h * i), s = 2 > s % t ? t : s);
    }), d = Number((a.width / i).toFixed(3)), t.dom.size = {
      width: i,
      height: s,
      scale: d >= n.minZoom ? Math.min(n.maxZoom, "auto" === r ? d : r) : 1
    };
  }, e.setMediaOffset = function (t, e) {
    var i = t.dom.size,
        s = this.slider,
        o = this.DOM.topBar.height,
        n = this.getThumbHeight(),
        r = 0;
    i.height <= e.height && (r = o + .5 * (e.height - i.height)), t.dom.offset = {
      top: 0 > r ? 0 : Math.round(r),
      left: Math.round(.5 * (e.width - i.width))
    }, t.dom.viewport = {
      width: s.width,
      height: s.height - n
    };
  }, e.mediaViewport = function (t) {
    var e = this.getMedia();
    if (!e.dom || !e.dom.size) return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    var i = e.dom.size,
        s = e.dom.offset,
        o = this.slider.height;
    e = this.slider.width;
    var n = .5 * (o - i.height),
        r = 2 * s.top - n;
    n = .5 * (n - r), r = n * t - 2 * n - r, s = i.width / 2 * (t - 1) - s.left;
    var a = i.height * t <= o ? n * t : -i.height / 2 * (t - 1) + o - i.height + r;
    return o = i.height * t <= o ? n * t : i.height / 2 * (t - 1) + r, {
      top: 1 >= t ? 0 : Math.round(a),
      bottom: 1 >= t ? 0 : Math.round(o),
      left: i.width * t < e ? 0 : Math.round(s),
      right: i.width * t < e ? 0 : Math.round(-s)
    };
  }, e.setMedia = function (e) {
    var i = this.gallery,
        s = this.slides,
        o = this.states.loop,
        n = this.isRTL(),
        r = Math.round(-n * this.slider.position.x / s.width),
        a = i.initialLength - 1,
        h = 0;
    n = [];
    var l;

    if (!e && !i.loaded) {
      for (l = e = 0; l < s.length; l++) {
        s[l].firstChild.childElementCount && e++;
      }

      e += 2, i.loaded = this.options.preload;
    }

    switch (e) {
      case 0:
      case 1:
        n = [0];
        break;

      case 2:
      case 3:
        n = [-1, 0, 1];
        break;

      default:
        e = 5, n = [-2, -1, 0, 1, 2];
    }

    for (o || (l = r + n[e - 1], e = r + n[0], h = 0 > e ? -e : 0, h = l > a ? a - l : h), n = n.map(function (e) {
      return t.modulo(i.length, e + h + r);
    }), l = 0; l < s.length; l++) {
      a = s[l], e = t.modulo(i.length, a.index), !o && a.index > e || !(-1 < n.indexOf(e)) || a.media === e || (this.unloadMedia(a), this.insertMedia(e, l));
    }
  }, e.updateMediaInfo = function () {
    var e = this.gallery;
    e.index = t.modulo(e.length, this.slides.index), this.isZoomable(), this.isDownloadable(), this.updateCounter(), this.updateCaption(), this.updateThumbs(), t.dispatchEvent(this, "modulobox", "updateMedia", this.getMedia());
  }, e.setThumbs = function () {
    var e = this.thumbs,
        i = this.gallery.initialLength,
        s = this.DOM.thumbsHolder;
    if (!this.options.thumbnails || 2 > i) this.DOM.caption.style.bottom = 0, s.style.visibility = "hidden", s.style.height = 0, e.height = e.gutter = 0;else {
      var o = this.options.thumbnailSizes,
          n = Math.max(window.innerWidth, Math.max(screen.width, screen.height));
      s = 0;
      var r = Object.keys(o).sort(function (t, e) {
        return t - e;
      });

      for (e = 0; e < r.length; e++) {
        var a = r[e],
            h = Math.ceil((e === r.length - 1 ? n : Math.min(n, a)) / (o[a].width + o[a].gutter) * 2);
        if (isFinite(h) && h > s && (s = h), a >= n) break;
      }

      for (o = document.createDocumentFragment(), i = i > 50 ? Math.min(s, i) : i, e = 0; i > e; e++) {
        s = t.createEl("div", this.pre + "-thumb"), o.appendChild(s);
      }

      this.DOM.thumbsInner.appendChild(o), this.setThumbsPosition();
    }
  }, e.thumbClick = function (e) {
    e = e.target, t.hasClass(e, this.pre + "-thumb") || (e = e.parentNode), 0 <= parseInt(e.index, 10) && this.slideTo(e.index);
  }, e.loadThumb = function (e, i) {
    var s = this.gallery[i];

    if (!s.thumb || "object" != _typeof(s.thumb)) {
      var o = s.thumb;
      s.thumb = t.createEl("div", this.pre + "-thumb-bg"), s.thumb.style.backgroundImage = o && 0 > o.indexOf(".json") ? "url(" + o + ")" : null, "video" === s.type && (t.addClass(s.thumb, this.pre + "-thumb-video"), t.addClass(s.thumb, this.pre + "-thumb-loaded"));
    }

    if (e[e.firstChild ? "replaceChild" : "appendChild"](s.thumb, e.firstChild), e.media = i, o) {
      var n = new Image();
      n.onload = function () {
        t.addClass(s.thumb, this.pre + "-thumb-loaded");
      }.bind(this), n.src = o;
    }
  }, e.updateThumbs = function () {
    var e = this.gallery;

    if (this.options.thumbnails && !(2 > e.initialLength)) {
      e = this.thumbs;
      var i = this.getThumbPosition(e);
      e.stopAnimate(), i === e.position.x ? this.shiftThumbs(e) : Math.abs(i - e.position.x) > 50 * e.size ? (this.DOM.thumbsHolder.style.visibility = "hidden", e.position.x = i, t.translate(this.DOM.thumbsInner, i, 0), this.renderThumbs(e), this.DOM.thumbsHolder.style.visibility = "") : (e.startAnimate(), e.releaseDrag(), e.animateTo({
        x: i
      }));
    }
  }, e.updateCaption = function () {
    if (this.options.caption) {
      var t = this.getMedia();
      t = t.caption ? t.caption : "";
      var e = this.DOM.captionInner;
      e.innerHTML !== t && (e.innerHTML = t);
    }
  }, e.updateCounter = function () {
    if (this.options.counterMessage) {
      var e = this.gallery,
          i = e.initialLength;
      e = t.modulo(i, e.index), i = this.options.counterMessage.replace("[index]", e + 1).replace("[total]", i), e = this.DOM.counter, e.textContent !== i && (e.textContent = i);
    }
  }, e.wrapAround = function () {
    var e = this.options.loop,
        i = this.gallery,
        s = i.length;

    if (i.initialLength || (i.initialLength = s), this.states.loop = e && s >= e ? !0 : !1, this.states.loop && s < this.slides.length) {
      e = Math.ceil(this.slides.length / s) * s - s;

      for (var o = 0; e > o; o++) {
        var n = s + o;
        i[n] = t.cloneObject(i[t.modulo(s, o)]), i[n].index = n;
      }
    }
  }, e.setSlider = function () {
    var t = this.slider,
        e = this.slides;
    this.setSizes(t, e), this.setSliderPosition(t, e), this.setSlidesPositions(e), this.DOM.overlay.style.opacity = 1;
  }, e.setSizes = function (t, e) {
    t.width = document.body.clientWidth, t.height = window.innerHeight, e.width = t.width + Math.round(t.width * this.options.spacing);
  }, e.setSlidesPositions = function (t) {
    for (var e = 0; e < t.length; e++) {
      t[e].position = null, this.setCellPosition(e);
    }

    this.shiftSlides();
  }, e.setThumbsPosition = function () {
    if (this.options.thumbnails && !(2 > this.gallery.initialLength)) {
      for (var e, i = this.thumbs, s = this.slider, o = this.DOM.thumbsHolder, n = this.DOM.thumbsInner, r = this.options.thumbnailSizes, a = this.options.rightToLeft, h = Object.keys(r).sort(function (t, e) {
        return e - t;
      }), l = Math.max.apply(null, h), d = window.innerWidth, u = 0; u < h.length; u++) {
        e = Number(h[u]), e >= d && (l = e);
      }

      i.width = Number(r[l].width), i.gutter = Number(r[l].gutter), i.height = Number(r[l].height), i.size = i.width + i.gutter, i.length = this.gallery.initialLength, r = i.length * i.size, i.bound = {
        left: 0,
        right: r > s.width ? s.width - r : 0
      }, a && (i.bound.right = r > s.width ? s.width - i.size : r - i.size, i.bound.left = r - i.size), "centered" === this.options.thumbnailsNav && (i.bound = {
        left: r > s.width ? Math.floor(.5 * s.width - .5 * i.size) : Math.floor(.5 * r - .5 * i.size),
        right: r > s.width ? Math.ceil(.5 * s.width - r + .5 * i.size) : -Math.ceil(.5 * r - .5 * i.size)
      }, a && (i.bound.right = i.bound.left, i.bound.left = i.bound.left + r - i.size)), i.resetAnimate(), h = this.getThumbPosition(i), i.position.x = h, t.translate(n, h, 0), h = this.getThumbHeight(), o.style.visibility = h ? "" : "hidden", o.style.height = h ? h + "px" : "", n.style.height = h ? i.height + Math.min(10, i.gutter) + "px" : "", n.style.width = i.length * i.size + "px", n.style.right = r > s.width && a ? "auto" : "";
    }
  }, e.getThumbPosition = function (e) {
    var i = this.slider,
        s = this.gallery,
        o = this.options.thumbnailsNav,
        n = this.isRTL(),
        r = 0 > n ? "right" : "left";
    return s = t.modulo(s.initialLength, s.index), i = .5 * i.width - .5 * e.size, s = e.bound[r] - s * e.size * n, s = e.bound[r] ? s + (0 > n && "centered" !== o ? -i : 0) : s + i, Math.max(e.bound.right, Math.min(e.bound.left, s));
  }, e.setCellPosition = function (e) {
    this.cells[e].resetAnimate(), t.translate(this.slides[e].children[0], 0, 0, 1);
  }, e.setSliderPosition = function (e, i) {
    var s = this.options.rightToLeft,
        o = -i.index * i.width;
    o = s ? -o : o, e.resetAnimate(), e.position.x = e.attraction.x = o, e.bound = {
      left: 0,
      right: -(this.gallery.length - 1) * i.width
    }, s && (e.bound.left = -e.bound.right, e.bound.right = 0), t.translate(this.DOM.slider, o, 0);
  }, e.setAnimation = function () {
    var t = this.DOM.slider,
        e = this.options.friction,
        s = this.options.attraction;
    this.slider = new i(t, {
      x: 0,
      y: 0
    }, Math.min(Math.max(e.slider, 0), 1), Math.min(Math.max(s.slider, 0), 1)), this.slider.on("settle.toanimate", this.settleSider.bind(this)), this.slider.on("render.toanimate", this.renderSlider.bind(this)), t = t.children;

    for (var o = t.length, n = 0; o > n; n++) {
      this.cells[n] = new i(t[n].children[0], {
        x: 0,
        y: 0,
        s: 1
      }, Math.min(Math.max(e.slide, 0), 1), Math.min(Math.max(s.slide, 0), 1)), this.cells[n].on("settle.toanimate", this.settleCell.bind(this)), this.cells[n].on("render.toanimate", this.renderCell.bind(this));
    }

    this.thumbs = new i(this.DOM.thumbsInner, {
      x: 0
    }, Math.min(Math.max(e.thumbs, 0), 1), Math.min(Math.max(s.thumbs, 0), 1)), this.thumbs.on("settle.toanimate", this.settleThumbs.bind(this)), this.thumbs.on("render.toanimate", this.renderThumbs.bind(this));
  }, e.settleSider = function (e) {
    if (t.dispatchEvent(this, "modulobox", "sliderSettled", e.position), this.states.open && (this.setMedia(), this.replaceState()), this.options.fadeIfSettle) for (var i = this.slides, s = 0; s < i.length; s++) {
      e = this.gallery[i[s].media], e.dom.loaded && this.showMedia(e, s);
    }
  }, e.settleCell = function (e) {
    var i = this.gesture;
    i.closeBy && t.dispatchEvent(this, "modulobox", "panYSettled", null, e.position), (i.closeBy && !1 === i.canClose || !i.closeBy) && t.dispatchEvent(this, "modulobox", "panZoomSettled", null, e.position);
  }, e.settleThumbs = function (e) {
    t.dispatchEvent(this, "modulobox", "thumbsSettled", null, e.position);
  }, e.renderSlider = function (e) {
    this.shiftSlides();
    var i = this.isRTL(),
        s = this.gallery.initialLength;
    e = t.modulo(s, -i * e.position.x / this.slides.width), t.dispatchEvent(this, "modulobox", "sliderProgress", null, Math.min(1, Math.max(0, (e > s - .5 ? 0 : e) / (s - 1))));
  }, e.renderCell = function (e) {
    if (this.willClose(e), "panY" === this.gesture.type || this.gesture.closeBy || "dragSlider" === this.gesture.type && 0 !== e.position.y) {
      var i = 1 - Math.abs(e.position.y) / (.5 * this.slider.height);
      t.dispatchEvent(this, "modulobox", "panYProgress", null, i);
    }

    "panY" !== this.gesture.type && 1 !== e.position.s && (i = e.position.s, t.dispatchEvent(this, "modulobox", "panZoomProgress", null, i));
  }, e.renderThumbs = function (e) {
    this.shiftThumbs(e), t.dispatchEvent(this, "modulobox", "thumbsProgress", null, e.bound.left !== e.bound.right ? (e.bound.left - e.position.x) / (e.bound.left - e.bound.right) : 0);
  }, e.touchStart = function (e) {
    var i = e.target,
        s = i.tagName,
        o = i.className;
    3 !== e.which && i !== this.buttons.play && this.stopSlideShow(), 3 === e.which || !this.isEl(e) || -1 < ["BUTTON", "VIDEO", "INPUT", "A"].indexOf(s) || ("IMG" === s && 1 < this.gallery.length && t.addClass(this.DOM.holder, this.pre + "-dragging"), e.preventDefault(), t.hasClass(this.DOM.holder, this.pre + "-open-tooltip") || (this.pointers.length || (this.gesture.canClose = void 0, t.handleEvents(this, window, this.dragEvents.move, "touchMove"), t.handleEvents(this, window, this.dragEvents.end, "touchEnd")), this.addPointer(e), 0 > o.indexOf("-thumb") ? (this.slider.stopAnimate(), e = this.getCell(), (1 !== Math.round(100 * e.position.s) / 100 || 2 === this.pointers.length || this.gesture.closeBy) && e.stopAnimate()) : this.thumbs.stopAnimate(), this.gestures("start")));
  }, e.touchMove = function (e) {
    this.updatePointer(e);
    var i = this.gesture,
        s = this.pointers.length,
        o = this.isSliderSettle();
    this.switchPointers(), this.gestures("move"), i.type ? (this[i.type](e), t.dispatchEvent(this, "modulobox", i.type + "Move", e, i), i.move = !0) : (2 === s && o || Math.abs(i.dx) > this.options.threshold || Math.abs(i.dy) > this.options.threshold) && (i.sx += i.dx, i.sy += i.dy, i.canZoom = this.isZoomable(), i.closeBy = !1, i.type = Math.abs(i.dx) < Math.abs(i.dy) / 2 ? !1 : "dragSlider", i.type = this.options.dragToClose && !i.type && o ? "panY" : i.type, i.type = (this.options.pinchToZoom || this.states.zoom) && i.canZoom && o && (2 === s || this.states.zoom) ? "panZoom" : i.type, i.type = this.options.pinchToClose && 1 > i.scale && o && 2 === s ? "panZoom" : i.type, i.type = -1 < e.target.className.indexOf("-thumb") ? "dragThumbs" : i.type, "dragSlider" === i.type && this.setMedia(), -1 < ["dragSlider", "dragThumbs"].indexOf(i.type) && (s = this.getCell(), s.startAnimate(), s.releaseDrag(), s.animateTo({
      x: 0,
      y: 0,
      s: 1
    })), "dragSlider" !== i.type && (s = this.slider, o = this.slides, -this.isRTL() * s.position.x !== o.index * o.width && (s.startAnimate(), s.releaseDrag())), i.type && (this.pauseVideo(), t.dispatchEvent(this, "modulobox", i.type + "Start", e, i), (1 < this.gallery.length || "dragSlider" !== i.type) && t.addClass(this.DOM.holder, this.pre + "-dragging")));
  }, e.touchEnd = function (e) {
    if (this.deletePointer(e), !this.pointers.length) {
      if (t.removeClass(this.DOM.holder, this.pre + "-dragging"), t.handleEvents(this, window, this.dragEvents.move, "touchMove", !1), t.handleEvents(this, window, this.dragEvents.end, "touchEnd", !1), this.isSliderSettle()) {
        var i = e.target.className;
        if (t.hasClass(e.target, this.pre + "-video")) this.appendVideo();else if (this.options.tapToClose && !this.states.zoom && (i === this.pre + "-item-inner" || i === this.pre + "-top-bar") && Math.abs(this.gesture.dx) < this.options.threshold) return void this.close();
        "IMG" === e.target.tagName && this.doubleTap(e);
      }

      this.options.thumbnails && !this.gesture.move && this.thumbClick(e), i = this.gesture.type + "End", this.gesture.type && "function" == typeof this[i] && (this[i](e), t.dispatchEvent(this, "modulobox", i, e, this.gesture)), this.gesture.type = this.gesture.move = !1, this.states.open && (e = this.getCell(), e.settle || (e.startAnimate(), e.releaseDrag()), e = this.slider, e.settle || (e.startAnimate(), e.releaseDrag()));
    }
  }, e.switchPointers = function () {
    if ("panZoom" === this.gesture.type && 1 === this.pointers.length && 0 !== this.gesture.distance) {
      var t = this.getCell();
      t.stopAnimate(), t.startAnimate(), this.gesture.move = !1, this.gestures("start"), this.gestures("move");
    }
  }, e.doubleTap = function (e) {
    e.preventDefault(), e = this.mapPointer(e);
    var i = e[0].clientX,
        s = e[0].clientY;
    "undefined" != typeof this.tap && 350 > +new Date() - this.tap.delay && 30 > Math.abs(this.tap.deltaX - i) && 30 > Math.abs(this.tap.deltaY - s) ? (this.states.tapIdle && clearTimeout(this.states.tapIdle), this.options.doubleTapToZoom && this.zoomTo(i, s), this.tap = void 0) : (this.browser.touchDevice && this.options.timeToIdle && !this.states.idle && (this.states.tapIdle = setTimeout(function () {
      var e = t.hasClass(this.DOM.holder, this.pre + "-idle") ? "remove" : "add";
      t[e + "Class"](this.DOM.holder, this.pre + "-idle");
    }.bind(this), 350)), this.tap = {
      delay: +new Date(),
      deltaX: e[0].clientX,
      deltaY: e[0].clientY
    });
  }, e.isSliderSettle = function () {
    if (this.gesture.type) return !1;
    var t = this.isRTL(),
        e = this.slides,
        i = e.width;
    return 3 >= Math.abs(t * this.slider.position.x + e.index * i) / i * 100 ? !0 : !1;
  }, e.mapPointer = function (t) {
    return t.touches ? t.changedTouches : [t];
  }, e.addPointer = function (t) {
    t = this.mapPointer(t);

    for (var e = 0; e < t.length; e++) {
      if (2 > this.pointers.length && -1 === ["dragSlider", "panY", "dragThumbs"].indexOf(this.gesture.type)) {
        var i = t[e],
            s = void 0 !== i.pointerId ? i.pointerId : i.identifier;
        this.getPointer(s) || (this.pointers[this.pointers.length] = {
          id: s,
          x: Math.round(i.clientX),
          y: Math.round(i.clientY)
        });
      }
    }
  }, e.updatePointer = function (t) {
    t = this.mapPointer(t);

    for (var e = 0; e < t.length; e++) {
      var i = t[e],
          s = this.getPointer(void 0 !== i.pointerId ? i.pointerId : i.identifier);
      s && (s.x = Math.round(i.clientX), s.y = Math.round(i.clientY));
    }
  }, e.deletePointer = function (t) {
    t = this.mapPointer(t);

    for (var e = 0; e < t.length; e++) {
      var i = t[e];
      i = void 0 !== i.pointerId ? i.pointerId : i.identifier;

      for (var s = 0; s < this.pointers.length; s++) {
        this.pointers[s].id === i && this.pointers.splice(s, 1);
      }
    }
  }, e.getPointer = function (t) {
    for (var e in this.pointers) {
      if (this.pointers[e].id === t) return this.pointers[e];
    }

    return null;
  }, e.gestures = function (t) {
    var e = this.gesture,
        i = this.pointers;

    if (i.length) {
      if (e.direction = e.x ? i[0].x > e.x ? 1 : -1 : 0, e.x = i[0].x, e.y = i[0].y, 2 === i.length) {
        var s = i[1].x;
        i = i[1].y;
        var o = this.getDistance([e.x, e.y], [s, i]);
        e.x -= (e.x - s) / 2, e.y -= (e.y - i) / 2;
      }

      "start" === t ? (e.dx = 0, e.dy = 0, e.sx = e.x, e.sy = e.y, e.distance = o ? o : 0) : (e.dx = e.x - e.sx, e.dy = e.y - e.sy, e.scale = o && e.distance ? o / e.distance : 1);
    }
  }, e.getDistance = function (t, e) {
    var i = e[0] - t[0],
        s = e[1] - t[1];
    return Math.sqrt(i * i + s * s);
  }, e.panY = function () {
    var t = this.getCell();
    t.startAnimate(), t.updateDrag({
      x: t.position.x,
      y: t.start.y + this.gesture.dy,
      s: t.position.s
    });
  }, e.panYEnd = function () {
    var t = this.getCell(),
        e = this.slider.height,
        i = t.resting.y;
    .8 > 1 - Math.abs(i) / (.5 * e) && (e = Math.abs(i) < .5 * e ? Math.abs(i) / i * e * .5 : i, this.close(), t.animateTo({
      x: 0,
      y: e,
      s: e ? t.resting.s : 1
    }), t.startAnimate(), t.releaseDrag());
  }, e.panZoom = function () {
    var t = this.getCell(),
        e = this.gesture,
        i = this.mediaViewport(t.position.s),
        s = Math.min(1.5 * this.options.maxZoom, Math.max(this.options.pinchToClose && e.canClose ? .1 : .6, t.start.s * e.scale)),
        o = t.start.x + e.dx,
        n = t.start.y + e.dy,
        r = e.sx - .5 * this.slider.width,
        a = e.sy - .5 * this.slider.height;
    e.canZoom && (this.options.pinchToZoom || this.states.zoom) || (s = Math.min(1, s)), !this.options.pinchToZoom && this.states.zoom && (s = t.position.s), e.move || 1 !== this.pointers.length || (t.start.x += o > i.left ? o - i.left : o < i.right ? o - i.right : 0, t.start.y += n > i.bottom ? n - i.bottom : n < i.top ? n - i.top : 0), o = e.dx + r + s / t.start.s * (t.start.x - r), n = e.dy + a + s / t.start.s * (t.start.y - a), 1 === this.pointers.length && (o = o > i.left ? .5 * (o + i.left) : o < i.right ? .5 * (o + i.right) : o, n = n > i.bottom ? .5 * (n + i.bottom) : n < i.top ? .5 * (n + i.top) : n), t.startAnimate(), t.updateDrag({
      x: o,
      y: n,
      s: s
    }), this.updateZoom(s);
  }, e.panZoomEnd = function () {
    var t = this.getCell(),
        e = this.gesture,
        i = t.resting.s > this.options.maxZoom ? this.options.maxZoom : 1 > t.resting.s ? 1 : t.resting.s,
        s = this.mediaViewport(i);

    if (Math.round(10 * t.resting.s) / 10 > this.options.maxZoom) {
      var o = e.distance ? e.sx - .5 * this.slider.width : 0,
          n = e.distance ? e.sy - .5 * this.slider.height : 0;
      o = e.dx + o + i / t.start.s * (t.start.x - o), n = e.dy + n + i / t.start.s * (t.start.y - n), o = o > s.left ? s.left : o < s.right ? s.right : o, n = n > s.bottom ? s.bottom : n < s.top ? s.top : n;
    } else o = t.resting.x > s.left ? s.left : t.resting.x < s.right ? s.right : void 0, n = t.resting.y > s.bottom ? s.bottom : t.resting.y < s.top ? s.top : void 0;

    this.options.pinchToClose && .8 > t.resting.s && e.canClose && (i = .3 > t.resting.s ? t.resting.s : .15, o = t.resting.x, n = t.resting.y, this.close()), t.animateTo({
      x: o,
      y: n,
      s: i !== t.resting.s ? i : void 0
    }), t.startAnimate(), t.releaseDrag(), this.updateZoom(t.resting.s);
  }, e.dragThumbs = function () {
    var t = this.thumbs,
        e = t.bound,
        i = t.start.x + this.gesture.dx;
    this.gesture.move || (t.start.x += i > e.left ? i - e.left : i < e.right ? i - e.right : 0, i = t.start.x + this.gesture.dx), i = i > e.left ? .5 * (i + e.left) : i < e.right ? .5 * (i + e.right) : i, t.startAnimate(), t.attraction.x = void 0, t.updateDrag({
      x: i
    });
  }, e.dragThumbsEnd = function () {
    var t = this.thumbs,
        e = t.bound,
        i = t.resting.x;
    i = i > e.left ? e.left : i < e.right ? e.right : i, i !== t.resting.x && t.animateTo({
      x: i
    }), t.startAnimate(), t.releaseDrag();
  }, e.dragSlider = function () {
    if (1 !== this.gallery.length) {
      var t = this.slider,
          e = t.start.x + this.gesture.dx;

      if (!this.states.loop) {
        var i = t.bound;
        this.gesture.move || (t.start.x += e > i.left ? e - i.left : e < i.right ? e - i.right : 0, e = t.start.x + this.gesture.dx), e = e > i.left ? .5 * (e + i.left) : e < i.right ? .5 * (e + i.right) : e;
      }

      t.startAnimate(), t.updateDrag({
        x: e
      });
    }
  }, e.dragSliderEnd = function () {
    if (1 !== this.gallery.length) {
      var t = this.slider,
          e = this.slides,
          i = e.index,
          s = this.isRTL();
      this.getRestingIndex(t.position.x, t.resting.x), i !== e.index && this.updateMediaInfo(), this.slider.animateTo({
        x: -s * e.index * e.width,
        y: void 0,
        s: void 0
      }), t.startAnimate(), t.releaseDrag();
    }
  }, e.getRestingIndex = function (t, e) {
    var i = this.gesture.direction,
        s = this.gallery,
        o = this.slides,
        n = this.gesture.dx,
        r = this.isRTL(),
        a = Math.round(-r * t / o.width),
        h = Math.abs(e - t);
    Math.abs(n) < .5 * o.width && h && (n > 0 && i > 0 ? a -= 1 * r : 0 > n && 0 > i && (a += 1 * r)), i = Math.max(-1, Math.min(1, a - o.index)), (this.states.loop || !(0 > s.index + i || s.index + i > s.length - 1)) && (o.index += i);
  }, e.shiftSlides = function () {
    var e = this.slides,
        i = this.gallery,
        s = this.states.loop,
        o = this.isRTL(),
        n = o * Math.round(-this.slider.position.x / e.width) - 2,
        r = n + 5;

    for (!s && r > i.initialLength - 1 && (n = i.initialLength - 5, r = n + 5), !s && 0 > n && (n = 0, r = 5), i = n; r > i; i++) {
      s = o * i * e.width, n = t.modulo(e.length, i), n = e[n], (n.index !== i || n.position !== s) && (n.index = i, n.position = s, n.style.left = s + "px");
    }

    this.states.open && this.setMedia(3);
  }, e.shiftThumbs = function (e) {
    var i = this.DOM.thumbsInner.children,
        s = this.slider,
        o = this.gallery,
        n = this.isRTL(),
        r = i.length,
        a = t.modulo(o.initialLength, o.index),
        h = Math.max(0, Math.round((-n * e.position.x + n * e.size * r * .25) / e.size) - Math.floor(r / 2)),
        l = h + r,
        d = .5 * s.width,
        u = e.position.x + d;

    for (s = e.position.x - s.width - d, l > o.initialLength && (l = o.initialLength, h = l - r), l === o.initialLength - 1 && r > h - l && (h = o.initialLength - r), o = h; l > o; o++) {
      h = i[t.modulo(r, o)], d = n * o * e.size + .5 * e.gutter;
      var p = this.pre + "-active-thumb",
          m = t.hasClass(h, p);
      (h.index !== o || h.position !== d) && (h.index = o, h.position = d, h.style.left = d + "px"), this.setThumbSize(h, e), -h.position <= u && -h.position >= s && h.media !== o && this.loadThumb(h, o), m && a !== o ? t.removeClass(h, p) : m || a !== o || t.addClass(h, p);
    }
  }, e.setThumbSize = function (t, e) {
    (t.width !== e.width || t.height !== e.height || t.gutter !== e.gutter) && (t.width = e.width, t.height = e.height, t.gutter = e.gutter, t.style.width = e.width + "px", t.style.height = e.height + "px");
  }, e.willClose = function (e) {
    var i = this.DOM.overlay.style.opacity,
        s = this.gesture.canClose,
        o = this.gesture.type,
        n = this.gesture.closeBy,
        r = "panY" === o || "panY" === n;
    1.1 < e.position.s && "undefined" == typeof s ? this.gesture.canClose = !1 : 1 > e.position.s && "undefined" == typeof s && (this.gesture.canClose = !0), this.options.pinchToClose && ("panZoom" === o || "panZoom" === n) && this.gesture.canClose ? (i = e.position.s, this.gesture.closeBy = "panZoom") : r ? (i = 1 - Math.abs(e.position.y) / (.5 * this.slider.height), this.gesture.closeBy = "panY") : i && 1 > i && (i = 1, this.gesture.closeBy = !1), i = i ? Math.max(0, Math.min(1, i)) : 1, t[(.8 >= i || !i ? "add" : "remove") + "Class"](this.DOM.holder, this.pre + "-will-close"), this.DOM.overlay.style.opacity = i;
  }, e.prev = t.throttle(function () {
    this.gesture.move || this.slideTo(this.slides.index - 1 * this.isRTL());
  }, 120), e.next = t.throttle(function () {
    this.gesture.move || this.slideTo(this.slides.index + 1 * this.isRTL());
  }, 120), e.slideTo = function (e, i) {
    var s = this.slides,
        o = this.gallery,
        n = this.DOM.slider,
        r = this.isRTL(),
        a = o.initialLength,
        h = t.modulo(a, e);
    o = t.modulo(a, o.index), o = h - o;
    var l = a - Math.abs(o);
    (this.states.loop || !(0 > e || e > this.gallery.initialLength - 1)) && (this.states.loop && 3 > l && a > 2 * l && (o = 0 > o ? l : -l), h === e && (e = s.index + o), (o = e - s.index) && (this.states.zoom && this.zoom(), this.pauseVideo(), this.share(), i || this.stopSlideShow(), s.index = e, a = this.slider, 2 < Math.abs(o) && (t.addClass(n, this.pre + "-hide"), this.setSliderPosition(a, s), this.setSlidesPositions(s), a.position.x = a.attraction.x = a.position.x + r * s.width * Math.min(2, Math.abs(o)) * Math.abs(o) / o, t.translate(n, a.position.x, 0), n.getClientRects()), this.updateMediaInfo(), t.removeClass(n, this.pre + "-hide"), a.startAnimate(), a.releaseDrag(), a.animateTo({
      x: -r * e * s.width,
      y: 0,
      s: void 0
    })));
  }, e.keyDown = function (t) {
    var e = t.keyCode,
        i = this.options;
    return i.prevNextKey && (37 === e ? this.prev(t) : 39 === e && this.next(t)), 27 === e && i.escapeToClose && this.close(), !i.mouseWheel && -1 < [32, 33, 34, 35, 36, 38, 40].indexOf(e) ? (t.preventDefault(), !1) : void 0;
  }, e.zoom = function () {
    this.zoomTo();
  }, e.zoomTo = function (t, e, i) {
    if (!(!this.isSliderSettle() || !this.isZoomable() && i > 1)) {
      this.gesture.closeBy = !1;
      var s = this.getMedia();
      i = i ? i : this.states.zoom ? 1 : s.dom.size.scale, s = this.getCell();
      var o = this.mediaViewport(i);
      t = t ? t - .5 * this.slider.width : 0, e = e ? e - .5 * this.slider.height : 0, t = i > 1 ? Math.ceil(t + i / s.position.s * (s.position.x - t)) : 0, e = i > 1 ? Math.ceil(e + i / s.position.s * (s.position.y - e)) : 0, s.startAnimate(), s.releaseDrag(), s.animateTo({
        x: t > o.left ? o.left : t < o.right ? o.right : t,
        y: e > o.bottom ? o.bottom : e < o.top ? o.top : e,
        s: i
      }), this.updateZoom(i);
    }
  }, e.updateZoom = function (e) {
    this.states.zoom = e > 1 ? !0 : !1, t[this.states.zoom ? "addClass" : "removeClass"](this.DOM.holder, this.pre + "-panzoom");
  }, e.destroy = function () {
    if (this.GUID) {
      this.states.open && this.close();
      var t = this.options.mediaSelector,
          e = "";

      try {
        e = document.querySelectorAll(t);
      } catch (i) {}

      t = 0;

      for (var s = e.length; s > t; t++) {
        var n = e[t];
        n.mobxListener && n.removeEventListener("click", n.mobxListener, !1);
      }

      for (this.bindEvents(!1), this.slider.resetAnimate(), t = 0; t < this.slides.length; t++) {
        this.cells[t].resetAnimate();
      }

      this.thumbs && this.thumbs.resetAnimate(), this.DOM.holder.parentNode.removeChild(this.DOM.holder), this.DOM.comment.parentNode.removeChild(this.DOM.comment), delete o[this.GUID], delete this.GUID;
    }
  }, "undefined" != typeof jQuery && function (t) {
    t.ModuloBox = function (t) {
      return new h(t);
    };
  }(jQuery), h;
});
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//! moment.js
;

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.moment = factory();
})(this, function () {
  'use strict';

  var hookCallback;

  function hooks() {
    return hookCallback.apply(null, arguments);
  } // This is done to register the method called with moment()
  // without creating circular dependencies.


  function setHookCallback(callback) {
    hookCallback = callback;
  }

  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
  }

  function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
  }

  function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
      return Object.getOwnPropertyNames(obj).length === 0;
    } else {
      var k;

      for (k in obj) {
        if (obj.hasOwnProperty(k)) {
          return false;
        }
      }

      return true;
    }
  }

  function isUndefined(input) {
    return input === void 0;
  }

  function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
  }

  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
  }

  function map(arr, fn) {
    var res = [],
        i;

    for (i = 0; i < arr.length; ++i) {
      res.push(fn(arr[i], i));
    }

    return res;
  }

  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }

  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }

    if (hasOwnProp(b, 'toString')) {
      a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
      a.valueOf = b.valueOf;
    }

    return a;
  }

  function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
  }

  function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidMonth: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      meridiem: null,
      rfc2822: false,
      weekdayMismatch: false
    };
  }

  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }

    return m._pf;
  }

  var some;

  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function some(fun) {
      var t = Object(this);
      var len = t.length >>> 0;

      for (var i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }

      return false;
    };
  }

  function isValid(m) {
    if (m._isValid == null) {
      var flags = getParsingFlags(m);
      var parsedParts = some.call(flags.parsedDateParts, function (i) {
        return i != null;
      });
      var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

      if (m._strict) {
        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
      }

      if (Object.isFrozen == null || !Object.isFrozen(m)) {
        m._isValid = isNowValid;
      } else {
        return isNowValid;
      }
    }

    return m._isValid;
  }

  function createInvalid(flags) {
    var m = createUTC(NaN);

    if (flags != null) {
      extend(getParsingFlags(m), flags);
    } else {
      getParsingFlags(m).userInvalidated = true;
    }

    return m;
  } // Plugins that add properties should also add the key here (null value),
  // so we can properly clone ourselves.


  var momentProperties = hooks.momentProperties = [];

  function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
      to._isAMomentObject = from._isAMomentObject;
    }

    if (!isUndefined(from._i)) {
      to._i = from._i;
    }

    if (!isUndefined(from._f)) {
      to._f = from._f;
    }

    if (!isUndefined(from._l)) {
      to._l = from._l;
    }

    if (!isUndefined(from._strict)) {
      to._strict = from._strict;
    }

    if (!isUndefined(from._tzm)) {
      to._tzm = from._tzm;
    }

    if (!isUndefined(from._isUTC)) {
      to._isUTC = from._isUTC;
    }

    if (!isUndefined(from._offset)) {
      to._offset = from._offset;
    }

    if (!isUndefined(from._pf)) {
      to._pf = getParsingFlags(from);
    }

    if (!isUndefined(from._locale)) {
      to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
      for (i = 0; i < momentProperties.length; i++) {
        prop = momentProperties[i];
        val = from[prop];

        if (!isUndefined(val)) {
          to[prop] = val;
        }
      }
    }

    return to;
  }

  var updateInProgress = false; // Moment prototype object

  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);

    if (!this.isValid()) {
      this._d = new Date(NaN);
    } // Prevent infinite loop in case updateOffset creates new moment
    // objects.


    if (updateInProgress === false) {
      updateInProgress = true;
      hooks.updateOffset(this);
      updateInProgress = false;
    }
  }

  function isMoment(obj) {
    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
  }

  function absFloor(number) {
    if (number < 0) {
      // -0 -> 0
      return Math.ceil(number) || 0;
    } else {
      return Math.floor(number);
    }
  }

  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }

    return value;
  } // compare two arrays, return the number of differences


  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;

    for (i = 0; i < len; i++) {
      if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
        diffs++;
      }
    }

    return diffs + lengthDiff;
  }

  function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
      console.warn('Deprecation warning: ' + msg);
    }
  }

  function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function () {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(null, msg);
      }

      if (firstTime) {
        var args = [];
        var arg;

        for (var i = 0; i < arguments.length; i++) {
          arg = '';

          if (_typeof(arguments[i]) === 'object') {
            arg += '\n[' + i + '] ';

            for (var key in arguments[0]) {
              arg += key + ': ' + arguments[0][key] + ', ';
            }

            arg = arg.slice(0, -2); // Remove trailing comma and space
          } else {
            arg = arguments[i];
          }

          args.push(arg);
        }

        warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
        firstTime = false;
      }

      return fn.apply(this, arguments);
    }, fn);
  }

  var deprecations = {};

  function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(name, msg);
    }

    if (!deprecations[name]) {
      warn(msg);
      deprecations[name] = true;
    }
  }

  hooks.suppressDeprecationWarnings = false;
  hooks.deprecationHandler = null;

  function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
  }

  function set(config) {
    var prop, i;

    for (i in config) {
      prop = config[i];

      if (isFunction(prop)) {
        this[i] = prop;
      } else {
        this['_' + i] = prop;
      }
    }

    this._config = config; // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.

    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
  }

  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
        prop;

    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }

    for (prop in parentConfig) {
      if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
        // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
      }
    }

    return res;
  }

  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }

  var keys;

  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function keys(obj) {
      var i,
          res = [];

      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }

      return res;
    };
  }

  var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
  };

  function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
  }

  var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
  };

  function longDateFormat(key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
      return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
      return val.slice(1);
    });
    return this._longDateFormat[key];
  }

  var defaultInvalidDate = 'Invalid date';

  function invalidDate() {
    return this._invalidDate;
  }

  var defaultOrdinal = '%d';
  var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

  function ordinal(number) {
    return this._ordinal.replace('%d', number);
  }

  var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  };

  function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
  }

  function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
  }

  var aliases = {};

  function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
  }

  function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
  }

  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);

        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }

    return normalizedInput;
  }

  var priorities = {};

  function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
  }

  function getPrioritizedUnits(unitsObj) {
    var units = [];

    for (var u in unitsObj) {
      units.push({
        unit: u,
        priority: priorities[u]
      });
    }

    units.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return units;
  }

  function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }

  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
  var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
  var formatFunctions = {};
  var formatTokenFunctions = {}; // token:    'M'
  // padded:   ['MM', 2]
  // ordinal:  'Mo'
  // callback: function () { this.month() + 1 }

  function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;

    if (typeof callback === 'string') {
      func = function func() {
        return this[callback]();
      };
    }

    if (token) {
      formatTokenFunctions[token] = func;
    }

    if (padded) {
      formatTokenFunctions[padded[0]] = function () {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }

    if (ordinal) {
      formatTokenFunctions[ordinal] = function () {
        return this.localeData().ordinal(func.apply(this, arguments), token);
      };
    }
  }

  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, '');
    }

    return input.replace(/\\/g, '');
  }

  function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
        i,
        length;

    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }

    return function (mom) {
      var output = '',
          i;

      for (i = 0; i < length; i++) {
        output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
      }

      return output;
    };
  } // format date using native date object


  function formatMoment(m, format) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](m);
  }

  function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
      return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;

    while (i >= 0 && localFormattingTokens.test(format)) {
      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }

    return format;
  }

  var match1 = /\d/; //       0 - 9

  var match2 = /\d\d/; //      00 - 99

  var match3 = /\d{3}/; //     000 - 999

  var match4 = /\d{4}/; //    0000 - 9999

  var match6 = /[+-]?\d{6}/; // -999999 - 999999

  var match1to2 = /\d\d?/; //       0 - 99

  var match3to4 = /\d\d\d\d?/; //     999 - 9999

  var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999

  var match1to3 = /\d{1,3}/; //       0 - 999

  var match1to4 = /\d{1,4}/; //       0 - 9999

  var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

  var matchUnsigned = /\d+/; //       0 - inf

  var matchSigned = /[+-]?\d+/; //    -inf - inf

  var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

  var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

  var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
  // any word (or two) characters or numbers including two/three word month in arabic.
  // includes scottish gaelic two word and hyphenated months

  var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
  var regexes = {};

  function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
      return isStrict && strictRegex ? strictRegex : regex;
    };
  }

  function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
      return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
  } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


  function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
      return p1 || p2 || p3 || p4;
    }));
  }

  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  var tokens = {};

  function addParseToken(token, callback) {
    var i,
        func = callback;

    if (typeof token === 'string') {
      token = [token];
    }

    if (isNumber(callback)) {
      func = function func(input, array) {
        array[callback] = toInt(input);
      };
    }

    for (i = 0; i < token.length; i++) {
      tokens[token[i]] = func;
    }
  }

  function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
      config._w = config._w || {};
      callback(input, config._w, config, token);
    });
  }

  function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
      tokens[token](input, config._a, config, token);
    }
  }

  var YEAR = 0;
  var MONTH = 1;
  var DATE = 2;
  var HOUR = 3;
  var MINUTE = 4;
  var SECOND = 5;
  var MILLISECOND = 6;
  var WEEK = 7;
  var WEEKDAY = 8; // FORMATTING

  addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
  });
  addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
  });
  addFormatToken(0, ['YYYY', 4], 0, 'year');
  addFormatToken(0, ['YYYYY', 5], 0, 'year');
  addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

  addUnitAlias('year', 'y'); // PRIORITIES

  addUnitPriority('year', 1); // PARSING

  addRegexToken('Y', matchSigned);
  addRegexToken('YY', match1to2, match2);
  addRegexToken('YYYY', match1to4, match4);
  addRegexToken('YYYYY', match1to6, match6);
  addRegexToken('YYYYYY', match1to6, match6);
  addParseToken(['YYYYY', 'YYYYYY'], YEAR);
  addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
  });
  addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
  }); // HELPERS

  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  }

  function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  } // HOOKS


  hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
  }; // MOMENTS


  var getSetYear = makeGetSet('FullYear', true);

  function getIsLeapYear() {
    return isLeapYear(this.year());
  }

  function makeGetSet(unit, keepTime) {
    return function (value) {
      if (value != null) {
        set$1(this, unit, value);
        hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get(this, unit);
      }
    };
  }

  function get(mom, unit) {
    return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
  }

  function set$1(mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
      if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
      } else {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
      }
    }
  } // MOMENTS


  function stringGet(units) {
    units = normalizeUnits(units);

    if (isFunction(this[units])) {
      return this[units]();
    }

    return this;
  }

  function stringSet(units, value) {
    if (_typeof(units) === 'object') {
      units = normalizeObjectUnits(units);
      var prioritized = getPrioritizedUnits(units);

      for (var i = 0; i < prioritized.length; i++) {
        this[prioritized[i].unit](units[prioritized[i].unit]);
      }
    } else {
      units = normalizeUnits(units);

      if (isFunction(this[units])) {
        return this[units](value);
      }
    }

    return this;
  }

  function mod(n, x) {
    return (n % x + x) % x;
  }

  var indexOf;

  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function indexOf(o) {
      // I know
      var i;

      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }

      return -1;
    };
  }

  function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
      return NaN;
    }

    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
  } // FORMATTING


  addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
  });
  addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
  });
  addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
  }); // ALIASES

  addUnitAlias('month', 'M'); // PRIORITY

  addUnitPriority('month', 8); // PARSING

  addRegexToken('M', match1to2);
  addRegexToken('MM', match1to2, match2);
  addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
  });
  addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
  });
  addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
  });
  addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  }); // LOCALES

  var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
  var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');

  function localeMonths(m, format) {
    if (!m) {
      return isArray(this._months) ? this._months : this._months['standalone'];
    }

    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
  }

  var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');

  function localeMonthsShort(m, format) {
    if (!m) {
      return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
    }

    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
  }

  function handleStrictParse(monthName, format, strict) {
    var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();

    if (!this._monthsParse) {
      // this is not used
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];

      for (i = 0; i < 12; ++i) {
        mom = createUTC([2000, i]);
        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
      return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    } // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse


    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);

      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
      }

      if (!strict && !this._monthsParse[i]) {
        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
      } // test the regex


      if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  } // MOMENTS


  function setMonth(mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
      // No op
      return mom;
    }

    if (typeof value === 'string') {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

        if (!isNumber(value)) {
          return mom;
        }
      }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

    return mom;
  }

  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      hooks.updateOffset(this, true);
      return this;
    } else {
      return get(this, 'Month');
    }
  }

  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }

  var defaultMonthsShortRegex = matchWord;

  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }

      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsShortRegex')) {
        this._monthsShortRegex = defaultMonthsShortRegex;
      }

      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }

  var defaultMonthsRegex = matchWord;

  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }

      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsRegex')) {
        this._monthsRegex = defaultMonthsRegex;
      }

      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
  }

  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;

    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);
      shortPieces.push(this.monthsShort(mom, ''));
      longPieces.push(this.months(mom, ''));
      mixedPieces.push(this.months(mom, ''));
      mixedPieces.push(this.monthsShort(mom, ''));
    } // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.


    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);

    for (i = 0; i < 12; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
    }

    for (i = 0; i < 24; i++) {
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
  }

  function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms); // the date constructor remaps years 0-99 to 1900-1999

    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }

    return date;
  }

  function createUTCDate(y) {
    var date = new Date(Date.UTC.apply(null, arguments)); // the Date.UTC function remaps years 0-99 to 1900-1999

    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }

    return date;
  } // start-of-first-week - start-of-year


  function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
    fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
  } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;

    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }

    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }

  function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;

    if (week < 1) {
      resYear = mom.year() - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
      resWeek = week - weeksInYear(mom.year(), dow, doy);
      resYear = mom.year() + 1;
    } else {
      resYear = mom.year();
      resWeek = week;
    }

    return {
      week: resWeek,
      year: resYear
    };
  }

  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  } // FORMATTING


  addFormatToken('w', ['ww', 2], 'wo', 'week');
  addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

  addUnitAlias('week', 'w');
  addUnitAlias('isoWeek', 'W'); // PRIORITIES

  addUnitPriority('week', 5);
  addUnitPriority('isoWeek', 5); // PARSING

  addRegexToken('w', match1to2);
  addRegexToken('ww', match1to2, match2);
  addRegexToken('W', match1to2);
  addRegexToken('WW', match1to2, match2);
  addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
  }); // HELPERS
  // LOCALES

  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }

  var defaultLocaleWeek = {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6 // The week that contains Jan 6th is the first week of the year.

  };

  function localeFirstDayOfWeek() {
    return this._week.dow;
  }

  function localeFirstDayOfYear() {
    return this._week.doy;
  } // MOMENTS


  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
  }

  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
  } // FORMATTING


  addFormatToken('d', 0, 'do', 'day');
  addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
  });
  addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
  });
  addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
  });
  addFormatToken('e', 0, 0, 'weekday');
  addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

  addUnitAlias('day', 'd');
  addUnitAlias('weekday', 'e');
  addUnitAlias('isoWeekday', 'E'); // PRIORITY

  addUnitPriority('day', 11);
  addUnitPriority('weekday', 11);
  addUnitPriority('isoWeekday', 11); // PARSING

  addRegexToken('d', match1to2);
  addRegexToken('e', match1to2);
  addRegexToken('E', match1to2);
  addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
  });
  addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
  });
  addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
  });
  addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });
  addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
  }); // HELPERS

  function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
      return input;
    }

    if (!isNaN(input)) {
      return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);

    if (typeof input === 'number') {
      return input;
    }

    return null;
  }

  function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
      return locale.weekdaysParse(input) % 7 || 7;
    }

    return isNaN(input) ? null : input;
  } // LOCALES


  var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');

  function localeWeekdays(m, format) {
    if (!m) {
      return isArray(this._weekdays) ? this._weekdays : this._weekdays['standalone'];
    }

    return isArray(this._weekdays) ? this._weekdays[m.day()] : this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
  }

  var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');

  function localeWeekdaysShort(m) {
    return m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
  }

  var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');

  function localeWeekdaysMin(m) {
    return m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
  }

  function handleStrictParse$1(weekdayName, format, strict) {
    var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();

    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];

      for (i = 0; i < 7; ++i) {
        mom = createUTC([2000, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._weekdaysParse, llc);

        if (ii !== -1) {
          return ii;
        }

        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
      return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);

      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
      }

      if (!this._weekdaysParse[i]) {
        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
      } // test the regex


      if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  } // MOMENTS


  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, 'd');
    } else {
      return day;
    }
  }

  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
  }

  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    } // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.


    if (input != null) {
      var weekday = parseIsoWeekday(input, this.localeData());
      return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
      return this.day() || 7;
    }
  }

  var defaultWeekdaysRegex = matchWord;

  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        this._weekdaysRegex = defaultWeekdaysRegex;
      }

      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }

  var defaultWeekdaysShortRegex = matchWord;

  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysShortRegex')) {
        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
      }

      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }

  var defaultWeekdaysMinRegex = matchWord;

  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }

      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysMinRegex')) {
        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
      }

      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }

  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;

    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);
      minp = this.weekdaysMin(mom, '');
      shortp = this.weekdaysShort(mom, '');
      longp = this.weekdays(mom, '');
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.


    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);

    for (i = 0; i < 7; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
  } // FORMATTING


  function hFormat() {
    return this.hours() % 12 || 12;
  }

  function kFormat() {
    return this.hours() || 24;
  }

  addFormatToken('H', ['HH', 2], 0, 'hour');
  addFormatToken('h', ['hh', 2], 0, hFormat);
  addFormatToken('k', ['kk', 2], 0, kFormat);
  addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });
  addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
  });
  addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });

  function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
  }

  meridiem('a', true);
  meridiem('A', false); // ALIASES

  addUnitAlias('hour', 'h'); // PRIORITY

  addUnitPriority('hour', 13); // PARSING

  function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
  }

  addRegexToken('a', matchMeridiem);
  addRegexToken('A', matchMeridiem);
  addRegexToken('H', match1to2);
  addRegexToken('h', match1to2);
  addRegexToken('k', match1to2);
  addRegexToken('HH', match1to2, match2);
  addRegexToken('hh', match1to2, match2);
  addRegexToken('kk', match1to2, match2);
  addRegexToken('hmm', match3to4);
  addRegexToken('hmmss', match5to6);
  addRegexToken('Hmm', match3to4);
  addRegexToken('Hmmss', match5to6);
  addParseToken(['H', 'HH'], HOUR);
  addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
  });
  addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  }); // LOCALES

  function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
  }

  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;

  function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? 'pm' : 'PM';
    } else {
      return isLower ? 'am' : 'AM';
    }
  } // MOMENTS
  // Setting the hour should keep the time, because the user explicitly
  // specified which hour they want. So trying to maintain the same hour (in
  // a new timezone) makes sense. Adding/subtracting hours does not follow
  // this rule.


  var getSetHour = makeGetSet('Hours', true);
  var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
  }; // internal storage for locale config files

  var locales = {};
  var localeFamilies = {};
  var globalLocale;

  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
  } // pick the locale from the array
  // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
  // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


  function chooseLocale(names) {
    var i = 0,
        j,
        next,
        locale,
        split;

    while (i < names.length) {
      split = normalizeLocale(names[i]).split('-');
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split('-') : null;

      while (j > 0) {
        locale = loadLocale(split.slice(0, j).join('-'));

        if (locale) {
          return locale;
        }

        if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
          //the next array item is better than a shallower substring of this one
          break;
        }

        j--;
      }

      i++;
    }

    return globalLocale;
  }

  function loadLocale(name) {
    var oldLocale = null; // TODO: Find a better way to register and load all the locales in Node

    if (!locales[name] && typeof module !== 'undefined' && module && module.exports) {
      try {
        oldLocale = globalLocale._abbr;
        var aliasedRequire = require;
        aliasedRequire('./locale/' + name);
        getSetGlobalLocale(oldLocale);
      } catch (e) {}
    }

    return locales[name];
  } // This function will load locale and then set the global locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.


  function getSetGlobalLocale(key, values) {
    var data;

    if (key) {
      if (isUndefined(values)) {
        data = getLocale(key);
      } else {
        data = defineLocale(key, values);
      }

      if (data) {
        // moment.duration._locale = moment._locale = data;
        globalLocale = data;
      } else {
        if (typeof console !== 'undefined' && console.warn) {
          //warn user if arguments are passed but the locale could not be set
          console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
      }
    }

    return globalLocale._abbr;
  }

  function defineLocale(name, config) {
    if (config !== null) {
      var locale,
          parentConfig = baseConfig;
      config.abbr = name;

      if (locales[name] != null) {
        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
        parentConfig = locales[name]._config;
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          parentConfig = locales[config.parentLocale]._config;
        } else {
          locale = loadLocale(config.parentLocale);

          if (locale != null) {
            parentConfig = locale._config;
          } else {
            if (!localeFamilies[config.parentLocale]) {
              localeFamilies[config.parentLocale] = [];
            }

            localeFamilies[config.parentLocale].push({
              name: name,
              config: config
            });
            return null;
          }
        }
      }

      locales[name] = new Locale(mergeConfigs(parentConfig, config));

      if (localeFamilies[name]) {
        localeFamilies[name].forEach(function (x) {
          defineLocale(x.name, x.config);
        });
      } // backwards compat for now: also set the locale
      // make sure we set the locale AFTER all child locales have been
      // created, so we won't end up with the child locale set.


      getSetGlobalLocale(name);
      return locales[name];
    } else {
      // useful for testing
      delete locales[name];
      return null;
    }
  }

  function updateLocale(name, config) {
    if (config != null) {
      var locale,
          tmpLocale,
          parentConfig = baseConfig; // MERGE

      tmpLocale = loadLocale(name);

      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }

      config = mergeConfigs(parentConfig, config);
      locale = new Locale(config);
      locale.parentLocale = locales[name];
      locales[name] = locale; // backwards compat for now: also set the locale

      getSetGlobalLocale(name);
    } else {
      // pass null for config to unupdate, useful for tests
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }

    return locales[name];
  } // returns locale data


  function getLocale(key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }

    if (!key) {
      return globalLocale;
    }

    if (!isArray(key)) {
      //short-circuit everything else
      locale = loadLocale(key);

      if (locale) {
        return locale;
      }

      key = [key];
    }

    return chooseLocale(key);
  }

  function listLocales() {
    return keys(locales);
  }

  function checkOverflow(m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }

      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }

      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }

      getParsingFlags(m).overflow = overflow;
    }

    return m;
  } // Pick the first defined of two or three arguments.


  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }

    if (b != null) {
      return b;
    }

    return c;
  }

  function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());

    if (config._useUTC) {
      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }

    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  } // convert an array to a date.
  // the array should mirror the parameters below
  // note: all values past the year are optional and will default to the lowest possible value.
  // [year, month, day , hour, minute, second, millisecond]


  function configFromArray(config) {
    var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;

    if (config._d) {
      return;
    }

    currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config);
    } //if the day of the year is set, figure out what it is


    if (config._dayOfYear != null) {
      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

      if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }

      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    } // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything


    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    } // Zero out whatever was not defaulted, including time


    for (; i < 7; i++) {
      config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
    } // Check for 24:00:00.000


    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.

    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
      config._a[HOUR] = 24;
    } // check for mismatching day of week


    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
      getParsingFlags(config).weekdayMismatch = true;
    }
  }

  function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
    w = config._w;

    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
      // how we interpret now (local, utc, fixed offset). So create
      // a now version of current config (take local/utc/offset flags, and
      // create now).

      weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);

      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;
      var curWeek = weekOfYear(createLocal(), dow, doy);
      weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

      week = defaults(w.w, curWeek.week);

      if (w.d != null) {
        // weekday -- low day numbers are considered next week
        weekday = w.d;

        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        // local weekday -- counting starts from beginning of week
        weekday = w.e + dow;

        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        // default to beginning of week
        weekday = dow;
      }
    }

    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  } // iso 8601 regex
  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
  var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
  var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
  var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], // YYYYMM is NOT allowed by the standard
  ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]]; // iso time formats and regexes

  var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];
  var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i; // date from iso format

  function configFromISO(config) {
    var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat;

    if (match) {
      getParsingFlags(config).iso = true;

      for (i = 0, l = isoDates.length; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }

      if (dateFormat == null) {
        config._isValid = false;
        return;
      }

      if (match[3]) {
        for (i = 0, l = isoTimes.length; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            // match[2] should be 'T' or space
            timeFormat = (match[2] || ' ') + isoTimes[i][0];
            break;
          }
        }

        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }

      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }

      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = 'Z';
        } else {
          config._isValid = false;
          return;
        }
      }

      config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  } // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3


  var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

  function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

    if (secondStr) {
      result.push(parseInt(secondStr, 10));
    }

    return result;
  }

  function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);

    if (year <= 49) {
      return 2000 + year;
    } else if (year <= 999) {
      return 1900 + year;
    }

    return year;
  }

  function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }

  function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
      // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
      var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

      if (weekdayProvided !== weekdayActual) {
        getParsingFlags(config).weekdayMismatch = true;
        config._isValid = false;
        return false;
      }
    }

    return true;
  }

  var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
  };

  function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
      return obsOffsets[obsOffset];
    } else if (militaryOffset) {
      // the only allowed military tz is Z
      return 0;
    } else {
      var hm = parseInt(numOffset, 10);
      var m = hm % 100,
          h = (hm - m) / 100;
      return h * 60 + m;
    }
  } // date and time from ref 2822 format


  function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));

    if (match) {
      var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

      if (!checkWeekday(match[1], parsedArray, config)) {
        return;
      }

      config._a = parsedArray;
      config._tzm = calculateOffset(match[8], match[9], match[10]);
      config._d = createUTCDate.apply(null, config._a);

      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

      getParsingFlags(config).rfc2822 = true;
    } else {
      config._isValid = false;
    }
  } // date from iso format or fallback


  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
      config._d = new Date(+matched[1]);
      return;
    }

    configFromISO(config);

    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }

    configFromRFC2822(config);

    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    } // Final attempt, use Input Fallback


    hooks.createFromInputFallback(config);
  }

  hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
  }); // constant that refers to the ISO standard

  hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


  hooks.RFC_2822 = function () {}; // date from string and format string


  function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
      configFromISO(config);
      return;
    }

    if (config._f === hooks.RFC_2822) {
      configFromRFC2822(config);
      return;
    }

    config._a = [];
    getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

    var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0]; // console.log('token', token, 'parsedInput', parsedInput,
      //         'regex', getParseRegexForToken(token, config));

      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));

        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }

        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
        totalParsedInputLength += parsedInput.length;
      } // don't parse if it's not a known token


      if (formatTokenFunctions[token]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        } else {
          getParsingFlags(config).unusedTokens.push(token);
        }

        addTimeToArrayFromToken(token, parsedInput, config);
      } else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token);
      }
    } // add remaining unparsed input length to the string


    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    } // clear _12h flag if hour is <= 12


    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
    configFromArray(config);
    checkOverflow(config);
  }

  function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
      // nothing to do
      return hour;
    }

    if (locale.meridiemHour != null) {
      return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
      // Fallback
      isPm = locale.isPM(meridiem);

      if (isPm && hour < 12) {
        hour += 12;
      }

      if (!isPm && hour === 12) {
        hour = 0;
      }

      return hour;
    } else {
      // this is not supposed to happen
      return hour;
    }
  } // date from string and array of format strings


  function configFromStringAndArray(config) {
    var tempConfig, bestMoment, scoreToBeat, i, currentScore;

    if (config._f.length === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = new Date(NaN);
      return;
    }

    for (i = 0; i < config._f.length; i++) {
      currentScore = 0;
      tempConfig = copyConfig({}, config);

      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }

      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);

      if (!isValid(tempConfig)) {
        continue;
      } // if there is any input that was not parsed add a penalty for that format


      currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
      getParsingFlags(tempConfig).score = currentScore;

      if (scoreToBeat == null || currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }

    extend(config, bestMoment || tempConfig);
  }

  function configFromObject(config) {
    if (config._d) {
      return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
      return obj && parseInt(obj, 10);
    });
    configFromArray(config);
  }

  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));

    if (res._nextDay) {
      // Adding is smart enough around DST
      res.add(1, 'd');
      res._nextDay = undefined;
    }

    return res;
  }

  function prepareConfig(config) {
    var input = config._i,
        format = config._f;
    config._locale = config._locale || getLocale(config._l);

    if (input === null || format === undefined && input === '') {
      return createInvalid({
        nullInput: true
      });
    }

    if (typeof input === 'string') {
      config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
      config._d = input;
    } else if (isArray(format)) {
      configFromStringAndArray(config);
    } else if (format) {
      configFromStringAndFormat(config);
    } else {
      configFromInput(config);
    }

    if (!isValid(config)) {
      config._d = null;
    }

    return config;
  }

  function configFromInput(config) {
    var input = config._i;

    if (isUndefined(input)) {
      config._d = new Date(hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function (obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (isObject(input)) {
      configFromObject(config);
    } else if (isNumber(input)) {
      // from milliseconds
      config._d = new Date(input);
    } else {
      hooks.createFromInputFallback(config);
    }
  }

  function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
      strict = locale;
      locale = undefined;
    }

    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
      input = undefined;
    } // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423


    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
  }

  function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
  }

  var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);

    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  });
  var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
    var other = createLocal.apply(null, arguments);

    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }); // Pick a moment m from moments so that m[fn](other) is true for all
  // other. This relies on the function fn to be transitive.
  //
  // moments should either be an array of moment objects or an array, whose
  // first element is an array of moment objects.

  function pickBy(fn, moments) {
    var res, i;

    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }

    if (!moments.length) {
      return createLocal();
    }

    res = moments[0];

    for (i = 1; i < moments.length; ++i) {
      if (!moments[i].isValid() || moments[i][fn](res)) {
        res = moments[i];
      }
    }

    return res;
  } // TODO: Use [].sort instead?


  function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isBefore', args);
  }

  function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isAfter', args);
  }

  var now = function now() {
    return Date.now ? Date.now() : +new Date();
  };

  var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

  function isDurationValid(m) {
    for (var key in m) {
      if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
        return false;
      }
    }

    var unitHasDecimal = false;

    for (var i = 0; i < ordering.length; ++i) {
      if (m[ordering[i]]) {
        if (unitHasDecimal) {
          return false; // only allow non-integers for smallest unit
        }

        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
          unitHasDecimal = true;
        }
      }
    }

    return true;
  }

  function isValid$1() {
    return this._isValid;
  }

  function createInvalid$1() {
    return createDuration(NaN);
  }

  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

    this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
    minutes * 6e4 + // 1000 * 60
    hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately

    this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.

    this._months = +months + quarters * 3 + years * 12;
    this._data = {};
    this._locale = getLocale();

    this._bubble();
  }

  function isDuration(obj) {
    return obj instanceof Duration;
  }

  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  } // FORMATTING


  function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
      var offset = this.utcOffset();
      var sign = '+';

      if (offset < 0) {
        offset = -offset;
        sign = '-';
      }

      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
    });
  }

  offset('Z', ':');
  offset('ZZ', ''); // PARSING

  addRegexToken('Z', matchShortOffset);
  addRegexToken('ZZ', matchShortOffset);
  addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
  }); // HELPERS
  // timezone chunker
  // '+10:00' > ['10',  '00']
  // '-1530'  > ['-15', '30']

  var chunkOffset = /([\+\-]|\d\d)/gi;

  function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
      return null;
    }

    var chunk = matches[matches.length - 1] || [];
    var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);
    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
  } // Return a moment from input, that is local/utc/zone equivalent to model.


  function cloneWithOffset(input, model) {
    var res, diff;

    if (model._isUTC) {
      res = model.clone();
      diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

      res._d.setTime(res._d.valueOf() + diff);

      hooks.updateOffset(res, false);
      return res;
    } else {
      return createLocal(input).local();
    }
  }

  function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
  } // HOOKS
  // This function will be called whenever a moment is mutated.
  // It is intended to keep the offset in sync with the timezone.


  hooks.updateOffset = function () {}; // MOMENTS
  // keepLocalTime = true means only change the timezone, without
  // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
  // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
  // +0200, so we adjust the time as needed, to be valid.
  //
  // Keeping the time actually adds/subtracts (one hour)
  // from the actual represented time. That is why we call updateOffset
  // a second time. In case it wants us to change the offset again
  // _changeInProgress == true case, then we have to adjust, because
  // there is no such time in the given timezone.


  function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;

    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    if (input != null) {
      if (typeof input === 'string') {
        input = offsetFromString(matchShortOffset, input);

        if (input === null) {
          return this;
        }
      } else if (Math.abs(input) < 16 && !keepMinutes) {
        input = input * 60;
      }

      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }

      this._offset = input;
      this._isUTC = true;

      if (localAdjust != null) {
        this.add(localAdjust, 'm');
      }

      if (offset !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          addSubtract(this, createDuration(input - offset, 'm'), 1, false);
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }

      return this;
    } else {
      return this._isUTC ? offset : getDateOffset(this);
    }
  }

  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== 'string') {
        input = -input;
      }

      this.utcOffset(input, keepLocalTime);
      return this;
    } else {
      return -this.utcOffset();
    }
  }

  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }

  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;

      if (keepLocalTime) {
        this.subtract(getDateOffset(this), 'm');
      }
    }

    return this;
  }

  function setOffsetToParsedOffset() {
    if (this._tzm != null) {
      this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
      var tZone = offsetFromString(matchOffset, this._i);

      if (tZone != null) {
        this.utcOffset(tZone);
      } else {
        this.utcOffset(0, true);
      }
    }

    return this;
  }

  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }

    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
  }

  function isDaylightSavingTime() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }

  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }

    var c = {};
    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
      var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }

    return this._isDSTShifted;
  }

  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }

  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }

  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  } // ASP.NET json date format regex


  var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/; // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
  // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
  // and further modified to allow for strings containing both week and day

  var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

  function createDuration(input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
    match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (isNumber(input)) {
      duration = {};

      if (key) {
        duration[key] = input;
      } else {
        duration.milliseconds = input;
      }
    } else if (!!(match = aspNetRegex.exec(input))) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign,
        h: toInt(match[HOUR]) * sign,
        m: toInt(match[MINUTE]) * sign,
        s: toInt(match[SECOND]) * sign,
        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

      };
    } else if (!!(match = isoRegex.exec(input))) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign),
        M: parseIso(match[3], sign),
        w: parseIso(match[4], sign),
        d: parseIso(match[5], sign),
        h: parseIso(match[6], sign),
        m: parseIso(match[7], sign),
        s: parseIso(match[8], sign)
      };
    } else if (duration == null) {
      // checks for null or undefined
      duration = {};
    } else if (_typeof(duration) === 'object' && ('from' in duration || 'to' in duration)) {
      diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
      ret._locale = input._locale;
    }

    return ret;
  }

  createDuration.fn = Duration.prototype;
  createDuration.invalid = createInvalid$1;

  function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

    return (isNaN(res) ? 0 : res) * sign;
  }

  function positiveMomentsDifference(base, other) {
    var res = {
      milliseconds: 0,
      months: 0
    };
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

    if (base.clone().add(res.months, 'M').isAfter(other)) {
      --res.months;
    }

    res.milliseconds = +other - +base.clone().add(res.months, 'M');
    return res;
  }

  function momentsDifference(base, other) {
    var res;

    if (!(base.isValid() && other.isValid())) {
      return {
        milliseconds: 0,
        months: 0
      };
    }

    other = cloneWithOffset(other, base);

    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }

    return res;
  } // TODO: remove 'name' arg after deprecation is removed


  function createAdder(direction, name) {
    return function (val, period) {
      var dur, tmp; //invert the arguments, but complain about it

      if (period !== null && !isNaN(+period)) {
        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
        tmp = val;
        val = period;
        period = tmp;
      }

      val = typeof val === 'string' ? +val : val;
      dur = createDuration(val, period);
      addSubtract(this, dur, direction);
      return this;
    };
  }

  function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
      // No op
      return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
      setMonth(mom, get(mom, 'Month') + months * isAdding);
    }

    if (days) {
      set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }

    if (milliseconds) {
      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }

    if (updateOffset) {
      hooks.updateOffset(mom, days || months);
    }
  }

  var add = createAdder(1, 'add');
  var subtract = createAdder(-1, 'subtract');

  function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
  }

  function calendar$1(time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';
    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
  }

  function clone() {
    return new Moment(this);
  }

  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }

  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }

  function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);

    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
      return false;
    }

    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
  }

  function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;

    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }

    units = normalizeUnits(units) || 'millisecond';

    if (units === 'millisecond') {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }

  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }

  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }

  function diff(input, units, asFloat) {
    var that, zoneDelta, output;

    if (!this.isValid()) {
      return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
      return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);

    switch (units) {
      case 'year':
        output = monthDiff(this, that) / 12;
        break;

      case 'month':
        output = monthDiff(this, that);
        break;

      case 'quarter':
        output = monthDiff(this, that) / 3;
        break;

      case 'second':
        output = (this - that) / 1e3;
        break;
      // 1000

      case 'minute':
        output = (this - that) / 6e4;
        break;
      // 1000 * 60

      case 'hour':
        output = (this - that) / 36e5;
        break;
      // 1000 * 60 * 60

      case 'day':
        output = (this - that - zoneDelta) / 864e5;
        break;
      // 1000 * 60 * 60 * 24, negate dst

      case 'week':
        output = (this - that - zoneDelta) / 6048e5;
        break;
      // 1000 * 60 * 60 * 24 * 7, negate dst

      default:
        output = this - that;
    }

    return asFloat ? output : absFloor(output);
  }

  function monthDiff(a, b) {
    // difference in months
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
    anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;

    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

      adjust = (b - anchor) / (anchor2 - anchor);
    } //check for negative zero, return zero if negative zero


    return -(wholeMonthDiff + adjust) || 0;
  }

  hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
  hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

  function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  }

  function toISOString(keepOffset) {
    if (!this.isValid()) {
      return null;
    }

    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;

    if (m.year() < 0 || m.year() > 9999) {
      return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    if (isFunction(Date.prototype.toISOString)) {
      // native implementation is ~50x faster, use it when we can
      if (utc) {
        return this.toDate().toISOString();
      } else {
        return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
      }
    }

    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
  }
  /**
   * Return a human readable representation of a moment that can
   * also be evaluated to get a new moment which is the same
   *
   * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
   */


  function inspect() {
    if (!this.isValid()) {
      return 'moment.invalid(/* ' + this._i + ' */)';
    }

    var func = 'moment';
    var zone = '';

    if (!this.isLocal()) {
      func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
      zone = 'Z';
    }

    var prefix = '[' + func + '("]';
    var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
  }

  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }

    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }

  function from(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        to: this,
        from: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
  }

  function to(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        from: this,
        to: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
  } // If passed a locale key, it will set the locale for this
  // instance.  Otherwise, it will return the locale configuration
  // variables for this instance.


  function locale(key) {
    var newLocaleData;

    if (key === undefined) {
      return this._locale._abbr;
    } else {
      newLocaleData = getLocale(key);

      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }

      return this;
    }
  }

  var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
    if (key === undefined) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  });

  function localeData() {
    return this._locale;
  }

  function startOf(units) {
    units = normalizeUnits(units); // the following switch intentionally omits break keywords
    // to utilize falling through the cases.

    switch (units) {
      case 'year':
        this.month(0);

      /* falls through */

      case 'quarter':
      case 'month':
        this.date(1);

      /* falls through */

      case 'week':
      case 'isoWeek':
      case 'day':
      case 'date':
        this.hours(0);

      /* falls through */

      case 'hour':
        this.minutes(0);

      /* falls through */

      case 'minute':
        this.seconds(0);

      /* falls through */

      case 'second':
        this.milliseconds(0);
    } // weeks are a special case


    if (units === 'week') {
      this.weekday(0);
    }

    if (units === 'isoWeek') {
      this.isoWeekday(1);
    } // quarters are also special


    if (units === 'quarter') {
      this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
  }

  function endOf(units) {
    units = normalizeUnits(units);

    if (units === undefined || units === 'millisecond') {
      return this;
    } // 'date' is an alias for 'day', so it should be considered as such.


    if (units === 'date') {
      units = 'day';
    }

    return this.startOf(units).add(1, units === 'isoWeek' ? 'week' : units).subtract(1, 'ms');
  }

  function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
  }

  function unix() {
    return Math.floor(this.valueOf() / 1000);
  }

  function toDate() {
    return new Date(this.valueOf());
  }

  function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
  }

  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }

  function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
  }

  function isValid$2() {
    return isValid(this);
  }

  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }

  function invalidAt() {
    return getParsingFlags(this).overflow;
  }

  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  } // FORMATTING


  addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
  });
  addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
  });

  function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
  }

  addWeekYearFormatToken('gggg', 'weekYear');
  addWeekYearFormatToken('ggggg', 'weekYear');
  addWeekYearFormatToken('GGGG', 'isoWeekYear');
  addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

  addUnitAlias('weekYear', 'gg');
  addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

  addUnitPriority('weekYear', 1);
  addUnitPriority('isoWeekYear', 1); // PARSING

  addRegexToken('G', matchSigned);
  addRegexToken('g', matchSigned);
  addRegexToken('GG', match1to2, match2);
  addRegexToken('gg', match1to2, match2);
  addRegexToken('GGGG', match1to4, match4);
  addRegexToken('gggg', match1to4, match4);
  addRegexToken('GGGGG', match1to6, match6);
  addRegexToken('ggggg', match1to6, match6);
  addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
  });
  addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
  }); // MOMENTS

  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
  }

  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
  }

  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }

  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;

    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }

  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;

    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);

      if (week > weeksTarget) {
        week = weeksTarget;
      }

      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }

  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  } // FORMATTING


  addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

  addUnitAlias('quarter', 'Q'); // PRIORITY

  addUnitPriority('quarter', 7); // PARSING

  addRegexToken('Q', match1);
  addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  }); // MOMENTS

  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  } // FORMATTING


  addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

  addUnitAlias('date', 'D'); // PRIORITY

  addUnitPriority('date', 9); // PARSING

  addRegexToken('D', match1to2);
  addRegexToken('DD', match1to2, match2);
  addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
  });
  addParseToken(['D', 'DD'], DATE);
  addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
  }); // MOMENTS

  var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

  addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

  addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

  addUnitPriority('dayOfYear', 4); // PARSING

  addRegexToken('DDD', match1to3);
  addRegexToken('DDDD', match3);
  addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
  }); // HELPERS
  // MOMENTS

  function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
  } // FORMATTING


  addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

  addUnitAlias('minute', 'm'); // PRIORITY

  addUnitPriority('minute', 14); // PARSING

  addRegexToken('m', match1to2);
  addRegexToken('mm', match1to2, match2);
  addParseToken(['m', 'mm'], MINUTE); // MOMENTS

  var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

  addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

  addUnitAlias('second', 's'); // PRIORITY

  addUnitPriority('second', 15); // PARSING

  addRegexToken('s', match1to2);
  addRegexToken('ss', match1to2, match2);
  addParseToken(['s', 'ss'], SECOND); // MOMENTS

  var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

  addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
  });
  addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
  });
  addFormatToken(0, ['SSS', 3], 0, 'millisecond');
  addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
  });
  addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
  });
  addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
  });
  addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
  }); // ALIASES

  addUnitAlias('millisecond', 'ms'); // PRIORITY

  addUnitPriority('millisecond', 16); // PARSING

  addRegexToken('S', match1to3, match1);
  addRegexToken('SS', match1to3, match2);
  addRegexToken('SSS', match1to3, match3);
  var token;

  for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
  }

  function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
  }

  for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
  } // MOMENTS


  var getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

  addFormatToken('z', 0, 0, 'zoneAbbr');
  addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

  function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
  }

  function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
  }

  var proto = Moment.prototype;
  proto.add = add;
  proto.calendar = calendar$1;
  proto.clone = clone;
  proto.diff = diff;
  proto.endOf = endOf;
  proto.format = format;
  proto.from = from;
  proto.fromNow = fromNow;
  proto.to = to;
  proto.toNow = toNow;
  proto.get = stringGet;
  proto.invalidAt = invalidAt;
  proto.isAfter = isAfter;
  proto.isBefore = isBefore;
  proto.isBetween = isBetween;
  proto.isSame = isSame;
  proto.isSameOrAfter = isSameOrAfter;
  proto.isSameOrBefore = isSameOrBefore;
  proto.isValid = isValid$2;
  proto.lang = lang;
  proto.locale = locale;
  proto.localeData = localeData;
  proto.max = prototypeMax;
  proto.min = prototypeMin;
  proto.parsingFlags = parsingFlags;
  proto.set = stringSet;
  proto.startOf = startOf;
  proto.subtract = subtract;
  proto.toArray = toArray;
  proto.toObject = toObject;
  proto.toDate = toDate;
  proto.toISOString = toISOString;
  proto.inspect = inspect;
  proto.toJSON = toJSON;
  proto.toString = toString;
  proto.unix = unix;
  proto.valueOf = valueOf;
  proto.creationData = creationData;
  proto.year = getSetYear;
  proto.isLeapYear = getIsLeapYear;
  proto.weekYear = getSetWeekYear;
  proto.isoWeekYear = getSetISOWeekYear;
  proto.quarter = proto.quarters = getSetQuarter;
  proto.month = getSetMonth;
  proto.daysInMonth = getDaysInMonth;
  proto.week = proto.weeks = getSetWeek;
  proto.isoWeek = proto.isoWeeks = getSetISOWeek;
  proto.weeksInYear = getWeeksInYear;
  proto.isoWeeksInYear = getISOWeeksInYear;
  proto.date = getSetDayOfMonth;
  proto.day = proto.days = getSetDayOfWeek;
  proto.weekday = getSetLocaleDayOfWeek;
  proto.isoWeekday = getSetISODayOfWeek;
  proto.dayOfYear = getSetDayOfYear;
  proto.hour = proto.hours = getSetHour;
  proto.minute = proto.minutes = getSetMinute;
  proto.second = proto.seconds = getSetSecond;
  proto.millisecond = proto.milliseconds = getSetMillisecond;
  proto.utcOffset = getSetOffset;
  proto.utc = setOffsetToUTC;
  proto.local = setOffsetToLocal;
  proto.parseZone = setOffsetToParsedOffset;
  proto.hasAlignedHourOffset = hasAlignedHourOffset;
  proto.isDST = isDaylightSavingTime;
  proto.isLocal = isLocal;
  proto.isUtcOffset = isUtcOffset;
  proto.isUtc = isUtc;
  proto.isUTC = isUtc;
  proto.zoneAbbr = getZoneAbbr;
  proto.zoneName = getZoneName;
  proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
  proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
  proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
  proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
  proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

  function createUnix(input) {
    return createLocal(input * 1000);
  }

  function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
  }

  function preParsePostFormat(string) {
    return string;
  }

  var proto$1 = Locale.prototype;
  proto$1.calendar = calendar;
  proto$1.longDateFormat = longDateFormat;
  proto$1.invalidDate = invalidDate;
  proto$1.ordinal = ordinal;
  proto$1.preparse = preParsePostFormat;
  proto$1.postformat = preParsePostFormat;
  proto$1.relativeTime = relativeTime;
  proto$1.pastFuture = pastFuture;
  proto$1.set = set;
  proto$1.months = localeMonths;
  proto$1.monthsShort = localeMonthsShort;
  proto$1.monthsParse = localeMonthsParse;
  proto$1.monthsRegex = monthsRegex;
  proto$1.monthsShortRegex = monthsShortRegex;
  proto$1.week = localeWeek;
  proto$1.firstDayOfYear = localeFirstDayOfYear;
  proto$1.firstDayOfWeek = localeFirstDayOfWeek;
  proto$1.weekdays = localeWeekdays;
  proto$1.weekdaysMin = localeWeekdaysMin;
  proto$1.weekdaysShort = localeWeekdaysShort;
  proto$1.weekdaysParse = localeWeekdaysParse;
  proto$1.weekdaysRegex = weekdaysRegex;
  proto$1.weekdaysShortRegex = weekdaysShortRegex;
  proto$1.weekdaysMinRegex = weekdaysMinRegex;
  proto$1.isPM = localeIsPM;
  proto$1.meridiem = localeMeridiem;

  function get$1(format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
  }

  function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
      index = format;
      format = undefined;
    }

    format = format || '';

    if (index != null) {
      return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];

    for (i = 0; i < 12; i++) {
      out[i] = get$1(format, i, field, 'month');
    }

    return out;
  } // ()
  // (5)
  // (fmt, 5)
  // (fmt)
  // (true)
  // (true, 5)
  // (true, fmt, 5)
  // (true, fmt)


  function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';
    } else {
      format = localeSorted;
      index = format;
      localeSorted = false;

      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
      return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];

    for (i = 0; i < 7; i++) {
      out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }

    return out;
  }

  function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
  }

  function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
  }

  function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
  }

  function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
  }

  function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
  }

  getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function ordinal(number) {
      var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
      return number + output;
    }
  }); // Side effect imports

  hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
  hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
  var mathAbs = Math.abs;

  function abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
  }

  function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
  } // supports only 2.0-style add(1, 's') or add(duration)


  function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
  } // supports only 2.0-style subtract(1, 's') or subtract(duration)


  function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
  }

  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }

  function bubble() {
    var milliseconds = this._milliseconds;
    var days = this._days;
    var months = this._months;
    var data = this._data;
    var seconds, minutes, hours, years, monthsFromDays; // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166

    if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
      days = 0;
      months = 0;
    } // The following code bubbles up values, see the tests for
    // examples of what that means.


    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24); // convert days to months

    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
  }

  function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
  }

  function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
  }

  function as(units) {
    if (!this.isValid()) {
      return NaN;
    }

    var days;
    var months;
    var milliseconds = this._milliseconds;
    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
      days = this._days + milliseconds / 864e5;
      months = this._months + daysToMonths(days);
      return units === 'month' ? months : months / 12;
    } else {
      // handle milliseconds separately because of floating point math errors (issue #1867)
      days = this._days + Math.round(monthsToDays(this._months));

      switch (units) {
        case 'week':
          return days / 7 + milliseconds / 6048e5;

        case 'day':
          return days + milliseconds / 864e5;

        case 'hour':
          return days * 24 + milliseconds / 36e5;

        case 'minute':
          return days * 1440 + milliseconds / 6e4;

        case 'second':
          return days * 86400 + milliseconds / 1000;
        // Math.floor prevents floating point math errors here

        case 'millisecond':
          return Math.floor(days * 864e5) + milliseconds;

        default:
          throw new Error('Unknown unit ' + units);
      }
    }
  } // TODO: Use this.as('ms')?


  function valueOf$1() {
    if (!this.isValid()) {
      return NaN;
    }

    return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
  }

  function makeAs(alias) {
    return function () {
      return this.as(alias);
    };
  }

  var asMilliseconds = makeAs('ms');
  var asSeconds = makeAs('s');
  var asMinutes = makeAs('m');
  var asHours = makeAs('h');
  var asDays = makeAs('d');
  var asWeeks = makeAs('w');
  var asMonths = makeAs('M');
  var asYears = makeAs('y');

  function clone$1() {
    return createDuration(this);
  }

  function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
  }

  function makeGetter(name) {
    return function () {
      return this.isValid() ? this._data[name] : NaN;
    };
  }

  var milliseconds = makeGetter('milliseconds');
  var seconds = makeGetter('seconds');
  var minutes = makeGetter('minutes');
  var hours = makeGetter('hours');
  var days = makeGetter('days');
  var months = makeGetter('months');
  var years = makeGetter('years');

  function weeks() {
    return absFloor(this.days() / 7);
  }

  var round = Math.round;
  var thresholds = {
    ss: 44,
    // a few seconds to seconds
    s: 45,
    // seconds to minute
    m: 45,
    // minutes to hour
    h: 22,
    // hours to day
    d: 26,
    // days to month
    M: 11 // months to year

  }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
  }

  function relativeTime$1(posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds = round(duration.as('s'));
    var minutes = round(duration.as('m'));
    var hours = round(duration.as('h'));
    var days = round(duration.as('d'));
    var months = round(duration.as('M'));
    var years = round(duration.as('y'));
    var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
  } // This function allows you to set the rounding function for relative time strings


  function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
      return round;
    }

    if (typeof roundingFunction === 'function') {
      round = roundingFunction;
      return true;
    }

    return false;
  } // This function allows you to set a threshold for relative time strings


  function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
      return false;
    }

    if (limit === undefined) {
      return thresholds[threshold];
    }

    thresholds[threshold] = limit;

    if (threshold === 's') {
      thresholds.ss = limit - 1;
    }

    return true;
  }

  function humanize(withSuffix) {
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
      output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
  }

  var abs$1 = Math.abs;

  function sign(x) {
    return (x > 0) - (x < 0) || +x;
  }

  function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days = abs$1(this._days);
    var months = abs$1(this._months);
    var minutes, hours, years; // 3600 seconds -> 60 minutes -> 1 hour

    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60; // 12 months -> 1 year

    years = absFloor(months / 12);
    months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
      // this is the same as C#'s (Noda) and python (isodate)...
      // but not other JS (goog.date)
      return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
    return totalSign + 'P' + (Y ? ymSign + Y + 'Y' : '') + (M ? ymSign + M + 'M' : '') + (D ? daysSign + D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? hmsSign + h + 'H' : '') + (m ? hmsSign + m + 'M' : '') + (s ? hmsSign + s + 'S' : '');
  }

  var proto$2 = Duration.prototype;
  proto$2.isValid = isValid$1;
  proto$2.abs = abs;
  proto$2.add = add$1;
  proto$2.subtract = subtract$1;
  proto$2.as = as;
  proto$2.asMilliseconds = asMilliseconds;
  proto$2.asSeconds = asSeconds;
  proto$2.asMinutes = asMinutes;
  proto$2.asHours = asHours;
  proto$2.asDays = asDays;
  proto$2.asWeeks = asWeeks;
  proto$2.asMonths = asMonths;
  proto$2.asYears = asYears;
  proto$2.valueOf = valueOf$1;
  proto$2._bubble = bubble;
  proto$2.clone = clone$1;
  proto$2.get = get$2;
  proto$2.milliseconds = milliseconds;
  proto$2.seconds = seconds;
  proto$2.minutes = minutes;
  proto$2.hours = hours;
  proto$2.days = days;
  proto$2.weeks = weeks;
  proto$2.months = months;
  proto$2.years = years;
  proto$2.humanize = humanize;
  proto$2.toISOString = toISOString$1;
  proto$2.toString = toISOString$1;
  proto$2.toJSON = toISOString$1;
  proto$2.locale = locale;
  proto$2.localeData = localeData;
  proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
  proto$2.lang = lang; // Side effect imports
  // FORMATTING

  addFormatToken('X', 0, 0, 'unix');
  addFormatToken('x', 0, 0, 'valueOf'); // PARSING

  addRegexToken('x', matchSigned);
  addRegexToken('X', matchTimestamp);
  addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
  });
  addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
  }); // Side effect imports

  hooks.version = '2.23.0';
  setHookCallback(createLocal);
  hooks.fn = proto;
  hooks.min = min;
  hooks.max = max;
  hooks.now = now;
  hooks.utc = createUTC;
  hooks.unix = createUnix;
  hooks.months = listMonths;
  hooks.isDate = isDate;
  hooks.locale = getSetGlobalLocale;
  hooks.invalid = createInvalid;
  hooks.duration = createDuration;
  hooks.isMoment = isMoment;
  hooks.weekdays = listWeekdays;
  hooks.parseZone = createInZone;
  hooks.localeData = getLocale;
  hooks.isDuration = isDuration;
  hooks.monthsShort = listMonthsShort;
  hooks.weekdaysMin = listWeekdaysMin;
  hooks.defineLocale = defineLocale;
  hooks.updateLocale = updateLocale;
  hooks.locales = listLocales;
  hooks.weekdaysShort = listWeekdaysShort;
  hooks.normalizeUnits = normalizeUnits;
  hooks.relativeTimeRounding = getSetRelativeTimeRounding;
  hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
  hooks.calendarFormat = getCalendarFormat;
  hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

  hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
    // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
    // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
    // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',
    // <input type="date" />
    TIME: 'HH:mm',
    // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',
    // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',
    // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW',
    // <input type="week" />
    MONTH: 'YYYY-MM' // <input type="month" />

  };
  return hooks;
});
//https://raw.githubusercontent.com/horprogs/Just-validate/master/dist/js/just-validate.js
'use strict';

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

(function () {
  var typesToPatch = ['DocumentType', 'Element', 'CharacterData'],
      remove = function remove() {
    // The check here seems pointless, since we're not adding this
    // method to the prototypes of any any elements that CAN be the
    // root of the DOM. However, it's required by spec (see point 1 of
    // https://dom.spec.whatwg.org/#dom-childnode-remove) and would
    // theoretically make a difference if somebody .apply()ed this
    // method to the DOM's root node, so let's roll with it.
    if (this.parentNode != null) {
      this.parentNode.removeChild(this);
    }
  };

  for (var i = 0; i < typesToPatch.length; i++) {
    var type = typesToPatch[i];

    if (window[type] && !window[type].prototype.remove) {
      window[type].prototype.remove = remove;
    }
  }
})();

(function (root) {
  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {} // Polyfill for Function.prototype.bind


  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (_typeof(this) !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];
    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }

    if (self._state === 0) {
      self._deferreds.push(deferred);

      return;
    }

    self._handled = true;

    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;

      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }

      var ret;

      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }

      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');

      if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;

        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }

      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function () {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }

    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }
  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */


  function doResolve(fn, self) {
    var done = false;

    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);
    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);
    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
            var then = val.then;

            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }

          args[i] = val;

          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  }; // Use polyfill for setImmediate for performance gains


  Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
  } || function (fn) {
    setTimeoutFunc(fn, 0);
  };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };
  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */


  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };
  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */


  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }
})(window);

(function (window) {
  'use strict';

  if (!window.Promise) {
    window.Promise = Promise;
  }

  var RULE_REQUIRED = 'required',
      RULE_EMAIL = 'email',
      RULE_MINLENGTH = 'minLength',
      RULE_MAXLENGTH = 'maxLength',
      RULE_PASSWORD = 'password',
      RULE_ZIP = 'zip',
      RULE_PHONE = 'phone',
      RULE_REMOTE = 'remote';

  var formatParams = function formatParams(params, method) {
    if (typeof params === 'string') {
      return params;
    }

    var letter = method.toLowerCase() === 'post' ? '' : '?';

    if (Array.isArray(params)) {
      return letter + params.map(function (obj) {
        return obj.name + "=" + obj.value;
      }).join("&");
    }

    return letter + Object.keys(params).map(function (key) {
      return key + "=" + params[key];
    }).join("&");
  };

  var ajax = function ajax(options) {
    var url = options.url,
        method = options.method,
        data = options.data,
        debug = options.debug,
        callback = options.callback,
        error = options.error;

    if (debug) {
      callback('test');
      return;
    }

    var async = options.async === false ? false : true;
    var xhr = new XMLHttpRequest();
    var params = formatParams(data, 'get');
    var body = null;

    if (method.toLowerCase() === 'post') {
      body = formatParams(data, 'post');
      params = '';
    }

    xhr.open(method, url + params, async);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          callback(this.responseText);
        } else {
          error && error(this.responseText);
        }
      }
    };

    xhr.send(body);
  };

  var JustValidate = function JustValidate(selector, options) {
    this.options = options || {};
    this.rules = this.options.rules || {};
    this.messages = this.options.messages || undefined;
    this.colorWrong = this.options.colorWrong || '#B81111';
    this.result = {};
    this.elements = [];
    this.bindHandlerKeyup = this.handlerKeyup.bind(this);
    this.submitHandler = this.options.submitHandler || undefined;
    this.promiseRemote = null;
    this.isValidationSuccess = false;
    this.REGEXP = {
      email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      zip: /^\d{5}(-\d{4})?$/,
      phone: /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$/,
      password: /[^\w\d]*(([0-9]+.*[A-Za-z]+.*)|[A-Za-z]+.*([0-9]+.*))/
    };
    this.DEFAULT_REMOTE_ERROR = 'Error';
    this.setForm(document.querySelector(selector));
  };

  JustValidate.prototype = {
    defaultRules: {
      email: {
        required: true,
        email: true
      },
      name: {
        required: true,
        minLength: 3,
        maxLength: 15
      },
      text: {
        required: true,
        maxLength: 300,
        minLength: 5
      },
      password: {
        required: true,
        password: true,
        minLength: 4,
        maxLength: 8
      },
      zip: {
        required: true,
        zip: true
      },
      phone: {
        phone: true
      }
    },
    defaultMessages: {
      required: 'The field is required',
      email: 'Please, type a valid email',
      maxLength: 'The field must contain a maximum of :value characters',
      minLength: 'The field must contain a minimum of :value characters',
      password: 'Password is not valid',
      remote: 'Email already exists'
    },

    /**
     * Keyup handler
     * @param ev
     */
    handlerKeyup: function handlerKeyup(ev) {
      var elem = ev.target,
          item = {
        name: elem.getAttribute('data-validate-field'),
        value: elem.value
      };
      delete this.result[item.name];
      this.validateItem({
        name: item.name,
        value: item.value,
        isKeyupChange: true
      });
      this.renderErrors();
    },
    setterEventListener: function setterEventListener(item, event, handler, type) {
      if (event === 'keyup') {
        handler = this.bindHandlerKeyup;
      }

      switch (type) {
        case 'add':
          {
            item.addEventListener(event, handler);
            break;
          }

        case 'remove':
          {
            item.removeEventListener(event, handler);
            break;
          }
      }
    },
    // formPristine: function () {
    //     let $elems = this.$form.querySelectorAll('input, textarea');
    //     for (let i = 0, len = $elems.length; i < len; ++i) {
    //         if ($elems[i].type !== 'submit') {
    //             $elems[i].value = '';
    //         }
    //     }
    // },
    getElementsRealValue: function getElementsRealValue() {
      var $elems = this.$form.querySelectorAll('*'),
          name = void 0,
          result = {};

      for (var i = 0, len = $elems.length; i < len; ++i) {
        name = $elems[i].getAttribute('name');

        if (name) {
          if ($elems[i].type === 'checkbox') {
            result[name] = $elems[i].checked;
            continue;
          }

          result[name] = $elems[i].value;
        }
      }

      return result;
    },
    validationSuccess: function validationSuccess() {
      if (Object.keys(this.result).length === 0) {
        this.isValidationSuccess = false;

        if (this.submitHandler) {
          var realValues = this.getElementsRealValue();
          this.submitHandler(this.$form, realValues, ajax); // this.formPristine();

          return;
        }

        this.$form.submit(); // this.formPristine();
      }
    },
    setForm: function setForm(form) {
      var _this = this;

      this.$form = form;
      this.$form.setAttribute('novalidate', 'novalidate');
      this.$form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        _this.result = [];

        _this.getElements();

        if (!_this.promiseRemote) {
          if (_this.isValidationSuccess) {
            _this.validationSuccess();
          }

          return;
        }

        _this.promiseRemote.then(function () {
          _this.promiseRemote = null;

          if (_this.isValidationSuccess) {
            _this.validationSuccess();
          }
        });
      });
    },
    isEmail: function isEmail(email) {
      return this.REGEXP.email.test(email);
    },
    isZip: function isZip(zip) {
      return this.REGEXP.zip.test(zip);
    },
    isPhone: function isPhone(phone) {
      return this.REGEXP.phone.test(phone);
    },
    isPassword: function isPassword(password) {
      return this.REGEXP.password.test(password);
    },
    isEmpty: function isEmpty(val) {
      var newVal = val;

      if (val.trim) {
        newVal = val.trim();
      }

      return !newVal;
    },
    checkLengthMax: function checkLengthMax(text, max) {
      return text.length <= max;
    },
    checkLengthMin: function checkLengthMin(text, min) {
      return text.length >= min;
    },
    getElements: function getElements() {
      var _this2 = this;

      var elems = this.$form.querySelectorAll('[data-validate-field]');
      this.elements = [];

      for (var i = 0, len = elems.length; i < len; ++i) {
        var item = elems[i],
            name = item.getAttribute('data-validate-field'),
            value = item.value;

        if (item.type === 'checkbox') {
          value = item.checked || '';
          item.addEventListener('change', function (ev) {
            var elem = ev.target,
                item = {
              name: elem.getAttribute('data-validate-field'),
              value: elem.checked
            };
            delete _this2.result[item.name];

            _this2.validateItem({
              name: item.name,
              value: item.value
            });

            _this2.renderErrors();
          });
        }

        this.setterEventListener(item, 'keyup', this.handlerKeyup, 'add');
        this.elements.push({
          name: name,
          value: value
        });
      }

      this.validateElements();
    },

    /**
     * Validate Required field
     * @param {string} value Value for validate
     * @returns {boolean} True if validate is OK
     */
    validateRequired: function validateRequired(value) {
      return !this.isEmpty(value);
    },

    /**
     * Validate Email field
     * @param {string} value Value for validate
     * @returns {boolean} True if validate is OK
     */
    validateEmail: function validateEmail(value) {
      return this.isEmail(value);
    },

    /**
     * Validate Phone field
     * @param {string} value Value for validate
     * @returns {boolean} True if validate is OK
     */
    validatePhone: function validatePhone(value) {
      return this.isPhone(value);
    },

    /**
     * Validate field for Min Length
     * @param {string} value Value for validate
     * @param {integer} min
     * @returns {boolean} True if validate is OK
     */
    validateMinLength: function validateMinLength(value, min) {
      return this.checkLengthMin(value, min);
    },

    /**
     * Validate field for Max Length
     * @param {string} value Value for validate
     * @param {integer} max
     * @returns {boolean} True if validate is OK
     */
    validateMaxLength: function validateMaxLength(value, max) {
      return this.checkLengthMax(value, max);
    },

    /**
     * Validate Password field
     * @param {string} value Value for validate
     * @returns {boolean} True if validate is OK
     */
    validatePassword: function validatePassword(value) {
      return this.isPassword(value);
    },

    /**
     * Validate ZIP field
     * @param {string} value Value for validate
     * @returns {boolean} True if validate is OK
     */
    validateZip: function validateZip(value) {
      return this.isZip(value);
    },

    /**
     * Validate for remote check
     * @param value
     * @param name
     * @param {string} url
     * @param {string} successAnswer
     * @returns {boolean} True if validate is OK
     */
    validateRemote: function validateRemote(_ref) {
      var value = _ref.value,
          name = _ref.name,
          url = _ref.url,
          successAnswer = _ref.successAnswer,
          sendParam = _ref.sendParam,
          method = _ref.method;
      return new Promise(function (resolve) {
        ajax({
          url: url,
          method: method,
          data: _defineProperty({}, sendParam, value),
          async: true,
          callback: function callback(data) {
            if (data.toLowerCase() === successAnswer.toLowerCase()) {
              resolve('ok');
            }

            resolve({
              type: 'incorrect',
              name: name
            });
          },
          error: function error() {
            resolve({
              type: 'error',
              name: name
            });
          }
        });
      });
    },
    generateMessage: function generateMessage(rule, name, value) {
      var messages = this.messages || this.defaultMessages;
      var customMessage = messages[name] && messages[name][rule] || this.messages && typeof this.messages[name] === 'string' && messages[name] || // (messages[name][rule]) ||
      this.defaultMessages[rule] || this.DEFAULT_REMOTE_ERROR;

      if (value) {
        customMessage = customMessage.replace(':value', value.toString());
      }

      this.result[name] = {
        message: customMessage
      };
    },
    validateElements: function validateElements() {
      var _this3 = this;

      this.lockForm();
      this.elements.forEach(function (item) {
        _this3.validateItem({
          name: item.name,
          value: item.value
        });
      });

      if (!this.promiseRemote) {
        this.renderErrors();
        return;
      }

      this.promiseRemote.then(function (result) {
        if (result === 'ok') {
          _this3.renderErrors();

          return;
        }

        if (result.type === 'error') {
          alert('Server error occured. Please try later.');
        }

        _this3.generateMessage(RULE_REMOTE, result.name);

        _this3.renderErrors();
      });
    },
    validateItem: function validateItem(_ref2) {
      var name = _ref2.name,
          value = _ref2.value,
          isKeyupChange = _ref2.isKeyupChange;
      var rules = this.rules[name] || this.defaultRules[name] || false;

      if (!rules) {
        return;
      }

      for (var rule in rules) {
        var ruleValue = rules[rule];

        switch (rule) {
          case RULE_REQUIRED:
            {
              if (!ruleValue) {
                break;
              }

              if (this.validateRequired(value)) {
                break;
              }

              this.generateMessage(RULE_REQUIRED, name);
              return;
            }

          case RULE_EMAIL:
            {
              if (!ruleValue) {
                break;
              }

              if (this.validateEmail(value)) {
                break;
              }

              this.generateMessage(RULE_EMAIL, name);
              return;
            }

          case RULE_MINLENGTH:
            {
              if (!ruleValue) {
                break;
              }

              if (this.validateMinLength(value, ruleValue)) {
                break;
              }

              this.generateMessage(RULE_MINLENGTH, name, ruleValue);
              return;
            }

          case RULE_MAXLENGTH:
            {
              if (!ruleValue) {
                break;
              }

              if (this.validateMaxLength(value, ruleValue)) {
                break;
              }

              this.generateMessage(RULE_MAXLENGTH, name, ruleValue);
              return;
            }

          case RULE_PHONE:
            {
              if (!ruleValue) {
                break;
              }

              if (this.validatePhone(value)) {
                break;
              }

              this.generateMessage(RULE_PHONE, name);
              return;
            }

          case RULE_PASSWORD:
            {
              if (!ruleValue) {
                break;
              }

              if (this.validatePassword(value)) {
                break;
              }

              this.generateMessage(RULE_PASSWORD, name);
              return;
            }

          case RULE_ZIP:
            {
              if (!ruleValue) {
                break;
              }

              if (this.validateZip(value)) {
                break;
              }

              this.generateMessage(RULE_ZIP, name);
              return;
            }

          case RULE_REMOTE:
            {
              if (isKeyupChange) {
                break;
              }

              if (!ruleValue) {
                break;
              }

              var url = ruleValue.url,
                  successAnswer = ruleValue.successAnswer,
                  method = ruleValue.method,
                  sendParam = ruleValue.sendParam;
              var $elem = this.$form.querySelector('input[data-validate-field="' + name + '"]');
              this.setterEventListener($elem, 'keyup', this.handlerKeyup, 'remove');
              this.promiseRemote = this.validateRemote({
                name: name,
                value: value,
                url: url,
                method: method,
                sendParam: sendParam,
                successAnswer: successAnswer
              }); // this.unlockForm();

              return;
            }
        }
      }
    },
    clearErrors: function clearErrors() {
      var $elems = document.querySelectorAll('.js-validate-error-label');

      for (var i = 0, len = $elems.length; i < len; ++i) {
        $elems[i].remove();
      }

      $elems = document.querySelectorAll('.js-validate-error-field');

      for (var _i = 0, _len = $elems.length; _i < _len; ++_i) {
        $elems[_i].classList.remove('js-validate-error-field'); //$elems[_i].style.border = '';
        //$elems[_i].style.color = '';

      }
    },
    renderErrors: function renderErrors() {
      this.clearErrors();
      this.unlockForm();
      this.isValidationSuccess = false;

      if (Object.keys(this.result).length === 0) {
        this.isValidationSuccess = true;
        return;
      }

      for (var item in this.result) {
        var message = this.result[item].message;
        var $elems = this.$form.querySelectorAll('[data-validate-field="' + item + '"]');

        for (var i = 0, len = $elems.length; i < len; ++i) {
          var div = document.createElement('div'),
              _item = $elems[i];
          div.innerHTML = message;
          div.className = 'js-validate-error-label'; //div.setAttribute('style', 'color: ' + this.colorWrong);
          //_item.style.border = '1px solid ' + this.colorWrong;
          //_item.style.color = '' + this.colorWrong;

          _item.classList.add('js-validate-error-field');

          if (_item.type === 'checkbox') {
            var $label = document.querySelector('label[for="' + _item.getAttribute('id') + '"]');

            if (_item.parentNode.tagName.toLowerCase() === 'label') {
              _item.parentNode.parentNode.insertBefore(div, null);
            } else if ($label) {
              $label.parentNode.insertBefore(div, $label.nextSibling);
            } else {
              _item.parentNode.insertBefore(div, _item.nextSibling);
            }

            continue;
          }

          _item.parentNode.insertBefore(div, _item.nextSibling);
        }
      }
    },
    lockForm: function lockForm() {
      var $elems = this.$form.querySelectorAll('input, textarea, button, select');

      for (var i = 0, len = $elems.length; i < len; ++i) {
        $elems[i].setAttribute('disabled', 'disabled');
        $elems[i].style.pointerEvents = 'none';
        $elems[i].style.webitFilter = 'grayscale(100%)';
        $elems[i].style.filter = 'grayscale(100%)';
      }
    },
    unlockForm: function unlockForm() {
      var $elems = this.$form.querySelectorAll('input, textarea, button, select');

      for (var i = 0, len = $elems.length; i < len; ++i) {
        $elems[i].removeAttribute('disabled');
        $elems[i].style.pointerEvents = '';
        $elems[i].style.webitFilter = '';
        $elems[i].style.filter = '';
      }
    }
  };
  window.JustValidate = JustValidate;
})(window);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function () {
  "use strict";

  function t(n) {
    if (!n) throw new Error("No options passed to Waypoint constructor");
    if (!n.element) throw new Error("No element option passed to Waypoint constructor");
    if (!n.handler) throw new Error("No handler option passed to Waypoint constructor");
    this.key = "waypoint-" + e, this.options = t.Adapter.extend({}, t.defaults, n), this.element = this.options.element, this.adapter = new t.Adapter(this.element), this.callback = n.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = t.Group.findOrCreate({
      name: this.options.group,
      axis: this.axis
    }), this.context = t.Context.findOrCreateByElement(this.options.context), t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), i[this.key] = this, e += 1;
  }

  var e = 0,
      i = {};
  t.prototype.queueTrigger = function (t) {
    this.group.queueTrigger(this, t);
  }, t.prototype.trigger = function (t) {
    this.enabled && this.callback && this.callback.apply(this, t);
  }, t.prototype.destroy = function () {
    this.context.remove(this), this.group.remove(this), delete i[this.key];
  }, t.prototype.disable = function () {
    return this.enabled = !1, this;
  }, t.prototype.enable = function () {
    return this.context.refresh(), this.enabled = !0, this;
  }, t.prototype.next = function () {
    return this.group.next(this);
  }, t.prototype.previous = function () {
    return this.group.previous(this);
  }, t.invokeAll = function (t) {
    var e = [];

    for (var n in i) {
      e.push(i[n]);
    }

    for (var o = 0, r = e.length; r > o; o++) {
      e[o][t]();
    }
  }, t.destroyAll = function () {
    t.invokeAll("destroy");
  }, t.disableAll = function () {
    t.invokeAll("disable");
  }, t.enableAll = function () {
    t.Context.refreshAll();

    for (var e in i) {
      i[e].enabled = !0;
    }

    return this;
  }, t.refreshAll = function () {
    t.Context.refreshAll();
  }, t.viewportHeight = function () {
    return window.innerHeight || document.documentElement.clientHeight;
  }, t.viewportWidth = function () {
    return document.documentElement.clientWidth;
  }, t.adapters = [], t.defaults = {
    context: window,
    continuous: !0,
    enabled: !0,
    group: "default",
    horizontal: !1,
    offset: 0
  }, t.offsetAliases = {
    "bottom-in-view": function bottomInView() {
      return this.context.innerHeight() - this.adapter.outerHeight();
    },
    "right-in-view": function rightInView() {
      return this.context.innerWidth() - this.adapter.outerWidth();
    }
  }, window.Waypoint = t;
}(), function () {
  "use strict";

  function t(t) {
    window.setTimeout(t, 1e3 / 60);
  }

  function e(t) {
    this.element = t, this.Adapter = o.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + i, this.didScroll = !1, this.didResize = !1, this.oldScroll = {
      x: this.adapter.scrollLeft(),
      y: this.adapter.scrollTop()
    }, this.waypoints = {
      vertical: {},
      horizontal: {}
    }, t.waypointContextKey = this.key, n[t.waypointContextKey] = this, i += 1, o.windowContext || (o.windowContext = !0, o.windowContext = new e(window)), this.createThrottledScrollHandler(), this.createThrottledResizeHandler();
  }

  var i = 0,
      n = {},
      o = window.Waypoint,
      r = window.onload;
  e.prototype.add = function (t) {
    var e = t.options.horizontal ? "horizontal" : "vertical";
    this.waypoints[e][t.key] = t, this.refresh();
  }, e.prototype.checkEmpty = function () {
    var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
        e = this.Adapter.isEmptyObject(this.waypoints.vertical),
        i = this.element == this.element.window;
    t && e && !i && (this.adapter.off(".waypoints"), delete n[this.key]);
  }, e.prototype.createThrottledResizeHandler = function () {
    function t() {
      e.handleResize(), e.didResize = !1;
    }

    var e = this;
    this.adapter.on("resize.waypoints", function () {
      e.didResize || (e.didResize = !0, o.requestAnimationFrame(t));
    });
  }, e.prototype.createThrottledScrollHandler = function () {
    function t() {
      e.handleScroll(), e.didScroll = !1;
    }

    var e = this;
    this.adapter.on("scroll.waypoints", function () {
      (!e.didScroll || o.isTouch) && (e.didScroll = !0, o.requestAnimationFrame(t));
    });
  }, e.prototype.handleResize = function () {
    o.Context.refreshAll();
  }, e.prototype.handleScroll = function () {
    var t = {},
        e = {
      horizontal: {
        newScroll: this.adapter.scrollLeft(),
        oldScroll: this.oldScroll.x,
        forward: "right",
        backward: "left"
      },
      vertical: {
        newScroll: this.adapter.scrollTop(),
        oldScroll: this.oldScroll.y,
        forward: "down",
        backward: "up"
      }
    };

    for (var i in e) {
      var n = e[i],
          o = n.newScroll > n.oldScroll,
          r = o ? n.forward : n.backward;

      for (var s in this.waypoints[i]) {
        var l = this.waypoints[i][s];

        if (null !== l.triggerPoint) {
          var a = n.oldScroll < l.triggerPoint,
              h = n.newScroll >= l.triggerPoint,
              p = a && h,
              u = !a && !h;
          (p || u) && (l.queueTrigger(r), t[l.group.id] = l.group);
        }
      }
    }

    for (var d in t) {
      t[d].flushTriggers();
    }

    this.oldScroll = {
      x: e.horizontal.newScroll,
      y: e.vertical.newScroll
    };
  }, e.prototype.innerHeight = function () {
    return this.element == this.element.window ? o.viewportHeight() : this.adapter.innerHeight();
  }, e.prototype.remove = function (t) {
    delete this.waypoints[t.axis][t.key], this.checkEmpty();
  }, e.prototype.innerWidth = function () {
    return this.element == this.element.window ? o.viewportWidth() : this.adapter.innerWidth();
  }, e.prototype.destroy = function () {
    var t = [];

    for (var e in this.waypoints) {
      for (var i in this.waypoints[e]) {
        t.push(this.waypoints[e][i]);
      }
    }

    for (var n = 0, o = t.length; o > n; n++) {
      t[n].destroy();
    }
  }, e.prototype.refresh = function () {
    var t,
        e = this.element == this.element.window,
        i = e ? void 0 : this.adapter.offset(),
        n = {};
    this.handleScroll(), t = {
      horizontal: {
        contextOffset: e ? 0 : i.left,
        contextScroll: e ? 0 : this.oldScroll.x,
        contextDimension: this.innerWidth(),
        oldScroll: this.oldScroll.x,
        forward: "right",
        backward: "left",
        offsetProp: "left"
      },
      vertical: {
        contextOffset: e ? 0 : i.top,
        contextScroll: e ? 0 : this.oldScroll.y,
        contextDimension: this.innerHeight(),
        oldScroll: this.oldScroll.y,
        forward: "down",
        backward: "up",
        offsetProp: "top"
      }
    };

    for (var r in t) {
      var s = t[r];

      for (var l in this.waypoints[r]) {
        var a,
            h,
            p,
            u,
            d,
            f = this.waypoints[r][l],
            c = f.options.offset,
            w = f.triggerPoint,
            y = 0,
            g = null == w;
        f.element !== f.element.window && (y = f.adapter.offset()[s.offsetProp]), "function" == typeof c ? c = c.apply(f) : "string" == typeof c && (c = parseFloat(c), f.options.offset.indexOf("%") > -1 && (c = Math.ceil(s.contextDimension * c / 100))), a = s.contextScroll - s.contextOffset, f.triggerPoint = Math.floor(y + a - c), h = w < s.oldScroll, p = f.triggerPoint >= s.oldScroll, u = h && p, d = !h && !p, !g && u ? (f.queueTrigger(s.backward), n[f.group.id] = f.group) : !g && d ? (f.queueTrigger(s.forward), n[f.group.id] = f.group) : g && s.oldScroll >= f.triggerPoint && (f.queueTrigger(s.forward), n[f.group.id] = f.group);
      }
    }

    return o.requestAnimationFrame(function () {
      for (var t in n) {
        n[t].flushTriggers();
      }
    }), this;
  }, e.findOrCreateByElement = function (t) {
    return e.findByElement(t) || new e(t);
  }, e.refreshAll = function () {
    for (var t in n) {
      n[t].refresh();
    }
  }, e.findByElement = function (t) {
    return n[t.waypointContextKey];
  }, window.onload = function () {
    r && r(), e.refreshAll();
  }, o.requestAnimationFrame = function (e) {
    var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
    i.call(window, e);
  }, o.Context = e;
}(), function () {
  "use strict";

  function t(t, e) {
    return t.triggerPoint - e.triggerPoint;
  }

  function e(t, e) {
    return e.triggerPoint - t.triggerPoint;
  }

  function i(t) {
    this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), n[this.axis][this.name] = this;
  }

  var n = {
    vertical: {},
    horizontal: {}
  },
      o = window.Waypoint;
  i.prototype.add = function (t) {
    this.waypoints.push(t);
  }, i.prototype.clearTriggerQueues = function () {
    this.triggerQueues = {
      up: [],
      down: [],
      left: [],
      right: []
    };
  }, i.prototype.flushTriggers = function () {
    for (var i in this.triggerQueues) {
      var n = this.triggerQueues[i],
          o = "up" === i || "left" === i;
      n.sort(o ? e : t);

      for (var r = 0, s = n.length; s > r; r += 1) {
        var l = n[r];
        (l.options.continuous || r === n.length - 1) && l.trigger([i]);
      }
    }

    this.clearTriggerQueues();
  }, i.prototype.next = function (e) {
    this.waypoints.sort(t);
    var i = o.Adapter.inArray(e, this.waypoints),
        n = i === this.waypoints.length - 1;
    return n ? null : this.waypoints[i + 1];
  }, i.prototype.previous = function (e) {
    this.waypoints.sort(t);
    var i = o.Adapter.inArray(e, this.waypoints);
    return i ? this.waypoints[i - 1] : null;
  }, i.prototype.queueTrigger = function (t, e) {
    this.triggerQueues[e].push(t);
  }, i.prototype.remove = function (t) {
    var e = o.Adapter.inArray(t, this.waypoints);
    e > -1 && this.waypoints.splice(e, 1);
  }, i.prototype.first = function () {
    return this.waypoints[0];
  }, i.prototype.last = function () {
    return this.waypoints[this.waypoints.length - 1];
  }, i.findOrCreate = function (t) {
    return n[t.axis][t.name] || new i(t);
  }, o.Group = i;
}(), function () {
  "use strict";

  function t(t) {
    return t === t.window;
  }

  function e(e) {
    return t(e) ? e : e.defaultView;
  }

  function i(t) {
    this.element = t, this.handlers = {};
  }

  var n = window.Waypoint;
  i.prototype.innerHeight = function () {
    var e = t(this.element);
    return e ? this.element.innerHeight : this.element.clientHeight;
  }, i.prototype.innerWidth = function () {
    var e = t(this.element);
    return e ? this.element.innerWidth : this.element.clientWidth;
  }, i.prototype.off = function (t, e) {
    function i(t, e, i) {
      for (var n = 0, o = e.length - 1; o > n; n++) {
        var r = e[n];
        i && i !== r || t.removeEventListener(r);
      }
    }

    var n = t.split("."),
        o = n[0],
        r = n[1],
        s = this.element;
    if (r && this.handlers[r] && o) i(s, this.handlers[r][o], e), this.handlers[r][o] = [];else if (o) for (var l in this.handlers) {
      i(s, this.handlers[l][o] || [], e), this.handlers[l][o] = [];
    } else if (r && this.handlers[r]) {
      for (var a in this.handlers[r]) {
        i(s, this.handlers[r][a], e);
      }

      this.handlers[r] = {};
    }
  }, i.prototype.offset = function () {
    if (!this.element.ownerDocument) return null;
    var t = this.element.ownerDocument.documentElement,
        i = e(this.element.ownerDocument),
        n = {
      top: 0,
      left: 0
    };
    return this.element.getBoundingClientRect && (n = this.element.getBoundingClientRect()), {
      top: n.top + i.pageYOffset - t.clientTop,
      left: n.left + i.pageXOffset - t.clientLeft
    };
  }, i.prototype.on = function (t, e) {
    var i = t.split("."),
        n = i[0],
        o = i[1] || "__default",
        r = this.handlers[o] = this.handlers[o] || {},
        s = r[n] = r[n] || [];
    s.push(e), this.element.addEventListener(n, e);
  }, i.prototype.outerHeight = function (e) {
    var i,
        n = this.innerHeight();
    return e && !t(this.element) && (i = window.getComputedStyle(this.element), n += parseInt(i.marginTop, 10), n += parseInt(i.marginBottom, 10)), n;
  }, i.prototype.outerWidth = function (e) {
    var i,
        n = this.innerWidth();
    return e && !t(this.element) && (i = window.getComputedStyle(this.element), n += parseInt(i.marginLeft, 10), n += parseInt(i.marginRight, 10)), n;
  }, i.prototype.scrollLeft = function () {
    var t = e(this.element);
    return t ? t.pageXOffset : this.element.scrollLeft;
  }, i.prototype.scrollTop = function () {
    var t = e(this.element);
    return t ? t.pageYOffset : this.element.scrollTop;
  }, i.extend = function () {
    function t(t, e) {
      if ("object" == _typeof(t) && "object" == _typeof(e)) for (var i in e) {
        e.hasOwnProperty(i) && (t[i] = e[i]);
      }
      return t;
    }

    for (var e = Array.prototype.slice.call(arguments), i = 1, n = e.length; n > i; i++) {
      t(e[0], e[i]);
    }

    return e[0];
  }, i.inArray = function (t, e, i) {
    return null == e ? -1 : e.indexOf(t, i);
  }, i.isEmptyObject = function (t) {
    for (var e in t) {
      return !1;
    }

    return !0;
  }, n.adapters.push({
    name: "noframework",
    Adapter: i
  }), n.Adapter = i;
}();
// helper functions for m9 digital
// selecting elements
// select a list of matching elements, context is optional
function $(selector, context) {
  return (context || document).querySelectorAll(selector);
} // select the first match only, context is optional


function $1(selector, context) {
  return (context || document).querySelector(selector);
} // has, add, remove Class


function hasClass(el, className) {
  return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
}

function addClass(el, className) {
  if (el.classList) el.classList.add(className);else if (!hasClass(el, className)) el.className += ' ' + className;
}

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('\\b' + className + '\\b', 'g'), '');
}

function toggleClass(el, className, callback) {
  el.classList.toggle(className);

  if (callback && callback.typeOf === 'function') {
    callback();
  }
} // debounced resize
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.


function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

;

function getElementPosition(el) {
  var tp = el.offsetTop;
  return tp;
} // get current screenSize


function currScreenSize() {
  var head = document.getElementsByTagName('head')[0];
  var computed;

  if (window.getComputedStyle) {
    computed = window.getComputedStyle(head, null);
  } else if (document.documentElement.currentStyle) {
    computed = head.currentStyle;
  }

  var size = computed.fontSize;
  size = parseInt(size, 10);
  var screenDef;

  if (size === 10) {
    // small screen
    screenDef = 'ss';
  } else if (size === 20) {
    // midi screen
    screenDef = 'ms';
  } else if (size === 30) {
    // large screen
    screenDef = 'ls';
  } else if (size === 40) {
    screenDef = 'xls';
  }

  return screenDef;
}

function partialLoader(container, partial) {
  return new Promise(function (resolve, reject) {
    var x;

    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject("Microsoft.XMLHTTP");
    }

    x.open("GET", partial, true);
    x.send();

    x.onreadystatechange = function () {
      if (x.readyState === 4) {
        if (x.status === 200) {
          container.innerHTML = x.responseText;
          resolve('Success');
        } else {
          container.innerHTML = "Error loading document";
          reject('Error');
        }
      }
    };
  });
} // detect the dreaded crappo versions of IE


function detectOldIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  } // other browser


  return false;
}
// /*!
//   * domready (c) Dustin Diaz 2014 - License MIT
//   */
// !function (name, definition) {
//
//     if (typeof module != 'undefined') module.exports = definition()
//     else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
//     else this[name] = definition()
//
// }('domready', function () {
//
//     var fns = [], listener
//         , doc = document
//         , hack = doc.documentElement.doScroll
//         , domContentLoaded = 'DOMContentLoaded'
//         , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
//
//
//     if (!loaded)
//         doc.addEventListener(domContentLoaded, listener = function () {
//             doc.removeEventListener(domContentLoaded, listener)
//             loaded = 1
//             while (listener = fns.shift()) listener()
//         })
//
//     return function (fn) {
//         loaded ? setTimeout(fn, 0) : fns.push(fn)
//     }
//
// });
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var CHOUSE = {};
CHOUSE.start = {
  // config object - if required
  'config': {},
  init: function init(settings) {
    // loop through any settings passed in, and overwrite the default config with those settings
    if (settings && _typeof(settings) === 'object') {
      for (var prop in settings) {
        if (settings.hasOwnProperty(prop)) {
          this.config[prop] = settings[prop];
        }
      }
    }

    this.toggleNavigation();
    this.setUpSlider();
    this.setUpHomeCarousel();
    this.datePickerSetup();
    this.setUpPageImageGalleries();
    this.setUpConcertinas();
    this.formValidation(); //this.homeFormFocus();
  },
  toggleNavigation: function toggleNavigation() {
    var navTrigger = $1('.ch-mobile-nav-btn');
    var body = $1('body');
    var bodyOverlay = $1('.ch-site-container-active-overlay');
    navTrigger.addEventListener('click', function (event) {
      toggleClass(event.currentTarget, 'is-active');
      toggleClass(body, 'nav-is-open');
    });
    window.addEventListener('resize', function () {
      removeClass(body, 'nav-is-open');
      removeClass(navTrigger, 'is-active');
    });
    bodyOverlay.addEventListener('click', function () {
      removeClass(body, 'nav-is-open');
      removeClass(navTrigger, 'is-active');
    });
  },
  setUpSlider: function setUpSlider() {
    var homeSlider = $1('.hero-glide');

    if (homeSlider) {
      var glide = new Glide(homeSlider, {
        type: 'carousel',
        perView: 1,
        gap: 0,
        perTouch: 1,
        //autoplay: 10000,
        breakpoints: {
          768: {
            peek: {
              before: 0,
              after: 0
            }
          },
          1500: {
            peek: {
              before: 0,
              after: 0
            }
          },
          2200: {
            peek: {
              before: 150,
              after: 150
            }
          },
          3500: {
            peek: {
              before: 250,
              after: 250
            }
          }
        }
      });
      glide.mount();
    }
  },
  setUpHomeCarousel: function setUpHomeCarousel() {
    var homeCarousel = $1('.ch-home-carousel');

    if (homeCarousel) {
      var homeCarouselGlide = new Glide(homeCarousel, {
        gap: 0,
        perView: 8,
        peek: {
          before: 50,
          after: 50
        },
        type: 'carousel',
        breakpoints: {
          500: {
            perView: 2,
            peek: {
              before: 25,
              after: 25
            }
          },
          768: {
            perView: 4,
            peek: {
              before: 25,
              after: 25
            }
          },
          1920: {
            perView: 6,
            peek: {
              before: 50,
              after: 50
            }
          }
        }
      });
      homeCarouselGlide.mount();
      this.homeLightboxSetup();
    }
  },
  homeLightboxSetup: function homeLightboxSetup() {
    var homeLightGallery = $1('.ch-home-carousel-lightbox'); // create instance of ModuloBox

    var mobx = new ModuloBox({
      // options
      mediaSelector: '.ch-lightbox-element',
      scrollToZoom: true,
      controls: ['play', 'fullScreen', 'close']
    }); // initialize the instance

    mobx.init();
  },
  datePickerSetup: function datePickerSetup() {
    var datepickers = $('.ch-form-datepicker');

    if (datepickers && datepickers.length > 0) {
      var startPicker = $1('.ch-eform-book-start');
      var endPicker = $1('.ch-eform-book-end');
      var ONE_DAY = 1000 * 60 * 60 * 24;
      var displayedDateDiff = $1('.ch-eform-date-diff-val');
      var displayedDateVal = $1('.ch-eform-number-nights');

      var calcDateDiff = function calcDateDiff() {
        var bookingStartDate = new Date(sp.selectedDates[0]);
        var bookingEndDate = ep.selectedDates[0]; //console.log(bookingStartDate);
        //console.log('end date = ' + bookingEndDate);

        var timeDiff = Math.abs(bookingStartDate.getTime() - bookingEndDate.getTime());
        var dayDiff = Math.round(timeDiff / ONE_DAY);
        displayedDateDiff.innerText = dayDiff;
        displayedDateVal.value = dayDiff;
      };

      var ep = flatpickr(endPicker, {
        dateFormat: 'd.m.Y',
        minDate: new Date().fp_incr(1),
        defaultDate: new Date().fp_incr(2),
        disableMobile: true,
        onChange: function onChange() {
          setTimeout(calcDateDiff, 500);
        }
      });
      var sp = flatpickr(startPicker, {
        dateFormat: 'd.m.Y',
        minDate: "today",
        defaultDate: new Date().fp_incr(1),
        disableMobile: true,
        onChange: function onChange(selectedDates, dateStr, instance) {
          var newMinDate = instance.parseDate(dateStr);
          newMinDate.setDate(newMinDate.getDate() + 1);
          ep.set('minDate', newMinDate);
          ep.setDate(newMinDate);
        }
      });
    }
  },
  scrollToHomeForm: function scrollToHomeForm() {
    var homeFormButtons = $('.ch-glide-cta button');
    var enquiryForm = $1('.ch-home-form');
    homeFormButtons.forEach(function ($el) {
      $el.addEventListener('click', function () {
        scrollToEnquiryForm();
      });
    });

    function scrollToEnquiryForm() {
      var bodyRect = document.body.getBoundingClientRect();
      var formRect = enquiryForm.getBoundingClientRect();
      var offset = formRect.top - bodyRect.top; // scroll it!

      animateScrollTo(offset, 2100, 'easeInOutCirc');
    }
  },
  homeFormFocus: function homeFormFocus() {
    var enquiryForm = $1('.ch-home-form');

    if (enquiryForm) {
      var fadeInEnquiryForm = function fadeInEnquiryForm() {
        addClass(enquiryForm, 'is-in-view');
      };

      var waypoint = new Waypoint({
        element: enquiryForm,
        handler: function handler(direction) {
          setTimeout(fadeInEnquiryForm, 600);
        },
        offset: '150'
      });
    }
  },
  setUpPageImageGalleries: function setUpPageImageGalleries() {
    var imageGallery = $1('.ch-image-gallery');

    if (imageGallery) {
      var pageMobx = new ModuloBox({
        // options
        mediaSelector: '.ch-lightbox-element',
        scrollToZoom: true,
        controls: ['play', 'fullScreen', 'close']
      });
      pageMobx.init();
    }
  },
  setUpConcertinas: function setUpConcertinas() {
    var concertinas = $('.ch-concertina-wrapper');

    if (concertinas) {
      var _loop = function _loop(i) {
        var currentConc = concertinas[i];
        var conc = new BadgerAccordion(currentConc, {
          headerClass: '.ch-concertina-trigger',
          panelClass: '.ch-concertina',
          panelInnerClass: '.ch-concertina-inner'
        }, 200);
        var resizeFunc = debounce(function () {
          conc.calculateAllPanelsHeight();
        });
        window.addEventListener('resize', resizeFunc);
      };

      for (var i = 0; i < concertinas.length; i++) {
        _loop(i);
      }
    }
  },
  formValidation: function formValidation() {
    var formFeedbackWrap = $1('.ch-form-feedback');
    var form = $1('.ch-enquiry-form');

    if (form) {
      new JustValidate('.ch-enquiry-form', {
        rules: {
          cmrName: {
            required: true
          },
          cmrEmail: {
            required: true,
            email: true
          },
          cmrTel: {
            required: true
          }
        },
        messages: {
          cmrName: 'Please Enter Your Name',
          cmrEmail: 'An Email Address Is Required',
          cmrTel: 'Please Add Your Phone Number '
        },
        submitHandler: function submitHandler(form, values, ajax) {
          ajax({
            url: 'partials/_form-handler.php',
            method: 'POST',
            data: values,
            async: true,
            callback: function callback(response) {
              formFeedbackWrap.innerHTML = response;
              form.reset();
            },
            error: function error() {
              formFeedbackWrap.innerHTML = ' There was a problem with your submission, please try again';
            }
          });
        }
      });
    }
  }
};
window.addEventListener('DOMContentLoaded', function () {
  // dom is loaded!
  // custom cider house script
  CHOUSE.start.init();
});